export const DeTranslation = {
  lang: 'de',
  data: {
    CULTURE: {
      TITLE_MODAL: 'Sprache auswählen',
      ITALIAN: 'Italienisch',
      ENGLISH: 'Englisch',
      FRENCH: 'Französisch',
      SPANISH: 'Spanisch',
      GERMAN: 'Deutsch',
    },
    PRODUCTS_LIST: {
      ACTIONS: 'Aktionen für alle Produkte',
      HANDLE_IMAGES: 'Bilder verwalten'
    },
    PRICE_LIST_DETAIL: {
      INFORMATION: 'Informationen',
      NAME: 'Name',
      ASSOCIATED_CUSTOMERS_COUNT: 'Zugeordnete Kunden',
      TYPE: 'Typ',
      PRICE_LIST_TYPE: 'Preislistentyp',
      CUSTOM_PRICE_LIST: 'Individuelle Preisliste',
      DEFAULT_PRICE_LIST: 'Standardpreisliste',
      STORE: 'Geschäft',
      INCLUDED_VARIANTS: 'Enthaltene Varianten',
      EXCLUDED_VARIANTS: 'Ausgeschlossene Varianten',
      PRODUCT_LIST: 'Produktliste',
      VARIANTS: 'Varianten',
      BACK_TO_PRICE_LISTS: 'Zurück zu den Preislisten',
      PARENT_PRICE_LIST: 'Referenzpreisliste',
    },
    MENU: {
      UTILITIES: {
        UTILITIES: 'Werkzeuge',
        BULK_OPERATIONS: 'Bulk operations',
      },
      DASHBOARD: 'Dashboard',
      ORDERS: 'Bestellungen',
      CARTS: 'Warenkörbe',
      PROMOTIONS: 'Aktionen',
      CUSTOMIZATION_REQUESTS: 'Personalisierungsanfragen',
      AUTOMATIC_DISCOUNTS: 'Automatische rabatte',
      CUSTOMER_DISCOUNTS: 'Kundenrabatt',
      STORECHANNEL_DISCOUNT: 'Unschlagbare rabatte',
      GOK_MODE: 'Gok',
      DIRECT_MODE: 'Direktbestellung',
      VOUCHERS: 'Gutscheine',
      COMMERCIAL_AGREEMENTS: 'Handelsvereinbarungen',
      CUSTOMERS_DISCOUNTS: 'Kundenrabatte',
      AGENTS: 'Vertreter',
      AGENCY_INFO: 'Agenturinformationen',
      CUSTOMER_INFO: 'Kundeninformationen',
      COMMERCIAL_INFO: 'Handelsinformationen',
      FINANCIAL_INFO: 'Finanzinformationen',
      USERS: 'Benutzer',
      GENERAL_FIELDS: 'Allgemeine Felder',
      SHIPPING_ADDRESS: 'Lieferadresse',
      CATEGORIES: 'Kundenklassifizierungsgruppe',
      PAYMENT_TERMS: 'Zahlungsbedingungen',
      COMPANY_FORMS: 'Unternehmensformen',
      DOWNLOADS: {
        DOWNLOADS: 'Downloads',
        REPORTS: 'Reports'
      },
      PRODUCTS: {
        NAME: 'Produkte',
        PRODUCTS_LIST: 'Produktliste',
        INVENTORY_VISIBILITY: 'Inventar sichtbarkeit',
        ASSORTMENTS: 'Sortimente',
        IMPORT_PRODUCTS: 'Produkte importieren',
        BULK_EDITOR: 'Masseneditor',
        VARIANT_BULK_EDITOR: 'Varianteneditor',
      },
      SETTINGS: {
        NAME: 'Einstellungen',
        STORE_SETTINGS: 'Shop einstellungen',
        PRICE_LIST: 'Preisliste',
        TIERS: 'Stufen',
        SALES_CAMPAIGNS: 'Verkaufsaktionen',
        TERMS_OF_SALE: 'Verkaufsbedingungen',
        SEASON_REFERENCE: 'Saisonreferenz',
        PACKAGE_GROUP: 'Paketgruppe',
        TRANSPORT_AGENCY: 'Transportunternehmen',
        ORDER_LABEL: 'Order label (optional)',
        DEFAULT: 'Standard',
        EMAIL_SETTINGS: 'E-mail einstellungen',
        EMAIL_FOR_CHANNEL: 'E-mail pro vertriebskanal',
        OVERRIDE_EMAIL_INFO: 'Unten kannst du unterschiedliche e-mail adressen für jeden vertriebskanal angeben. Wenn keine e-mail für einen kanal angegeben ist, wird die standard e-mail verwendet.',
        SHIPPING_COST_SETTINGS: 'Versandkosteneinstellungen',
        FREE_SHIPPING_THRESHOLD: 'Grenzwert für kostenlosen versand',
        SHIPPING_COST: 'Versandkosten',
        NUMBER_OF_DAYS_TO_CALCULATE_THE_RE_ORDER_DATE: 'Anzahl der tage zur berechnung des nachbestelldatums',
        DEFAULT_LIMIT_FOR_STYLE_COLOR_OF_MONOBRAND_STORES: 'Standard-kauflimit für style-color (für vertriebskanäle, die es erfordern)',
        MINIMUM_VALUE_FOR_THE_TOTAL_ORDER_AMOUNT: 'Mindestbestellwert für die erstellung einer bestellung (für vertriebskanäle, die es erfordern)',
        FREE_SHIPPING_ORDER_TOTAL_THRESHOLD: 'Mindestbestellwert für kostenlosen versand (für vertriebskanäle, die es erfordern)',
        GENERAL: 'Allgemein',
        STORE_NAME: 'Name',
        DISCOUNT: 'Rabatt',
        CURRENCY: 'Währung',
        SALES_SETTINGS: 'Verkaufseinstellungen',
        PRE_ORDER_ACTIVE_FROM: 'Pre-order aktiv ab',
        PRE_ORDER_ACTIVE_TO: 'Pre-order aktiv bis',
        RE_ORDER_ACTIVE_FROM: 'Nachbestellung aktiv ab',
        RE_ORDER_ACTIVE_TO: 'Nachbestellung aktiv bis',
        MAX_CUSTOM_DATES: 'Benutzerdefiniertes lieferdatum möglich bis',

        BACKGROUND_IMAGE: 'Hintergrundbild',
        LOGO_IMAGE: 'Logo-bild',
        FAVICON_IMAGE: 'Favicon',
        ADD: 'Hinzufügen',
        CHANGE: 'Ändern',
        SMALL_LOGO: 'Kleines logo',

        UPLOAD_MEDIA: 'Medien hochladen',
        UPLOAD_EXCEL: 'Excel hochladen',
        UPLOAD_FILE: 'Datei hochladen',
        SAVE: 'Speichern',
        AVILABLE_FILE_SIZE: 'Maximale dateigröße',

        PRIMARY_COLOR: 'Primärfarbe',
        MAIL_NOTIFICATIONS: 'E-mail für shop-benachrichtigungen',
        MAIL_SENDER: 'E-mail-absender des shops',
        FOOTER_TEXT: 'Fußzeilentext',
        CART_NAME_MAX_LENGTH: 'Maximale länge des warenkorbnamens',
        CART_NOTIFICATION_SETTINGS: 'Inaktive warenkorb-benachrichtigungseinstellungen',
        CART_NOTIFICATION_THRESHOLD: 'Warenkorb-benachrichtigungslöschschwellenwert in tagen',
        CART_NOTIFICATION_DELETION_THRESHOLD: 'Inaktive warenkorb-löschschwellenwert in tagen',
        DEFAULT_DESIGNER: 'Standard-designer',
        KUSTOM_EMAIL: 'Kustom e-mail',
        KUSTOM_PHONE: 'Kustom telefon',
        KUSTOM_EMAIL_SECONDARY: 'Kustom e-mail sekundär',
        KUSTOM_SETTINGS: 'BasicKustom-einstellungen',
        KUSTOM_MIN_QUANTYTY_FOR_PRODUCT: 'Mindestbestellmenge für personalisierte produkte in anfragen',
        ENABLE_KUSTOM: 'BasicKustom aktiviert',
        DISABLE_KUSTOM: 'BasicKustom deaktiviert',
        PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Bitte fülle alle pflichtfelder aus',
      },

      AGENCIES: 'Agenturen',
      CUSTOMERS: 'Kunden',
      //USERS: 'Benutzer',
      LOCATIONS: 'Adressen',
      TUTORIAL: {
        NAME: 'Tutorial',
        VIDEO: 'Video',
      },
    },
    IMPORT_PRODUCTS: {
      START_SEARCH: 'Suchtext eingeben, um den Import zu starten',
      DESELECT_ALL: 'Alle abwählen',
      RELOAD_PRODUCTS: 'Produkte neu laden',
      ID: 'ID',
      NAME: 'Name',
      SELLING_PERIOD: 'Verkaufszeitraum',
      PRODUCTS_QUANTITY: 'Produktanzahl',
      LOAD_MORE_DATA: 'Weitere daten laden',
      THERE_IS_NO_MORE_DATA: 'Keine weiteren daten verfügbar',
      STATUS: {
        IMPORTED: 'Importiert',
        NOT_IMPORTED: 'Nicht importiert',
        IMPORTING: 'Wird importiert...',
        FAILED: 'Fehlgeschlagen'
      },
      MODAL: {
        TITLE: 'Produkte importieren',
        YOU_HAVE_SELECTED: 'Du hast ausgewählt',
        ITEMS: 'Elemente',
        ATTENTTION_YOU_ARE_IMPORTING: 'Achtung, du importierst',
        MESSAGE: 'Stile, die bereits importiert wurden. Alle Änderungen an diesen und deren varianten gehen verloren. Bist du sicher?',
        YOU_HAVE_TO_SELECT_AT_LAST_ONE_ITEM: 'Du musst mindestens ein element auswählen',
        USE_CUSTOM_DISCOUNT: 'Benutzerdefinierten rabatt zur berechnung des großhandelspreises festlegen',
        USE_CUSTOM_DISCOUNT_INFO: 'Wenn du einen benutzerdefinierten rabatt festlegst, wird dieser zur berechnung des Großhandelspreises aller varianten der zu importierenden produkte verwendet – sowohl für PRE Order als auch RE Order. Wenn kein rabatt festgelegt wird, wird der zuletzt verwendete prozentsatz für bereits importierte produkte verwendet und der standardrabatt des aktuellen shops für produkte, die noch nie importiert wurden.'
      }
    },
    USERMENU: {
      SHOP: 'Shop',
      MY_PROFILE: 'Profil',
      LOGOUT: 'Abmelden',
      SWITCH_TENANT: 'Land wechseln',
      LOGOUT_CONFIRM: 'Möchten sie sich wirklich abmelden?',
      CANCEL: 'Abbrechen',
    },
    BACK_TO: {
      SALES_CAMPAIGN: 'Zurück zur verkaufskampagne',
      SALES_CAMPAIGNS: 'Zurück zu den verkaufskampagnen',
    },
    GENERIC_LABEL: {
      SELECT: 'Auswählen',
      SELECT_SIZE: 'Größe auswählen',
      APPROVE: 'Genehmigen',
      COPY: 'Kopieren',
      SALE_CAMPAIGN: 'Verkaufskampagnen',
      CHOOSE_FILE: 'Datei auswählen',
      BACK: 'Zurück',
      SYNC_START: 'Synchronisierung gestartet, bitte einige minuten warten und seite aktualisieren',
      ADD_NEW: 'Neu hinzufügen',
      ADD: 'Hinzufügen',
      SAVE: 'Speichern',
      SAVE_CHANGES: 'Änderungen speichern',
      DELETE: 'Löschen',
      CANCEL: 'Abbrechen',
      CLOSE: 'Schließen',
      TRANSFORM_INTO_DRAFT: 'Zurück in den Warenkorb umwandeln',
      LEAVE_PAGE: 'Seite verlassen',
      ACTIONS: 'Aktionen',
      UPLOAD: 'Hochladen',
      IMPORT: 'Importieren',
      DUPLICATE: 'Duplizieren',
      CONFIRM: 'Bestätigen',
      SEND_CONFIRMATION_MAIL: 'Bestätigungsmail erneut senden',
      EDIT: 'Bearbeiten',
      EDIT_ITEMS: 'Artikel bearbeiten',
      EDIT_CART: 'Warenkorb bearbeiten',
      ACTIVATE: 'Aktivieren',
      SEND: 'Senden',
      RESEND: 'Erneut senden',
      DEACTIVATE: 'Deaktivieren',
      FORM_ERROR: 'Fehlende oder fehlerhafte daten',
      YES: 'Ja',
      NO: 'Nein',
      PRINT: 'Drucken',
      PRINT_PREVIEW: 'Druckvorschau',
      ERROR: 'Fehler!',
      ARE_YOU_SURE: 'Sind sie sicher?',
      ARE_YOU_SURE_YOU_WANT_TO_PROCEED: 'Sind sie sicher, dass sie fortfahren möchten?',
      DONE: 'Fertig!',
      REMOVE: 'Entfernen',
      BLOCKED: 'Blockiert',
      UNBLOCKED: 'Nicht blockiert',
      USER: 'Benutzer',
      ACTIVATED: 'Aktiviert',
      DEACTIVATED: 'Deaktiviert',
      MAN: 'Mann',
      WOMAN: 'Frau',
      UNISEX: 'Unisex',
      UNPUBLISH: 'Veröffentlichung aufheben',
      CREATE: 'Erstellen',
      LOSING_CHANGES_MESSAGE: 'Nicht gespeicherte Änderungen gehen verloren. Möchten sie fortfahren?',
      SETTINGS: 'Einstellungen',
      DETAILS: 'Details',
      START_SYNC: 'Synchronisierung vom ERP starten',
      THE_VALUE_MUST_BE_BETWEEN: 'Der wert muss zwischen {{min}} und {{max}} liegen',
      MAX_LENGTH: 'Maximale länge {{max}} zeichen, eingegebene zeichen {{length}}',
      ATTENTION: 'Achtung!',
      PREVIEW: 'Vorschau',
      DOWNLOAD: '{{extension}} herunterladen',
      APPLY: 'Anwenden',
      NEXT: 'Weiter',
      SELECT_CODE: 'Code auswählen',
      DOWNLOAD_REPORT: 'Bericht herunterladen',
      EXPORT_ORDERS: 'Bestellungen exportieren',
      ONLY_WITH_STOCK_PRODUCTS: 'Nur verfügbare produkte',
      PRODUCT_TYPE: 'Produkttyp',
      REPORTS_MODAL_MESSAGE: 'Stelle die gewünschten filter ein und du erhältst den bericht in deinem e-mail-postfach.',
      STORE_VARIANTS_REPORT: 'Produktvariantenbericht',
      CUSTOMER_REPORT: 'Kundenbericht',
      FROM_DATE: 'Von',
      TO_DATE: 'Bis',
      SALES_CAMPAIGN: 'Verkaufskampagne',
      SELECTED_ORDERS: 'Bestellungen ausgewählt',
      NO_ORDERS_SELECTED: 'Keine Bestellungen ausgewählt',
      SELECTED: 'Ausgewählt',
      EDIT_SELECTED_ORDERS: 'Ausgewählte bestellungen bearbeiten',
      DELETE_ORDERS: 'Bestellungen löschen',
      CANCEL_ORDERS: 'Bestellungen stornieren',
      DELETE_ORDERS_BY_EXCEL: 'Bestellungen löschen',
      SUCCESS_DELETE_ORDERS: 'Bestellungen gelöscht',
      UPLOAD_ORDERS_TEMPLATE: 'Lade die artikel deiner bestellungen mit der vorlage hoch',
      DOWNLOAD_TEMPLATE: 'Vorlage herunterladen',
      ERROR_NEGATIVE_NUMBERS: 'Es ist nicht möglich, negative Zahlen oder dezimalzahlen einzugeben',
      INVALID_QUANTITY: 'Ungültige menge',
      NAME: 'Name',
      CART_QTY: 'artikel im warenkorb',
      BULK_SELECTION: 'Sammelauswahl',
      WORKING_MODE: "Arbeitsmodus auswählen",
      SELECT_FILTERS: "Nach Filtern auswählen",
      SELECT_FREE_TEXT: "Nach external Bestell-IDs auswählen",
      ENTER_ORDER_IDS: "Bestell-IDs eingeben",
      ENTER_ORDER_IDS_PLACEHOLDER: "Geben Sie eine oder mehrere external Bestell-IDs ein oder fügen Sie sie ein, getrennt durch Semikolon",
      OTHERS: "Andere"
    },
    MANAGE_GENERAL_FIELDS: {
      FIELDS_TYPE: 'Feldtyp',
      VALUE_SET: 'Wertesatz',
      TABLE: {
        VALUE: 'Wert',
        DECIMAL_VALUE: 'Dezimalwert',
        CREATION_TIME: 'Erstellungsdatum',
        LAST_UPDATE: 'Letzte Aktualisierung',
        DELETE_GF: 'Allgemeines Feld löschen',
        ARE_YOU_SURE: 'Sind Sie sicher, dass Sie dieses allgemeine Feld löschen möchten?',
        EDIT_GF: 'Allgemeines Feld bearbeiten',
        CREATE_GF: 'Neues allgemeines Feld erstellen',
        CODE: 'Code',
        DESCRIPTION: 'Beschreibung',
        ID: 'ID',
        EXTERNAL_ID: 'External ID',
        NAME: 'Name',
        ORDER: 'Reihenfolge',
      },
    },
    TABLE: {
      ACTION: {
        NAME: 'Aktionen',
        EDIT: 'Bearbeiten',
        DELETE: 'Löschen',
        CREATE_NEW: 'Neu erstellen',
        EXPORT: 'Exportieren',
        IMPORT: 'Importieren',
        INVITE_USER: 'Benutzer einladen',
        DUPLICATE: 'Duplizieren',
        VIEW_DETAILS: 'Details anzeigen',
        ACTIVATE: 'Aktivieren',
        DEACTIVATE: 'Deaktivieren',
        REFRESH: 'Aktualisieren',
        ARCHIVE: 'Archivieren',
        UPLOAD: 'Datei hochladen',
        DOWNLOAD: 'Datei herunterladen',
        DOWNLOAD_LIST: 'Liste herunterladen',
        CREATE_CART_FROM_EXCEL: 'Kassen aus Excel erstellen',
      },
      FILTERS: {
        FILTERS: 'Filter',
        CREATOR: 'Ersteller',
        REQUESTER: 'Anforderer',
        CUSTOMER_REQUESTER: 'Kundenanforderer',
        AGENCY_REQUESTER: 'Agenturanforderer',
        DESIGNER: 'Designer',
        APPROVED_BY: 'Genehmigt von',
        APPLY_FILTER: 'Filter anwenden',
        ACTIVE_FILTERS: 'Aktive Filter',
        SEARCH: 'Suchen',
        VISIBILITY_TYPE: 'Typ',
        TYPE: 'Typ',
        VALIDITY: 'Gültigkeit',
        REORDER: 'Nachbestellung',
        PREORDER: 'Vorbestellung',
        PRE_ORDER: 'Pre-order',
        RE_ORDER: 'Re-order',
        WHOLESALE_PRICE: 'Großhandelspreis',
        NEW_WHOLESALE_PRICE: 'Neuer Großhandelspreis',
        FROM: 'Von',
        TO: 'Bis',
        RETAIL_PRICE: 'Einzelhandelspreis',
        STOCK: 'Lager',
        ASSORTMENT: 'Sortiment',
        STYLE_GROUP: 'Stilgruppe',
        CITY: 'Stadt',
        TIER: 'Stufe',
        STORE: 'Geschäft',
        CUSTOMER: 'Kunde',
        CUSTOMER_TYPE: 'Kundentyp',
        AGENCY: 'Agentur',
        ONLINE_STORES: 'Online-Shops',
        WITHOUT_STORE: 'Ohne Geschäft',
        POINT_OF_SALE: 'Verkaufsstelle',
        ORDER_STATUS: 'Bestellstatus',
        STATUS: 'Status',
        LOCATION_TYPE: 'Adressart',
        REGISTERED_DATE: 'Registrierungsdatum',
        ROLE: 'Rolle',
        ONLY_INCLUDED: 'Nur einbezogen',
        COLORS: 'Farben',
        SIZE: 'Größe',
        SIZE_GROUP: 'Größengruppe',
        NOTES: 'Notizen',
        HAS_NOTES: 'Mit Notizen',
        EXTERNAL_COLLECTIONS: 'Externe kollektionen',
        EXTERNAL_ORDER_ID: 'Externe bestellnummer',
        CHANNEL: 'Kanal',
        PRODUCTS: 'Produkte',
        OPERATION_TYPE: 'Operationstyp',
        CUSTOMER_AMMINISTRATIVE_STATUS: 'Administrativer sperrstatus',
        SHOW_ONLY_BLOCKED: 'Nur gesperrte kunden anzeigen',
        SHOW_ONLY_WITH_CR: 'Bestellungen mit zugehörigen Personalisierungsanfragen anzeigen',
        CHANNEL_ID: 'Kanal-ID',
        CREATED_AFTER: 'Erstellt nach dem',
        CREATED_BEFORE: 'Erstellt vor dem',
        SELECT_ORDERS: 'Bestellungen auswählen',
        MANAGEMENT_ORDERS: 'Bestellungen verwalten',
        COMERCIAL_BLOCK: 'Kommerzieller Block',
        COMPLETED_AT: 'Abgeschlossen am',
        SHOW_CR_WITH_DESIGNER_NOTIFICATION: 'Nur Personalisierungsanfragen mit Benachrichtigung des Anforderers anzeigen',
        ORDER_BULK_OPERATION_SCOPE: 'Geltungsbereich',
        ORDER: 'Bestellung',
      },

      CUSTOMIZATION_REQUEST: {
        TITLE: 'Anpassungsanfragen',
        COLUMN: {
          NAME: 'Name',
          STATUS: 'Status',
          CUSTOMER: 'Kunde',
          CHANNEL: 'Kanal',
          POINT_OF_SALE: 'Verkaufsstelle',
          TOTAL_WHOLESALE: 'Ges. großhandel',
          PRODUCT_NUMBER: 'Letzte Aktualisierung',
          LAST_UPDATE: 'Ultimo aggiornamento',
          WITH_REQUESTER_NOTIFICATION: 'Mit Benachrichtigung des Anforderers',
          LAST_UPDATE_REQUESTER: 'Letzte Aktualisierung des Anforderers',
        },
      },

      PRICE_LIST: {
        DEFAULT_PRICE_LIST: 'Standardpreisliste',
        CUSTOM_PRICE_LIST: 'Individuelle Preislisten',
        CREATE_PRICE_LIST: 'Preisliste erstellen',
        NAME: 'Name',
        PARENT_PRICE_LIST: 'Übergeordnete Preisliste',
        TYPE: 'Typ',
        STORE: 'Geschäft',
        ASSOCIATED_CUSTOMERS: 'Wählen Sie aus, ob Sie mit der Zuordnung von Kunden zu dieser Preisliste fortfahren möchten',
      },

      PRICE_LIST_DETAIL: {
        COLUMNS: {
          SKU: 'SKU',
          PALETTE: 'Palette',
          TYPE: 'Typ',
          PRE_ORDER: 'Pre-order',
          RE_ORDER: 'Re-order',
          CURRENCY: 'Währung',
          DEFAULTRETAILPRICE: 'Standard-Einzelhandelspreis',
          DEFAULTWHOLESALEPRICE: 'Standard-Großhandelspreis',
          CUSTOMRETAILPRICE: 'Individueller Einzelhandelspreis',
          CUSTOMWHOLESALEPRICE: 'Individueller Großhandelspreis',
        },
      },

      SUPER_BULK: {
        COLUMN: {
          ID: 'ID',
          USER: 'Benutzer',
          OPERATION_TYPE: 'Operationstyp',
          CREATION_TIME: 'Erstellungsdatum',
          START_AT: 'Beginn am',
          CONCLUDED_AT: 'Abgeschlossen am',
          STATUS: 'Status',
        },
        OPERATION_TYPE: {
          UPDATING_VISIBILITY_PRE: 'Sichtbarkeit für Vorbestellung aktualisieren',
          UPDATING_VISIBILITY_RE: 'Sichtbarkeit für Nachbestellung aktualisieren',
          UPDATING_PRICE: 'Preis aktualisieren',
          UPDATING_BLANK_CELL: 'Leere zellen aktualisieren',
          ASSOCIATING_TIER: 'Stufe zuordnen',
          DISASSOCIATING_TIER: 'Stufe entfernen',
          ASSOCIATING_ASSORTMENT: 'Zuordnung von Sortiment',
          DISASSOCIATING_ASSORTMENT: 'Aufhebung der Zuordnung von Sortiment',
          ASSOCIATING_PROMOTION: 'Aktion zuordnen',
          DISASSOCIATING_PROMOTION: 'Aktion entfernen',
          UPDATE_PALETTES_STOCK_LIMITS: 'Kauflimits nach Farbe aktualisieren (für unterstützte Kanäle)',
        }
      },

      BULK_OPERATIONS: {
        NAME: 'Operationen',
        COLUMNS: {
          ID: 'Id',
          TYPE: 'Typ',
          CREATOR: 'Ersteller',
          CREATED_AT: 'Erstellungsdatum',
          SCOPE: 'Geltungsbereich',
          STATUS: 'Status',
          ISSUE: 'Problem',
          ORDER_ITEM_ID: 'ID Artikel Bestellung',
          ORDER_ID: 'ID Bestellung',
          ORDER_NUMBER: 'Bestellnummer',
          CUSTOMER_NAME: 'Kundenname',
          CUSTOMER_ACCOUNT: 'Kundenaccount',
          STARTED_AT: 'Beginn am',
          CONCLUDED_AT: 'Abgeschlossen am',
          PROCESSED_ORDER_ITEMS_COUNT: 'Verarbeitete Artikel',
          PROCESSED_WITH_ISSUES_COUNT: 'Verarbeitete mit Problemen'
        },
      },

      BULK_EDIT_ORDERS_MODAL: {
        INFO_MESSAGE: 'Durch die Verwendung der Checkboxen kannst du mehrere Elemente gleichzeitig bearbeiten. Achtung: Beim Speichern werden alle Elemente in diesem Fenster gespeichert, unabhängig von der getroffenen Auswahl.',
        ADD_NEW_ITEMS: 'Neue artikel hinzufügen',
        REPLACE_ITEMS: 'Artikel ersetzen',
        REMOVE_ITEMS: 'Artikel entfernen',
        CURRENT_DATE: 'Aktuelles datum',
        NEW_DATE: 'Neues datum',
        CHANGE_ITEMS_DELIVERY_DATE: 'Artikellieferdatum ändern',
        SUCCESS_CHANGE_ITEMS_DELIVERY_DATE: 'Artikellieferdatum erfolgreich geändert',
        SUCCESS_ADD_ITEMS: 'Artikel hinzugefügt',
        SUCCESS_CHANGE_ITEMS_WHOLESALE_PRICE: 'Großhandelspreis erfolgreich geändert',
        INVALID_PRICE: 'Der eingegebene großhandelspreis ist nicht gültig',
        CHANGE_CUSTOMER_AND_SHIPPING_ADDRESS: 'Kunde und Lieferadresse ändern',
        EDIT_QUANTITY: 'Menge bearbeiten',
        WHOLESALE_PRICE: 'Großhandelspreis',
        EDIT_NET_PRICE: 'Nettopreis bearbeiten',
        EDIT_RETAIL_PRICE: 'Einzelhandelspreis bearbeiten',
        CURRENT_UNIT_PRICE: 'Aktueller stückpreis',
        NEW_UNIT_PRICE: 'Neuer preis pro Stueck',
        NEW_RETAIL_PRICE: 'Neuer Einzelhandelspreis',
        CURRENT_RETAIL_PRICE: 'Aktueller Einzelhandelspreis',
        RETAIL_PRICE: 'Einzelhandelspreis',
        SUCCESS_REPLACE_ITEMS: 'Artikel ersetzt',
        DISCOUNT: 'Rabatt',
        SUCCESS_CHANGE_ITEMS_QUANTITY: 'Mengen Artikel erfolgreich geändert',
        SUCCESS_DELETE_ITEMS: 'Artikel erfolgreich entfernt',
        SUCCESS_OPERATION: 'Operation inqueued successfully',
      },

      COMMERCIAL_AGREEMENT: {
        NAME: 'Handelsabkommen',
        COLUMNS: {
          ID: 'ID',
          NAME: 'Name',
          VALID_FROM: 'Gültig ab',
          VALID_UNTIL: 'Gültig bis',
          DISCOUNT_PERCENTAGE: '% rabatt',
          TOTAL_RETAIL_AMOUNT: 'Ges. einzelhandel (€)',
          RESIDUAL_RETAIL_AMOUNT: 'Restbetrag (€)',
          CUSTOMER_NAME: 'Kundenname',
          STATUS: 'Status',
          CONSUMPTION: 'Verbrauch',
        },
        MODAL_DELETE: {
          TITLE: 'Handelsabkommen löschen',
          MESSAGE: 'Möchten sie dieses handelsabkommen wirklich löschen?',
          ATTENTION_COMMERCIAL_AGREEMENT_IS_LINKED_ON_VARIOUS_CART: '<strong>Achtung!</strong> Es sind {{draftOrdersCount}} warenkörbe mit diesem handelsabkommen verknüpft. Durch das löschen dieses abkommens werden auch die verknüpfungen entfernt.',
        },
      },

      TERM_OF_SALE: {
        NAME: 'Verkaufsbedingungen',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Name',
          STATUS: 'Status',
          CREATION_TIME: 'Erstellungsdatum',
          LAST_UPDATE_TIME: 'Letzte aktualisierung',
        },
      },

      FULFILLMENT: {
        GROUP_ELEMENT: {
          SHIPPING_PACKAGE: 'Paket',
          TOTAL_QUANTITY: 'Gesamtmenge',
          TOTAL_WEIGHT: 'Gesamtgewicht',
        },
        COLUMNS: {
          STYLE: 'Stil',
          COLOR: 'Farbe',
          SIZE: 'Größe',
          QUANTITY: 'Menge',
          AMOUNT: 'Betrag',
          EAN: 'EAN',
          ORDER_ID: 'Bestellnummer',
        },
      },

      PROMOTION: {
        NAME: 'Aktionen',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Name',
          VALID_FROM: 'Gültig ab',
          VALID_TO: 'Gültig bis',
          TYPE: 'Typ',
          VALID_ON: 'Gültig für',
        },
        MODAL_DELETE_PROMOTION: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_PROMOTION: 'Bist du sicher, dass du die aktion löschen möchtest?',
        },
        INFO_ALLERT: 'Automatisch eingerichtete rabatte werden in den kanälen nicht aktiviert',
      },
      VOUCHERS: {
        NAME: 'Gutscheine',
        COLUMNS: {
          ID: 'Id',
          CODE: 'Code',
          DESCRIPTION: 'Beschreibung',
          CONSTRAINT_TYPE: 'Einschränkung',
          AMOUNT: 'Wert',
          THRESHOLD: 'Schwelle',
          VALID_FROM: 'Gültig ab',
          VALID_TO: 'Gültig bis',
          RESIDUAL_AMOUNT: 'Verbleibender betrag',
          STATUS: 'Status'
        },
        MODAL_DELETE_VOUCHER: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_VOUCHER: 'Bist du sicher, dass du den gutschein löschen möchtest?',
          ARE_YOU_SURE_DELETE_CUSTOMER: 'Bist du sicher, dass du den gutschein vom kunden trennen möchtest?',
        },
        INFO_ALLERT: 'Die eingerichteten gutscheine werden in den kanälen nicht aktiviert',
      },

      PRIVILEGES_CASH: {
        COLUMNS: {
          EXTERNAL_ID: 'ID',
          NAME: 'Name',
          INITIAL_AMOUNT_WITH_VAT: 'Anfangsbetrag mit MwSt.',
          RESIDUAL_AMOUNT_WITH_VAT: 'Restbetrag mit MwSt.',
          RESIDUAL_AMOUNT_WITHOUT_VAT: 'Restbetrag ohne MwSt.',
          VALID_FROM: 'Gültig ab',
          VALID_TO: 'Gültig bis',
          STATUS: 'Status',
        },
        STATUS: {
          IMPORTABLE: 'Importierbar',
          ALREADY_IMPORTED: 'Bereits importiert',
        },
      },

      DISCOUNT: {
        NAME: 'Rabatte',
      },

      CART: {
        NAME: 'Warenkorb',
        COLUMNS: {
          ID: 'ID',
          NAME: 'Name',
          VARIANTS: 'Varianten',
          POS: 'Verkaufsstelle',
          TOTAL: 'Gesamt',
          TOTAL_RETAIL: 'Gesamt einzelhandel',
          DATE: 'Datum',
          TYPE: 'Typ',
          AGENCY_CODE: 'Agentur',
          CHANNEL_NAME: 'Kanal',
          PCS: 'Stück',
          SEASON_REFERENCE: 'Saisonreferenz',
          PACKAGE_GROUP: 'Paketgruppe',
          NOTE: 'Notiz',
          EXTERNAL_ID: 'Externe ID',
        },
        ASTERISK_MESSAGE: 'Gesamtbeträge basieren auf einzelhandelspreisen, da sie den kanälen zugeordnet sind',
        MISSING_EXCEL_FILE_MESSAGE: 'Um fortzufahren, muss ein Excel-Datei hochgeladen werden',
        MISSING_EXCE_CODE_MESSAGE: 'Wählen Sie eine Codeart aus, um das Modell herunterzuladen',
        UPLOAD_DONE: 'Vorgang erfolgreich gestartet! Du erhältst eine E-Mail mit dem Ergebnis des Vorgangs.',
        MODAL_IMPORT: {
          IMPORT_CART_FROM_FILE_XLSX: 'Warenkorb aus XLSX-Datei importieren',
          CART_REPORT_UPLOADED: 'Warenkorbbericht hochgeladen',
          CUSTOMER: 'Kunde',
          POINT_OF_SALE: 'Verkaufsstelle',
          CART_NAME: 'Name des warenkorbs',
          TYPE: 'Typ',
          ALTERNATIVE_SHIPPING_ADDRESS: 'Alternative versandadresse',
          PRODUCT: 'Produkt',
          AGENCY: 'Agentur'
        },
        MODAL_DUPLICATE_CART: {
          DUPLICATE_CART: 'Warenkorb duplizieren',
          DUPLICATE: 'Duplizieren',
        },
        MODAL_DELETE_CART: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_CART: 'Bist du sicher, dass du den warenkorb löschen möchtest?',
        }
      },

      ADMIN_DOWNLOADS: {
        NAME: 'Verwaltungsdownloads',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Name',
          EXTENTION: 'Typ',
          UPLOAD_DATE: 'Upload-datum',
          CREATOR: 'Ersteller',
        },
        ACTION: {
          DOWNLOAD: 'Herunterladen',
          DELETE: 'Löschen',
          UPLOAD_FILE: 'Datei hochladen',
        },
        MODAL_DELETE_FILE: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_FILE: 'Bist du sicher, dass du die datei löschen möchtest?',
        },
      },

      ORDER: {
        NAME: 'Bestellungen',
        COLUMNS: {
          STATUS: 'Status',
          PENDING_BULK: 'Ausstehender Bulk',
          POINTS_OF_SALES: 'Verkaufspunkte',
          AGENCY_CODE: 'Agenturcode',
          CUSTOMER: 'Kunde',
          GOK: 'GOK',
          REASSORTMENT: 'Nachbestellung',
          PRODUCT_EXCHANGE: 'Warentausch'
        }
      },

      ASSORTMENTS: {
        NAME: 'Sortimente',
        COLUMNS: {
          ID: 'Id',
          TITLE: 'Titel',
          CHANNEL_NAME: 'Kanal',
          RE_ORDER: 'Nachbestellung',
          PRE_ORDER: 'Vorbestellung',
        }
      },

      VARIANT_BULK_EDITOR: {
        NAME: 'Varianten-editor',
        INCLUDE_BY: 'Auswählen für: ',
        INCLUDE_BY_ASSORTMENT: 'Sortiment',
        INCLUDE_BY_COLLECTION: 'Kollektion',
        INCLUDE_BY_TIER: 'Stufe',
        SELECTED: 'Ausgewählt',
        EDIT_SELECTED: 'Ausgewählte bearbeiten',
        DESELECT_ALL: 'Alle abwählen',
        YOU_HAVE_JUST_SELECTED: 'Du hast gerade ausgewählt',
        NEW_VARIANTS_FROM_ASSORTMENT: 'neue varianten aus dem sortiment',
        NEW_VARIANTS_FROM_COLLECTION: 'neue varianten aus der kollektion',
        NEW_VARIANTS_FROM_TIER: 'neue varianten aus der stufe',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_ASSORTMENT: 'Du kannst alle varianten eines bestimmten sortiments auswählen',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_COLLECTION: 'Du kannst alle varianten einer bestimmten kollektion auswählen',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_TIER: 'Du kannst alle varianten einer bestimmten stufe auswählen',
        NO_ASSORTMENT_TO_VIEW: 'Kein sortiment zum anzeigen',
        NO_COLLECTION_TO_VIEW: 'Keine kollektion zum anzeigen',
        NO_SELECTED_VARIANTS: 'Keine ausgewählten varianten',
        ORDERS_FROM_LIST: 'Bestellungen aus der liste',
        CONFIRM_LEAVE_PAGE: {
          ARE_YOUR_SURE: 'Bist du sicher?',
          IF_YUO_LEAVE_PAGE_YOU_WILL_LOSE_ALL_CHANGES: 'Wenn du die seite verlässt, werden alle Änderungen verloren gehen',
        },
        UNPUBLISH_ALL_FOR_PRE_ORDER: 'Alle pre-order varianten zurücknehmen',
        ARE_YOU_SURE: 'Bist du sicher?',
        ARE_YOU_SURE_UNPUBLISH_ALL_VARIANTS_FROM_PRE_ORDER: 'Bist du sicher, dass du alle pre-order varianten zurücknehmen möchtest?',
        UNPUBLISH_ALL_FOR_PRE_ORDER_WARNING: 'Diese Aktion wird auf alle Produkte angewendet',
        MESSAGE_SUCCESS_UNPUBLISH: 'Alle pre-order varianten wurden zurückgenommen',
        MESSAGE_SUCCESS_SEND_EMAIL: 'Der pre-order variantenbericht wurde erfolgreich gesendet',
        DOWNLOAD_REPORT_VARIANTS_ON_PRE_ORDER: 'Pre-order variantenbericht herunterladen',
        DOWNLOAD_REPORT_VARIANTS_ON_RE_ORDER: 'Re-order variantenbericht herunterladen',
        DOWNLOAD_REPORT_VARIANTS: 'Variantenbericht herunterladen',
        ARE_YOU_SURE_DELETE_ORDERS: 'Bist du sicher, dass du diese stufe löschen möchtest?',
      },

      TIERS: {
        NAME: 'Stufen',
        CREATE_MODAL: {
          ADD_NEW_TIER: 'Neue stufe hinzufügen',
          EDIT_TIER: 'Stufe bearbeiten',
          NAME: 'Name',
          DESCRIPTION: 'Beschreibung',
        },
        COLUMNS: {
          ID: 'Id',
          NAME: 'Name',
          DESCRIPTION: 'Beschreibung',
          CREATED_ON: 'Erstellt am',
          CREATED_BY: 'Erstellt von',
        },
        DELETE_MODAL: {
          TITLE: 'Bist du sicher?',
          DESCRIPTION: 'Bist du sicher, dass du diese stufe löschen möchtest?',
        },
        ARCHIVE_MODAL_DESCRIPTION: 'Bist du sicher, dass du diese stufe archivieren möchtest? Dieser vorgang ist nicht rückgängig zu machen.'
      },

      SEASON_REFERENCE: {
        NAME: 'Saisonreferenz',
        CREATE_EDIT: {
          NAME: 'Name',
          DATE_FROM: 'Gültig ab',
          DATE_TO: 'Gültig bis',
        },
        TABLE: {
          ID: 'Externe ID',
          NAME: 'Name',
          DATE_FROM: 'Gültig ab',
          DATE_TO: 'Gültig bis',
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Neu erstellen',
          EDIT: 'Bearbeiten',
          CANCEL: 'Abbrechen',
          SAVE: 'Speichern',
        },
        DELETE_MODAL: {
          DELETE_SR: 'Saisonreferenz löschen',
          SURE: 'Möchten sie diese saisonreferenz löschen?',
          DELETE: 'Löschen'
        }
      },

      SHOWCASES: {
        NAME: 'Showcases',
        CREATE_EDIT: {
          NAME: 'Name',
          DATE_FROM: 'Gültig ab',
          DATE_TO: 'Gültig bis',
        },
        TABLE: {
          NAME: 'Name',
          STATUS: 'Status',
          ACTIVE: 'Aktiv',
          INACTIVE: 'Inaktiv'
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Neu erstellen',
          EDIT: 'Bearbeiten',
          CANCEL: 'Abbrechen',
          SAVE: 'Speichern',
        },
        AUTOMATIC_DISCOUNTS: {
          TITLE: 'Automatischen rabatt hinzufügen',
          ARE_YOU_SURE: 'Sind sie sicher, dass sie das showcase aus dem automatischen rabatt entfernen möchten?',
          ALREADY_ADDED_TITLE: 'Bereits hinzugefügt',
          ALREADY_ADDED: 'Das showcase ist bereits diesem automatischen rabatt zugeordnet.'
        },
        ASSORTMENTS: {
          TITLE: 'Sortiment hinzufügen',
          ARE_YOU_SURE: 'Sind sie sicher, dass sie das showcase aus dem sortiment entfernen möchten?',
          ALREADY_ADDED: 'Dieses showcase ist bereits diesem sortiment zugeordnet.'
        },
        DESCRIPTION: {
          NAME: 'Wählen sie das showcase aus, für das das sortiment verfügbar ist:'
        },
        DELETE_MODAL: {
          DELETE_SR: 'Showcase löschen',
          SURE: 'Möchten sie dieses showcase löschen?',
          DELETE: 'Löschen'
        }
      },

      AGENCIES: {
        NAME: 'Agenturen',
        CHANGE_AGENCY_ASSOCIATION: 'Wechsel agentur/verkaufsstellen-zuordnung',
        FROM_AGENCY: 'Von der agentur',
        TO_AGENCY: 'Zur agentur',
        MODAL_INFO: 'Hier können sie massenhaft die verbindung aller verkaufsstellen (und zugehöriger warenkörbe) mit einer agentur zu einer anderen verschieben',
        COLUMNS: {
          VAT: 'USt-IdNr.',
          AGENCY_CODE: 'Code',
          NAME: 'Name',
          CITY: 'Stadt',
          ORDERS_YTD: 'Bestellungen (YTD)',
          TOTAL_YTD: 'Gesamt (YTD)',
          STATUS: 'Status',
        },
        MODAL_DELETE_AGENCY: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_AGENCY: 'Bist du sicher, dass du diese agentur löschen möchtest?',
        },
        POS_UPDATE: 'Verkaufsstellen aktualisiert: ',
        CARTS_UPDATE: 'Warenkörbe aktualisiert: '
      },

      CUSTOMERS: {
        NAME: 'Kunden',
        COLUMNS: {
          VAT: 'USt-IdNr.',
          ALTERNATIVE_VAT: 'Alternative USt-IdNr.',
          ALTERNATIVE_GLN: 'Alternative GLN Number',
          NAME: 'Name',
          CITY: 'Stadt',
          POS: 'Verkaufsstelle',
          POS_PLURAL: 'Verkaufsstellen',
          ORDERS_YTD: 'Bestellungen (YTD)',
          TOTAL_YTD: 'Gesamt (YTD)',
          STATUS: 'Status',
          RELOAD_PAGE: 'Seite neu laden',
          EXTERNAL_ID: 'Externe ID',
          VAT_NUMBER: 'USt-IdNr.',
        },
        INFO_SECTION: {
          INFO: 'Kundeninfo',
          COMMERCIAL_INFO: 'Kommerzielle infos',
          FINANCIAL_INFO: 'Finanzielle infos',
          CUSTOMER_CLASSIFICATION: 'Kundeneinstufung',
          TAX_COMPLIANCE: 'Steuern & Compliance',
          PREFIX_VAT: 'USt-IdNr. präfix',
          VAT_WITHOUT_PREFIX: 'USt-IdNr. ohne präfix',
          DEFAULT_TRANSACTION_SPECIFICATION: 'Standard-transaktionsspezifikation',
          TRANSACTION_TYPE: 'Transaktionstyp',
          IBAN: 'IBAN',
          SWIFT_CODE: 'SWIFT-Code',
          MISSING_POS_NAME: 'Fehlender Name in mindestens einem Verkaufsstandort',
          BANK_NAME: 'Bankname',
          BANK_ACCOUNT_NUMBER: 'Kontonummer',
          BANK_ACCOUNT_ID: 'Bankkonto-ID',
          ROUTING_NUMBER: 'Routing number',
          ROUTING_TYPE: 'Routing type',
          FISCAL_CODE: 'Steuernummer',
          ABI: 'ABI',
          CAB: 'CAB',
          BANKING_DETAILS: 'Bankdaten',
          SAVE_ERP: 'Speichern und an ERP senden',
          BUSINESS_INFO: 'Geschäftsinformationen',
          ACCOUNT_NUMBER: 'Kontonummer',
          GENERATE: 'Automatisch erzeugen',
          ACCOUNT_NUMBER_USED: 'Kontonummer bereits in Verwendung!',
          VAT_ALREADY_USED: 'Umsatzsteuer bereits verwendet!',
          EMAIL_ALREADY_USED: 'E-Mail-Adresse bereits verwendet!',
          CUSTOMERS_GROUP: 'Kundengruppe',
          SALES_TAX_GROUP: 'Umsatzsteuergruppe',
          TOOLTIP_COMPANY_OWNER: 'Es ist erforderlich, einen Benutzer zu erstellen/auszuwählen',
          COMPANY_NAME: 'Firmenname',
          PAYMENT_METHOD_CODE: 'Zahlungsmethoden-Code',
          LOGISTICS_TRANSACTIONS: 'Logistik & transaktionen',
          PACKAGE_GROUPING_MODE: 'Paketgruppierungsmodus',
          DELIVERY_TERMS: 'Lieferbedingungen',
          CURRENCY_CODE: 'Währungscode',
          SUBJECTED_FACTORING: 'Factor',
          CREDIT_LIMIT: 'Credit limit',
          PAYMENT_TERMS_CODE: 'Zahlungsbedingungen-code',
          PAYMENT: 'Zahlung',
          SDI_CODE: 'SDI-code',
          OFFICE_PA_CODE: 'PA-büro-code',
          PEC_EMAIL: 'PEC e-mail',
          CENTRAL_OF_PAYMENT: 'Zahlungsstellenkonto',
          CENTRAL_OF_PAYMENT_NUMBER: 'Nummer der Zahlungsstelle',
          INVOICING_ACCOUNT_NUMBER: 'Abrechnungskonto',
          COMPANY_FORM: 'Unternehmensform',
          KNOWN_AS: 'Bekannt als',
          GROUP_REPS: 'Vertretergruppe',
          ADMINISTRATIVEEMAIL_MISSING: 'Kontaktdetails: Administrative E-Mail fehlt',
          PHONE_MISSING: 'Kontaktdetails: Telefonnummer fehlt',
          MOBILE_MISSING: 'Kontaktdetails: Mobiltelefon fehlt',
          FAX_MISSING: 'Kontaktdetails: Fax fehlt',
          EMAIL_MISSING: 'Kontaktdetails: E-Mail fehlt',
          COMMERCIALEMAIL_MISSING: 'Kontaktdetails: Geschäftliche E-Mail fehlt',
          PEC_MISING: 'Kontaktdetails: PEC fehlt',
          WEBSITE_MISSING: 'Kontaktdetails: Website fehlt',
          FACEBOOK_MISSING: 'Kontaktdetails: Facebook fehlt',
          INSTAGRAM_MISSING: 'Kontaktdetails: Instagram fehlt',
          TWITTER_MISSING: 'Kontaktdetails: Twitter fehlt',
          LINKEDIN_MISSING: 'Kontaktdetails: LinkedIn fehlt',
          MISSING_USER: 'Erstellen Sie einen Benutzer oder wählen Sie einen bestehenden aus',
          MISSING_CONTACTS_POS: 'Fehlende Kontaktdaten am Verkaufsstandort',
          MISSING_CONTACTS_POS_FRANCE: 'Geben Sie mindestens eine administrative E-Mail-Adresse ein',
          MISSING_LOCATION_POS: 'Fehlende Adressdaten am Verkaufsstandort',
          MISSING_CHANNELS_IN_DROPDOWN: 'Für jeden Verkaufsstandort mindestens ein Geschäft aktivieren und mindestens einen Vertriebskanal für jedes aktive Geschäft hinzufügen',
          MISSING_ONLINESTORES_POS: 'Fehlende Online-Shop-Daten am Verkaufsstandort',
          TOOLTIP_TAX_COMPLIANCE: 'Geben Sie eine gültige und eindeutige USt-IdNr. ein',
          NOT_POSSIBLE_SAVE: 'Speichern nicht möglich',
          SAVE_CHANGES: 'Möchten Sie die Änderungen speichern?',
          SWITCH_1: 'Dieser Kunde kann als "Abrechnungskonto" für andere Kunden zugewiesen werden',
          SWITCH_2: 'Dieser Kunde kann als "Zahlungsstellenkonto" für andere Kunden zugewiesen werden',
          BILLING_LOCATION: 'Rechnungsadresse',
          ADDRESS: 'Adresse',
          PROVINCE: 'Provinz',
          POSTAL_CODE: 'Postleitzahl',
          CITY: 'Stadt',
          COUNTRY: 'Land',
          COMPANY_IDENTIFICATION: 'Unternehmensidentifikation',
          SIREN_NUMBER: 'SIREN-Nummer',
          SIRET_NUMBER: 'SIRET-Nummer',
          GLN_NUMBER: 'GLN-Kundennummer',
          TOOLTIP_DETAIL_CONTACTS: 'Geben Sie mindestens einen Kontakt für jeden unten aufgeführten Typ ein',
          CONTACTS_DETAIL: 'Kontaktdetails',
          ADMINISTRATIVE: 'Verwaltung',
          TYPE: 'Typ',
          VALUE: 'Wert',
          ANALYTICS: 'Analysen',
          CLASSIFICATION_GROUP: 'Kundenklassifizierungsgruppe',
          GROUP_CODE: 'Kundengruppen-Code',
          SUB_CODE: 'Untergruppen-Code des Kunden',
          SINGBOARD: 'Kundenschild',
          HOLDING: 'Kundenhaltung',
          MISSING_FIELDS: 'Die folgenden felder sind nicht ausgefüllt',
          MISSING_FIELDS_EMPTY: 'Es ist möglich, an ERP zu senden, alle Pflichtfelder wurden ausgefüllt ✅',
          ALREADY_SENT: '✅ Kunde bereits gesendet, keine Änderungen',
          SELECT_COUNTRY: "Wählen Sie ein Land",
          ADD_LOCATION_BEFORE_CONTACTS: "Füllen Sie den Abschnitt <strong>\"Rechnungsadresse\"</strong> aus und speichern Sie ihn, bevor Sie Kontakte hinzufügen"
        },
        SUMMARY: {
          ORDER_INSIGHTS: 'Kauf-insights',
          CARTS_ORDERS_PLACED: 'Bestellungen & Warenkörbe'
        },
        GOK: {
          NEW_GOK: 'Neues Gok',
          EDIT_GOK: 'Gok bearbeiten',
          NAME: 'Name',
          TOTAL_AMOUNT: 'Gesamtbetrag',
          DISACTIVE: 'Inaktiv',
          EMAIL: 'Gok kontakt e-mail',
          MODIFY_EMAIL: 'E-mail bearbeiten',
          VALID_FROM: 'Gültig ab',
          VALID_TO: 'Gültig bis',
          RESIDUAL: 'Restbetrag',
          ORIGINAL_AMOUNT: 'Originalbetrag',
          MODIFY_GOK_NUMBER: 'Nummer Gok bearbeiten',
          STATUS: 'Status',
          TITLE_MODAL: 'Gok löschen',
          MESSAGE: 'Bist du sicher, dass du dieses Gok löschen möchtest?',
          CANT_ELIMINATE: 'Dieses Gok kann nicht gelöscht/bearbeitet werden, da es bereits verwendet wurde',
          IMPOSSIBLE: 'Gok erstellung nicht möglich',
          DATE_RANGE: 'Gok bereits im angegebenen zeitraum vorhanden',
          ACTIVATE_GOK: 'Aktiviertes Gok',
        },
        ATTACHMENTS: {
          TITLE: 'Anhänge',
          NAME: 'Name',
          CODE: 'Code',
          COMMENTS: 'Kommentare',
          CREATION_TIME: 'Erstellungsdatum',
          TITLE_MODAL: 'Anhänge löschen',
          MESSAGE: 'Bist du sicher, dass du diesen Anhang löschen möchtest?',
          VIEW_ATTACHMENTS: 'Anhänge anzeigen',
        },
        COMMERCIAL_BLOCK: {
          TITLE: 'Kunden-kommerzielle sperre',
          DESCRIPTION: 'Durch das aktivieren der kommerziellen sperre auf dem kunden kann niemand außer benutzern mit den rollen storeOwner, storeUser und admin den warenkorb bestätigen.',
          RESTRICTION_CAUSE: 'Grund der einschränkung',
          BLOCK_USER: 'Benutzer sperren',
        },
        MODAL_DELETE_CUSTOMER: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_CUSTOMER: 'Bist du sicher, dass du diesen kunden löschen möchtest?',
        },
        MODAL_IMPORT_CUSTOMER: 'Kunden über Post Office-ID importieren',
        CREATE_CUSTOMER: 'Kunde erstellen'
      },

      USERS: {
        NAME: 'Benutzer',
        COLUMNS: {
          NAME: 'Name',
          EMAIL: 'E-mail',
          ROLE: 'Rolle',
          COMPANY: 'Unternehmen',
          TYPE: 'Typ',
          STATUS: 'Status',
          GOK_NUMBER: 'Gok-Nummer',
        }
      },

      LOCATION: {
        NAME: 'Adressen',
        PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: 'Bitte füllen sie alle erforderlichen felder aus',
        PLEASE_FILL_IN_ALL_STOCK_LIMIT_FIELDS: 'Bitte füllen sie alle felder für bestandsgrenzen aus',
        PLEASE_ENABLE_AT_LEAST_ONE_STORE_AND_ITS_CHANNEL: 'Aktivieren sie mindestens ein geschäft und seinen kanal',
        PLEASE_ENABLE_AT_LEAST_ONE_CHANNEL: 'Bitte wähle mindestens einen Vertriebskanal für jedes aktivierte Geschäft aus',
        POINT_OF_SALE: 'Verkaufsstellen',
        SHIPPING_LOCATION: 'Versandadressen',
        CREATE_MODAL: {
          CREATE_NEW_POINT_OF_SALE: 'Neue verkaufsstelle erstellen',
          CREATE_NEW_SHIPPING_ADDRESS: 'Neue versandadresse erstellen',
        },
        COLUMNS: {
          NAME: 'Name',
          CITY: 'Stadt',
          STORES: 'Geschäfte',
          ORDERS_YTD: 'Bestellungen (YTD)',
          TOTAL_YTD: 'Gesamt (YTD)',
          COUNTRY: 'Land',
          ADDRESS: 'Adresse',
        },
        MODAL_DELETE_POS: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_POINT_OF_SALE: 'Bist du sicher, dass du diese verkaufsstelle löschen möchtest?',
        },
        MODAL_DELETE_SA: {
          ARE_YOU_SURE: 'Bist du sicher?',
          ARE_YOU_SURE_DELETE_SHIPPING_ADDRESS: 'Bist du sicher, dass du diese versandadresse löschen möchtest?',
        },
      },

      PRODUCT_LIST: {
        NAME: 'Produktliste',
        COLUMNS: {
          STYLE: 'Artikel',
          NAME: 'Name',
          WHOLE_SALE: 'Pre-order wholesale',
          RETAIL: 'Pre-order retail',
          ALL_IMAGES_HIDDEN: 'Ausgeblendete Bilder',
          STOCK: 'Lagerbestand',
          RE_ORDER: 'Nachbestellung',
          PRE_ORDER: 'Vorbestellung',
        },
        PRICE: 'Preis',
        VARIANTS: 'Varianten',
        INCLUDED: 'Inklusive',
        SELECTED: 'Ausgewählt',
        BY_PRODS: 'Pro produkt',
        BY_DATE: 'Pro datum',
      },

      VARIANT: {
        COLUMNS: {
          SKU: 'SKU',
          SIZE: 'Größe',
          COLOR: 'Farbe',
          STOCK_QTY: 'Menge (Stück)',
          RE_ORDER: 'Nachbestellung',
          PRE_ORDER: 'Vorbestellung',
          STOCK_LIMIT: 'Lagergrenze',
        },
      },

      SALES_CAMPAIGNS: {
        COLUMNS: {
          NAME: 'Name',
          DESCRIPTION: 'Beschreibung',
          START_DATE: 'Startdatum',
          END_DATE: 'Enddatum',
          SHOP_SELLING_PERIOD_START: 'Beginn der verkaufsperiode im geschäft',
          SHOP_SELLING_PERIOD_END: 'Ende der verkaufsperiode im geschäft',
          DELIVERY_PERIOD_START: 'Beginn der lieferung',
          DELIVERY_PERIOD_END: 'Ende der lieferung'
        },
        CREATE_MODAL: {
          EDIT_SALE_CAMPAIGN: 'Verkaufskampagne bearbeiten',
          ADD_NEW_SALE_CAMPAIGN: 'Neue Verkaufskampagne hinzufügen'
        },
        DELETE_MODAL: {
          TITLE: 'Bist du sicher?',
          DESCRIPTION: 'Bist du sicher, dass du diese verkaufskampagne löschen möchtest?'
        },
        RULE: {
          COLUMN: {
            ID: 'ID',
            NAME: 'Name',
            ROLES_BYPASSING: 'Rollen, die die regel umgehen',
            TIER: 'Stufe',
            LAST_MODIFICATION_TIME: 'Letzte Änderung',
            STATUS: 'Status',
          },
        },
      },
      REPORTS: {
        NAME: 'Reports',
        COLUMNS: {
          ID: 'ID',
          NAME: 'Name',
          TYPE: 'Typ',
          CREATOR: 'Ersteller',
          COMPLETED_AT: 'Abgeschlossen am',
        },
      },

    },
    SALES_CAMPAIGNS: {
      NAME: 'Name',
      VALIDITY: 'Gültigkeit',
      COMMERCIAL_RULES: 'Handelsregeln',
      NEW_RULE: 'Neue Regel',
      DELETE_ASSORTMENT_SUCCESSFULLY: 'Sortiment erfolgreich gelöscht',
      DELETE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Paketbeschränkung erfolgreich gelöscht',
      CREATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Paketbeschränkung erfolgreich erstellt',
      UPDATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Paketbeschränkung erfolgreich aktualisiert',
      ENABLED_CONSTRAINT_VALUE_SUCCESSFULLY: 'Wertbeschränkung erfolgreich aktiviert',
      DELETE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Wertbeschränkung erfolgreich gelöscht',
      CREATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Wertbeschränkung erfolgreich erstellt',
      UPDATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Wertbeschränkung erfolgreich aktualisiert',
      DELETE_FILTER_SUCCESSFULLY: 'Filter erfolgreich gelöscht',
      CREATE_FILTER_SUCCESSFULLY: 'Filter erfolgreich erstellt',
      UPDATE_FILTER_SUCCESSFULLY: 'Filter erfolgreich aktualisiert',
      UPDATE_RULE_SUCCESSFULLY: 'Regel erfolgreich aktualisiert',

      RULES: {
        CONSTRAINT_VALUE_NOT_ENABLED: 'Die beschränkung kann für dieses sortiment nicht aktiviert werden, da sie bereits für ein anderes sortiment aktiv ist',
        CONSTRAINT_VALUE_INFO_MESSAGE: 'Diese beschränkung wird auf jedes warenkorb angewendet, das mit dieser handelsregel verknüpft ist.',
        CONSTRAINT_VALUE_ENABLED: 'Wertbeschränkung aktiviert',
        NO_ASSORTMENTS: 'Kein sortiment konfiguriert, fügen sie ein sortiment hinzu, um die beschränkungen zu verwalten',
        NO_CONSTRAINT_PACKAGE: 'Es wurden noch keine paketbeschränkungen für dieses sortiment hinzugefügt',
        NO_CONSTRAINT_VALUE: 'Aktivieren sie diese funktion, um eine wertbeschränkung für dieses sortiment hinzuzufügen',
        NO_CONSTRAINT_FILTER: 'Sie können filter festlegen, um die artikel zu bestimmen, mit denen der großhandelspreis berechnet wird',
        CONSTRAINTS_CONFIGURATION: 'Beschränkungs-konfiguration',
        TITLE: 'Regeln',
        RULE: 'Regel: {{ruleName}}',
        NAME: 'Name',
        TIER: 'Stufe',
        ROLES_BYPASSING: 'Rollen, die die regel umgehen',
        ADD_ASSORTMENT: 'Sortiment hinzufügen',
        ADD_CONSTRAINT: 'Beschränkung hinzufügen',
        ADD_RULE: 'Regel hinzufügen',
        CONSTRAINTS_PACKAGE: 'Paketbeschränkungen',
        QUANTITY: 'Menge',
        STYLES_CODE: 'Produkte',
        CONSTRAINT_VALUE: 'Wertbeschränkung',
        PERCENTAGE: 'Prozentsatz',
        TYPE: 'Typ',
        CONDITION: 'Bedingung',
        VALUE: 'Wert',
        VALUE_RULE_WHEN_CALCULATE_TOTAL_WHOLESALE_INFORMATION: 'Der großhandelspreis der artikel in diesem sortiment im vergleich zum gesamt-großhandelspreis des warenkorbs muss größer oder gleich',
        VALUE_RULE_INFORMATION: 'Filter zur bestimmung der bestellartikel, auf die die wertbeschränkung angewendet wird: ',
        ADD_OR_REMOVE: 'Hinzufügen/Entfernen',
        ADD_FILTER: 'Filter hinzufügen',
        ACTIVATE: 'Regel aktivieren',
        DISABLE: 'Regel deaktivieren'
      },
      TYPE: {
        WHERE_STYLE_GROUP: 'Wo style-gruppe',
        WHERE_SIZE_GROUP: 'Wo size-gruppe',
      },
      CONDITION: {
        IS: 'ist',
        IS_NOT: 'ist nicht',
      },
    },
    PICK_LIST: {
      TO_INCLUDE: 'Einbeziehen',
      INCLUDED: 'Eingeschlossen',
      VARIANTS_SELECTED: 'Ausgewählte varianten: {{quantity}}',
      ALL: 'alle',
      SELECTED_ALL: 'Alles auswählen',
      CLICK_FOR_OPEN_REPORT: 'Klicken sie hier, um den bericht zu öffnen',
      INCLUDE: 'Einbeziehen',
      EXCLUDE: 'Ausschließen',
      VARIANTS: 'Varianten {{quantity}}',
      SUCCESS_VARIANTS_DISASSOCIATE: '{{quantity}} varianten erfolgreich getrennt',
      SUCCESS_VARIANTS_ASSOCIATE: '{{quantity}} varianten erfolgreich zugeordnet',
      NO_OTHER_DATA: 'Keine weiteren daten',
      NO_DATA_FOUND: 'Keine daten gefunden',
      SELECT_ALL_MODAL: {
        TITLE: 'Modus „alles ausgewählt“',
        MESSAGE: '<strong>Achtung!</strong> Wenn sie diesen modus auswählen, werden alle Produkte und varianten für die ausgewählten filter ausgewählt. <br> Sie können jedoch Produkte und varianten weiterhin aus der auswahl ausschließen.',
        NOT_SHOW_AGAIN: 'Nicht mehr anzeigen',
        CONFIRM: 'Bestätigen',
      },
      SELECT_ALL_CANCELED: 'Alles auswählen abgebrochen',
      REPORT_SELECTED_MODAL: {
        TITLE: 'Auswahlbericht',
        NOT_SELECTED: 'Es wurde noch keine variante oder produkt-farbe ausgewählt',
        YOU_ARE_SELECTING: 'Sie wählen gerade {{quantity}} {{what}} aus',
        YOU_ARE_EXCLUDING: 'Sie schließen gerade {{quantity}} {{what}} aus',
        PRODUCT_STYLE_COLOR: 'Produkt-farbe',
        VARIANTS: 'Varianten',
        YOU_ARE_SELECTING_ALL_VARIANTS_FOR_THIS_FILTERS: 'Sie wählen alle varianten für diese filter aus',
        YOU_ARE_SELECTING_THE_ENTIRE_CATALOGUE_AVAILABLE: 'Sie wählen den gesamten verfügbaren katalog aus',
        FROM_THE_SELECTION_YOU_ARE: 'Aus der Auswahl schließen sie gerade',
        EXCLUDING_PRODUCTS_STYLE_COLOR: '{{quantity}} produkt-farbe wird ausgeschlossen',
        EXCLUDING_VARIANTS: '{{quantity}} varianten werden ausgeschlossen',
        NOT_VARIANT_OR_PRODUCT_STYLE_COLOR_HAS_BEEN_SELECTED_YET: 'Es wurde noch keine variante oder produkt-farbe ausgewählt',
      },
      SAVE_INCLUDE_EXCLUDE_MODAL: {
        ARE_YOU_SURE: 'Sind sie sicher?',
      }
    },
    COMMERCIAL_AGREEMENT_DETAIL: {
      CONTINUE_WITHOUT_COMMERCIALAGREEMENT: "Fahre ohne kommerzielle vereinbarung fort",
      BACK_TO_COMMERCIAL_AGREEMENTS: "Zurück zu den kommerziellen vereinbarungen",
      CREATE_NEW_COMMERCIAL_AGREEMENT: "Neue kommerzielle vereinbarung erstellen",
      COMMERCIAL_AGREEMENT: "Kommerzielle vereinbarung: {name}",
      COMMERCIAL_AGREEMENT_INFO: "Informationen zur kommerziellen vereinbarung",
      NAME: "Name",
      VALID_FROM: "Gültig ab",
      VALID_UNTIL: "Gültig bis",
      DISCOUNT_PERCENTAGE: "% Rabatt",
      TOTAL_RETAIL_AMOUNT: "Ausgabengrenze (Einzelhandelspreis, €)",
      CUSTOMER: "Kunde",
      CHANNEL: "Kanal",
      ERRORS: {
        COMPILE_ALL_REQUIRED_FIELDS: "Füllen sie alle pflichtfelder aus",
      },
    },
    TERM_OF_SALE_DETAIL: {
      BACK_TO_TERMS_OF_SALE: "Zurück zu den verkaufsbedingungen",
      CREATE_NEW_TERM_OF_SALE: "Neue verkaufsbedingung erstellen",
      TERM_OF_SALE: "Verkaufsbedingung",
      NAME: "Name",
      SET_AS_ACTIVE: "Als aktiv festlegen",
      TERMS_AN_CONDITIONS_BY_LANGUAGE: "Bedingungen und konditionen nach sprache",
      PLEASE_SELECT_A_DEFAULT_LANGUAGE: "Wählen sie eine standardsprache aus, indem sie das aktionsmenü neben dem namen der ausgewählten sprache verwenden",
      PLEASE_WRITE_A_TERM_OF_SALE_FOR_THE_DEFAULT_LANGUAGE_OR_SELECT_ANOTHER_DEFAULT_LANGUAGE: "Schreiben sie eine verkaufsbedingung für die standardsprache oder wählen sie eine andere standardsprache",
      PLEASE_ENTER_A_VALID_TERM_OF_SALE_NAME: "Geben sie einen gültigen namen für die verkaufsbedingung ein",
      TERM_OF_SALE_UPDATE_SUCCESS: "Verkaufsbedingung erfolgreich aktualisiert",
      TERM_OF_SALE_CREATE_SUCCESS: "Verkaufsbedingung erfolgreich erstellt",
      NAME_ALREADY_EXISTS: "Der name existiert bereits",
      ENTER_THE_TERM_OF_SALE: "Geben sie die verkaufsbedingung ein",
      NAME_REQUIRED: "Name erforderlich",
      NAME_INVALID: "Ungültiger name",
      TERM_OF_SALE_DELETE_SUCCESS: "Verkaufsbedingung erfolgreich gelöscht",
      ARE_YOU_SURE: "Bist du sicher?",
      ARE_YOU_SURE_DELETE_TERM_OF_SALE: "Bist du sicher, dass du diese verkaufsbedingung löschen möchtest?",
      ERROR_IS_APPLIED_TO_ORDERS: "Diese verkaufsbedingung kann nicht bearbeitet oder gelöscht werden, da sie mit einer oder mehreren bestellungen verknüpft ist",
    },
    TIER_DETAIL: {
      BACK_TO_TIERS: 'Zurück zu den tiers',
      CREATE_NEW_TIER: 'Neues tier erstellen',
      NAME: 'Name',
      INFORMATION: 'Informationen',
      DESCRIPTION: 'Beschreibung',
      INCLUDE_VARIANTS: 'Varianten einbeziehen',
      INCLUDED_VARIANTS: 'Eingeschlossene varianten',
      ASSOCIATE_VARIANTS: 'Varianten zuordnen',
      DISASSOCIATE_VARIANTS: 'Varianten entfernen',
      PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Bitte füllen sie alle erforderlichen felder aus',
      TIER_UPDATE_SUCCESS: 'Tier erfolgreich aktualisiert',
      TIER_CREATE_SUCCESS: 'Tier erfolgreich erstellt',
      VARIANTS_DISASSOCIATED_SUCCESS: 'Varianten erfolgreich entfernt',
      VARIANTS_ASSOCIATED_SUCCESS: 'Varianten erfolgreich zugeordnet',
      REMOVE_POS_FROM_TIER: 'Sind sie sicher, dass sie den verkaufsstandort aus dem tier entfernen möchten?',
      POS_ALREADY_ASSOCIATED: 'Verkaufsstandort bereits dem tier zugeordnet',
      OPTION_DESCRIPTION: 'Wenn sie diese option aktivieren, sehen verkaufsstandorte mit diesem tier nicht nur die varianten dieses tier, sondern auch diejenigen ohne zugeordnetes tier für den eingestellten verkaufskanal.',
      INFO_ALLERT: {
        INCLUDE_VARIANTS: 'Wählen sie die varianten aus, die im tier eingeschlossen werden sollen, und klicken sie dann auf speichern, um das tier zu aktualisieren.',
        INCLUDED_VARIANTS: 'Dies sind die im tier enthaltenen varianten. Wählen sie die varianten aus, die aus dem tier entfernt werden sollen, und klicken sie dann auf speichern, um das tier zu aktualisieren.',
      },
      DETAIL: 'Detail',
      ASSOCIATED_VARIANTS: 'Zugeordnete varianten',
      ARCHIVED_TIER: 'Archiviertes tier #{{tierName}}',
      WORK_IN_PROGRESS_MESSAGE: 'Hier können sie die varianten sehen, die diesem tier zugeordnet waren. Wir arbeiten für sie.',
      CHANNEL: 'Kanal',
    },
    LOCATION_DETAIL: {
      POINT_OF_SALE_INFO: 'Verkaufsstandort informationen',
      BACK_TO_POS: 'Zurück zu den verkaufsstandorten',
      ADDRESS_INFO: 'Adresse informationen',
      PURCHASE_STATS: {
        NAME: 'Kaufstatistiken',
        TOTAL_CUSTOMER_REVENUE: 'Gesamter kundenumsatz',
        FROM_PRE_ORDER: 'Von vorbestellung',
        FROM_RE_ORDER: 'Von nachbestellung',
        TOTAL_MARGIN: 'Gesamtmarge',
        TOTAL_ORDERS: 'Gesamtbestellungen',
        AVERAGE_ORDER_VALUE: 'Durchschnittlicher bestellwert',
      },
      SUMMER_STOCK_LIMIT: 'Sommerlagergrenze',
      WINTER_STOCK_LIMIT: 'Winterlagergrenze',
      SUMMER_START_MONTH: 'Monat des sommerbeginns',
      WINTER_START_MONTH: 'Monat des winterbeginns',
      SUMMER_START_DAY: 'Tag des sommerbeginns',
      WINTER_START_DAY: 'Tag des winterbeginns',
      STOCK_LIMIT: 'Lagergrenze',
      THE_WAREHOUSE_LIMIT_MUST_BE_SET_FOR_THE_CHANNELS: 'Die lagergrenze muss für die kanäle festgelegt werden',
      ONLINE_STORES_ENABLED: 'Online-shops aktiviert',
      USE_NAME_IN_ORDER_HEADER: 'Verwenden sie den namen des geschäftes im bestellkopf',
      BACK_TO_LOCATIONS: 'Zurück zu den adressen',
      NAME: 'Name',
      TIER: 'Stufe',
      AGENCY: 'Agentur',
      CHANNEL: 'Kanal',
      YOU_CANT_EDITINFO_ABOUT_ADDRESS: 'Sie können die dressinformationen nicht bearbeiten, wenn sie auf die genehmigung für ein geschäft wartet!',
      YOU_CANT_ACTIVEATE_THIS_ADDRESS_IF_ITS_CUSTOMER_IS_NOT_APPROVED: 'Sie können diese adresse nicht aktivieren, wenn der kunde nicht genehmigt wurde!',
      MISSING_STOCK_LIMIT: 'Achtung! Um die Adresse im Plug&Sell-Kanal zu aktivieren, musst du zuerst den Abschnitt zu den Lagerbestandsgrenzen ausfüllen!',
      ERROR_MODAL: {
        TITLE: 'Achtung!',
        DESCRIPTION: 'Fehlende felder zum speichern der änderungen, bitte vervollständigen sie die daten, um fortzufahren',
      }
    },
    CONTACT: {
      NAME: 'Kontakt',
      NEW_CONTACT: 'Neuer kontakt',
      EDIT_CONTACT: 'Kontakt bearbeiten',
      CONTACT_INFO: 'Kontaktinformationen',
    },
    USER_DETAIL: {
      USER_INFO: 'Benutzerinformationen',
      REGISTERED_SINCE: 'Registriert seit',
      NAME_SURNAME: 'Vorname und nachname',
      NAME_SURNAME_ERROR: 'Vorname und nachname sind erforderlich',
      EMAIL_ERROR: 'E-mail ist erforderlich',
      ROLES_ERROR: 'Rolle ist erforderlich',
      STORE_ERROR: 'Geschäft ist erforderlich',
      CUSTOMER_ERROR: 'Kunde ist erforderlich',
      AGENCY_ERROR: 'Agentur ist erforderlich',
      USER_ROLE: 'Rolle',
      AGENCY: 'Agentur',
      CUSTOMER: 'Kunde',
      BACK_TO_USERS: 'Zurück zu den benutzern',
      MY_PROFILE: 'Mein profil',
      INVITE_USER: 'Benutzer einladen',
      SEND_INVIATION: 'Einladung senden',
      USER_STATUS: 'Benutzerstatus',
      RESEND_INVITATION: 'Einladung erneut senden',
      INVITATION_RESENT_COMPLETED: 'Einladung erfolgreich gesendet',
      INVITATION_RESENT_ERROR: 'Fehler beim senden der einladung',
      MODAL_CONFIRM: {
        ARE_YOU_SURE: 'Bist du sicher?',
        ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_USER: 'Bist du sicher, dass du diesen benutzer deaktivieren möchtest?',
      }
    },
    WORK_IN_PROGRESS_TITLE: 'Wir arbeiten für sie: außerordentliche wartungsarbeiten ab {{fromHour}} am {{fromDate}}. Wir sind wieder online um {{toHour}} am {{toDate}}.',
    ORDER_DETAIL: {
      EXTRA_COSTS_INFO: 'Hier kannst du Versand- und/oder Personalisierungskosten anpassen. Wenn sie nicht festgelegt werden, werden die entsprechenden Kosten gemäß den Standardeinstellungen übernommen. Wenn du zum Beispiel für diesen Warenkorb keine Versandkosten berechnen möchtest, gib 0 in das entsprechende Feld ein.',
      CUSTOMIZATION_COSTS: 'Personalisierungskosten',
      MANAGE_EXTRA_COSTS: 'Zusatzkosten verwalten',
      BULK_OPERATIONS_STATUS_SYNCING: 'Diese Bestellung wird gerade aktualisiert ({{processingCount}} Vorgänge in der Warteschlange). Alle Vorgänge sind vorübergehend deaktiviert, bis die Synchronisierung abgeschlossen ist.',
      BULK_OPERATIONS_STATUS_SYNCING_2: 'Diese Bestellung wird gerade aktualisiert. Alle Vorgänge sind vorübergehend deaktiviert, bis die Synchronisierung abgeschlossen ist.',
      BULK_OPERATIONS_STATUS_AWATING: 'Diese Bestellung hat {{processingCount}} Vorgänge, die in der Warteschlange bearbeitet werden müssen.',
      HAS_OPERATION_PENDING_MESSAGE: 'Entschuldigung! Diese Bestellung kann nicht mehr geändert werden, da einer der wartenden Jobs bereits gestartet wurde. Bitte bearbeiten Sie die Bestellung erneut, sobald alle wartenden Jobs abgeschlossen sind, und aktualisieren Sie die Seite, um die Details zu sehen.',
      STATS: {
        TOTAL_WHOLESALE: 'Gesamtgroßhandel',
        TOTAL_RETAIL: 'Gesamt-einzelhandel',
        TOTAL_NET: 'Nettogesamt',
        TOTAL_NET_IVA: 'Nettogesamt (inklusive Steuern)',
        VAT_MARKUP: 'RE',
        VAT: 'MwSt.',
        TOTAL_ORDERED: 'Gesamtbestellung',
        TOTAL_DISCOUNT: 'Gesamtrabatt auf großhandel',
        TOTAL_PIECES: 'Stückzahl',
        TOTAL_MARGIN: 'Marge',
        TOTAL_COST: 'Kosten',
        TOTAL_CUSTOMER_DISCOUNT: 'Kundenrabatt',
        TOTAL_COMMERCIAL_DISCOUNT: 'Kommerzieller rabatt',
        TOTAL_FINANCIAL_DISCOUNT: 'Finanzieller rabatt',
        TOTAL_STORECHANNEL_DISCOUNT: 'Unbesiegbarer rabatt',
        TOTAL_AGREEMENT_DISCOUNT: 'Rabatt laut Vereinbarung',
        TOTAL_AUTO_DISCOUNT: 'Automatischer rabatt',
        TOTAL_VOUCHER_AMOUNT: 'Wert des gutscheins',
        DISCOUNT: 'Rabatt',
        TOTAL_SERVICES: 'Gesamtservices',
        SHIPPING_COST: 'Versandkosten',
        SOME_ORDERITEMS_HAS_NO_COST: 'Einige artikel im warenkorb haben keinen angegebenen preis, daher ist diese funktion nicht verfügbar.',
        PENDING_OPERATION: 'Sie können keine operationen am warenkorb durchführen, da excel-dateien mit bestellzeilen gerade verarbeitet werden.',
        CHOOSE_EXCEL_PROPS_TITLE: 'Wählen sie die Eigenschaften',
        CHOOSE_EXCEL_PROPS: 'Wählen sie die Spalten, die im excel-blatt für bestellzeilen angezeigt werden sollen',
        CHOOSE_DOWNLOAD_TYPE: 'Wählen sie den download-typ',
        DOWNLOAD_TYPE_MESSAGE: 'Eine E-Mail mit dem angehängten Datei wird an Ihre E-Mail Adresse gesendet sobald die Datei verfügbar ist',
        CUSTOM_DATE: 'Benutzerdefiniertes datum',
        EDIT_CUSTOM_DATE: 'Benutzerdefiniertes datum bearbeiten',
        NO_CUSTOM_DATE: 'Kein benutzerdefiniertes datum',
        SELECTED_ITEMS: 'Ausgewählte bestellzeilen',
        REQUESTED_SALES_PRICE: 'Verlangter verkaufspreis',
        COLUMNS: {
          IMAGE: 'Bild',
          NAME: 'Spalten',
          SKU: 'SKU',
          COLOR: 'Farbe',
          COLOR_CODE: 'Farbcode',
          COLOR_NAME: 'Farbname',
          SIZE: 'Größe',
          UNIT_WHOLESALE: 'Großhandelseinheit',
          UNIT_NET: 'Nettoeinheit',
          UNIT_COST: 'Einheitspreis',
          UNIT_MARGIN: 'Einheitmarge',
          TOTAL_RETAIL: 'Einzelhandel gesamt',
          TOTAL_WHOLESALE: 'Großhandel gesamt',
          TOTAL_NET: 'Netto gesamt',
          TOTAL_COST: 'Gesamtpreis',
          TOTAL_MARGIN: 'Gesamtmarge',
          TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Rabatt vom einzelhandel',
          TOTAL_DISCOUNT_PERCENTAGE: 'Rabatt vom Großhandel',
          CUSTOMER_DISCOUNT: 'Kundenrabatt',
          AGREEMENT_DISCOUNT: 'Rabatt vereinbarung',
          FINANCIAL_DISCOUNT: 'Finanzieller rabatt',
          STORECHANNEL_DISCOUNT: 'Rabatt kanal',
          DISCOUNT_BY_QTY: 'Rabatt nach menge',
          DISCOUNT_BY_VALUE: 'Rabatt nach wert',
          COMMERCIAL_DISCOUNT: 'Kommerzieller rabatt',
          MARGIN_PERCENTAGE: 'Marge',
          QTY: 'Menge',
          EAN: 'EAN',
          SIZE_GROUP: 'Größengruppe',
          PRODUCT_CODE: 'Produktcode',
          VARIANT_CODE: 'Variantencode',
          PRODUCT_TITLE: 'Produktbezeichnung',
          DATE: 'Datum',
          ORDERED_QTY: 'Bestellte menge',
          CANCELED_QTY: 'Stornierte menge',
          NOT_FULFILLED_QTY: 'Nicht erfüllte menge',
          FULFILLED_QTY: 'Erfüllte menge',
          FULFILLMENT_STATUS: 'Erfüllungsstatus',
          GROUP_GENERAL: 'Allgemein',
          GROUP_UNITARY: 'Einheit (€)',
          GROUP_TOTALS: 'Gesamt (€)',
          GROUP_PERCENT: 'Prozentsätze (%)',
          GROUP_FULFILLMENT: 'Erfüllung',
          STYLE_GROUP: 'Stilgruppe',
          NOTE: 'Notizen',
          DELIVERY_DATE: 'Lieferdatum',
          REPLACE_EAN: 'EAN ersetzen',
          CANCELLATION_REASON: 'Abbrechungsgrund',
        },
      },
      UPLOADS: {
        UPLOADED: 'Datei-upload erfolgreich! Eine e-mail wird dich über den abschluss der operation benachrichtigen.',
        TITLE: 'Uploads',
        MESSAGE1: 'Hier kannst du Artikel zu deinem warenkorb über eine excel-datei (.xlxs, .xls) hochladen. In der spalte "code" kannst du eine liste von ean-codes oder eine liste von sku-codes zur identifizierung der variante einfügen.',
        MESSAGE1_1: 'Die spalte "requested price" ist optional und kann verwendet werden, um einen gewünschten verkaufspreis anzugeben, um den handelsrabatt auf der bestellzeile zu berechnen.',
        MESSAGE2: 'In der spalte "code" wird meine datei die folgenden codes enthalten:',
        MESSAGE3: 'Möchtest du die datei hochladen:',
        OPERATION_ERRORS_DETAILS: 'Fehlerdetails der operation',
        DEFAULT_ERROR_MESSAGE: 'Beim Verarbeiten der Datei ist ein Fehler aufgetreten.',
        COLUMNS: {
          ID: 'Id',
          CREATED_BY: 'Erstellt von',
          CREATED_ON: 'Erstellt am',
          STARTED_ON: 'Begonnen am',
          CONCLUDED_ON: 'Abgeschlossen am',
          STATUS: 'Status',
          FILE_ROW_INDEX: 'Zeile in der datei'
        }
      },
      FULFILLMENT: {
        FULFILLMENTS: 'Erfüllungen',
        TITLE: 'Erfüllung #{{fulfillmentNumber}}',
        FULFILLMENT_STATUS: 'Erfüllungsstatus',
        FULFILLMENT_DATE: 'Erfüllungsdatum',
        COURIER: 'Kurier',
        TRACKING_NUMBER: 'Sendungsverfolgungsnummer',
        TRACK_DELIVERY: 'Sendung verfolgen',
        DOWNLOAD_DELIVERY_NOTE: 'Lieferschein herunterladen',
        SHIPPED: 'Versendet',
        DELIVERED: 'Zugestellt',
      },

      ORIGINAL_MODIFIED_INFORMATION: 'Geänderte information, original: {{originalValue}}',
      COMMERCIAL_BLOCK_INFO: 'Für den aktuellen kunden ist eine administrative sperre aktiv.',
      NO_CART_CONF: 'Dieser warenkorb kann nicht bestätigt werden.',
      PAYMENT_TERM: 'Zahlungsbedingungen',
      ALREADY_FULFILLED_QUANTITY: 'Artikel aus bestellungen von installationen',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'Sie können diesen warenkorb nicht bestätigen, weil der kunde nicht genehmigt ist.',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'Sie können diesen warenkorb nicht bestätigen, weil der verkaufsort nicht genehmigt ist.',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_HAS_NOT_ITEMS: 'Sie können diesen warenkorb nicht bestätigen, weil keine Artikel vorhanden sind.',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'Sie können diesen warenkorb nicht bestätigen, weil der warenkorbwert unter dem im geschäft zulässigen mindestwert liegt.',
      SOME_ORDER_ITEMS_IS_NOT_AVAILABLE_FOR_CURRENT_REQUESTED_QUANTITY: 'Einige artikel der bestellung sind für die angeforderte menge nicht verfügbar.',
      SUMMARY: 'Zusammenfassung',
      ORDER_ITEMS: 'Bestellartikel',
      ORDER_TYPE: 'Bestelltyp',
      REORDER_TYPE: 'Wiederbestelltyp',
      ORDER_STATUS: 'Bestellstatus',
      CHANNEL_NAME: 'Kanalname',
      CHANNEL: 'Kanal',
      CUSTOMER: 'Kunde',
      CUSTOMER_LOCATION: 'Kundenadresse',
      POINT_OF_SALE: 'Verkaufsstelle',
      AGENT: 'Agent',
      AGENCY: 'Agentur',
      USER: 'Benutzer',
      USER_EMAIL: 'Benutzer e-mail',
      SHIPPING_ADDRESS: 'Lieferadresse',
      CREATED_ON: 'Erstellt am',
      CONFIRMED_ON: 'Bestätigt am',
      DELIVERY_DATE: 'Lieferdatum',
      EXTERNAL_ID: 'Externe ID',
      REASON: 'Grund',
      ORDER_REASON: 'Bestellgrund',
      MANUAL_DISCOUNT: 'Manueller rabatt',
      CUSTOMIZATION_REQUEST: 'Personalisierungsanfragemit',
      NAME: 'Name',
      AMOUNT: 'Betrag',
      NOTE: 'Hinweis',
      SELECT_ACTION_TYPE: 'Wählen sie den aktionstyp aus',
      BACK_TO_ORDERS: 'Zurück zu bestellungen',
      BACK_TO_CARTS: 'Zurück zu warenkörben',
      SAVED_NOTE: 'Gespeicherte notiz',
      ESTIMATED_DELIVERY_DATE: 'Voraussichtliches lieferdatum',
      DELETE_ORDER: 'Bestellung löschen',
      CANCEL_ORDER: 'Bestellung stornieren',
      RESEND_ORDER_CONFIRMATION: 'Bestätigungsmail erneut senden',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ORDERS: 'Bist du sicher, dass du die ausgewählten bestellungen löschen möchtest?',
      ADD_ITEMS: 'Artikel hinzufügen',
      EDIT_ITEMS: 'Artikel bearbeiten',
      EDIT_SELECTED: 'Ausgewählte bearbeiten',
      DELETE_NOT_FULFILED_ITEMS: 'Artikel nicht erfüllt löschen',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ITEMS: 'Bist du sicher, dass du die folgenden Artikel löschen möchtest?',
      CLOSE_SELECT_MODE: 'Schließen den auswahlmodus',
      SUCCESS_RESEND_ORDER_CONFIRMATION: 'Bestellbestätigung erfolgreich erneut gesendet',
      INVOICING_NUMBER_FULL_NAME: 'Rechnungs-Kontonummer',
      CENTRAL_PAYMENT_NUMBER_FULL_NAME: 'Zentralzahlungsnummer',
      MODAL: {
        ARE_YOU_SURE: 'Bist du sicher?',
        CONFIRM: 'Bestätigen',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Bist du sicher, dass du löschen möchtest?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CART: 'Bist du sicher, dass du diesen warenkorb löschen möchtest?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_DISCOUNT: 'Bist du sicher, dass du den rabatt entfernen möchtest?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_VARIANT: 'Bist du sicher, dass du diese variante entfernen möchtest?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_SELECTED_VARIANTS: 'Bist du sicher, dass du diese ausgewählten varianten entfernen möchtest?',
        SET_MAXIMUM_QUANTITY_FOR_THIS_SELECTED_VARIANTS: 'Achtung! Wenn du bestätigst, wird für jede ausgewählte variante die maximale verfügbare menge festgelegt.',
      },
      DISCOUNT: {
        DISCOUNT_AMOUNT: 'Zusätzlicher rabatt',
        DESCRIPTION_COMMERCIAL_DISCOUNT: 'Dieser rabatt wird auf die ausgewählten artikel angewendet',
        DESCRIPTION_FINANCIAL_DISCOUNT: 'Dieser rabatt wird auf jeden artikel im warenkorb angewendet'
      },
      MODAL_EDIT_ORDERITEM: {
        EDIT_ORDER_ITEM: 'Artikel bearbeiten',
        ORDER_QTY: 'Bestellte menge',
        MAXIMUM_QUANTITY_AVAILABLE_FOR_THIS_VARIANT_ON_DATE: 'Maximale verfügbare menge für diese variante am datum',
        IS: 'ist:',
        YOU_ARE_BUYING_THIS_VARIANT_WHIT_BLANCK_CELL_OPTION: 'Du kaufst diese variante mit einer leeren zellenoption',
        MAX_AMOUNT_EXCEEDED: 'Maximalbetrag überschritten',
        MINIMUM_ONE_PIECE: 'Mindestens ein Stück',
        THE_QUANTITY_OF_THE_VARIANT_MUST_BE_A_MULTIPLE_OF: 'Die menge der variante muss ein vielfaches von sein:',
        THE_QUANTITY_ENTERED_IS_LESS_THAN_THE_MINIMUM_ALLOWED: 'Die eingegebene menge ist geringer als das mindestmaß',
        THE_MINIMUM_ORDER_QUANTITY_OF_THE_VARIANT_IS: 'Die Mindestbestellmenge der variante ist:',
        LOSE_CUSTOM_DELIVERY_DATES: 'Wenn du die Mengen in dieser Bestellzeile änderst, verlierst du die festgelegten benutzerdefinierten lieferdaten! Denke daran, diese beim bestellbestätigen erneut festzulegen!',
      },
      MODAL_ORDER_NAME_CHANGE: {
        CHANGE_ORDER_NAME: 'Bestellname ändern',
      },
      MODAL_HANDLE_DATE: {
        HANDLE_DATE_BUTTON: 'Daten verwalten',
        HANDLE_DATE: 'Verwalte das ursprüngliche lieferdatum auf den bestellpositionen',
        OVERWRITE_ORIGINAL_DATE: 'Verwende dieses datum, um das ursprüngliche lieferdatum auf den ausgewählten bestellpositionen zu überschreiben. Dadurch wird die verfügbarkeit der artikel basierend auf diesem neuen datum überprüft. Achtung! Wenn du dieses datum änderst, gehen alle benutzerdefinierten lieferdaten verloren!'
      },
      MODAL_SHIPPING_VARIANTS_DATE_: {
        LIST_VARIANTS_FROR_DELIVERY_DATE: 'Liste von varianten für das lieferdatum',
      },
      BUTTONS: {
        EDIT: 'Bestellinfo bearbeiten',
        ADD_DISCOUNT_FINANCIAL: 'Finanziellen rabatt hinzufügen',
        ADD_DISCOUNT_COMMERCIAL: 'Kommerziellen rabatt hinzufügen',
        REMOVE_DISCOUNT_FINANCIAL: 'Finanziellen rabatt entfernen',
        REMOVE_DISCOUNT_COMMERCIAL: 'Kommerziellen rabatt entfernen',
        DISCOUNT_OPTIONS: 'Rabattoptionen',
        CONFIRM_ORDER: 'Bestellung bestätigen',
        CONTINUE: 'Weiter einkaufen',
        DUPLICATE_CART: 'Warenkorb duplizieren',
        SAVE_NOTE: 'Notizen speichern',
        RENAME_ORDER: 'Bestellung umbenennen',
        REMOVE_CUSTOM_DATE: 'Benutzerdefiniertes datum entfernen',
        SKIP_AUTOMATIC_DISCOUNT: 'Automatische rabatte ignorieren',
        SKIP_CUSTOMER_DISCOUNT: 'Kundenrabatt ignorieren',
        ACTIVATE_AUTOMATIC_DISCOUNT: 'Automatische rabatte aktivieren',
        ACTIVATE_CUSTOMER_DISCOUNT: 'Kundenrabatt aktivieren',
        ACTIVATE_STORECHANNEL_DISCOUNT: 'Invincibile-rabatte aktivieren',
        SKIP_STORECHANNEL_DISCOUNT: 'Invincibile-rabatte ignorieren',
        OPTIONS_ITEMS: 'Artikeloptionen',
        REMOVE_ITEMS: 'Artikel entfernen',
        SET_MAXIMUM_QUANTITY: 'Maximale menge festlegen',
        COMMERCIAL_AGREEMENT: 'Kommerzielles abkommen',
        HANDLE_NOTE_BUTTON: 'Notizen verwalten',
        EDIT_ORDER_HEADER: 'Bestellheader bearbeiten',
      },
      MODAL_CONFIRMATION_MAIL: {
        TITLE: 'Bestätigungsmail senden',
        SEND: 'Senden',
        ACTIVATE_MAIL: 'Füge benutzerdefinierte empfänger ein',
        TO: 'An',
        CC: 'Cc',
        CCN: 'Bcc',
        TOOLTIP_MSG: 'Wenn du keine benutzerdefinierten empfänger einfügst, wird die bestätigungsmail an die standardadressen gesendet',
        ADD: 'Hinzufügen',
        SNACKBAR_MESSAGE: 'Die eingegebene adresse ist keine gültige e-mail adresse'
      },
      MODAL_ACTIVATE_AUTOMATIC_DISCOUNT: {
        TITLE: 'Automatische rabatte aktivieren',
        DESCRIPTION: 'Bist du sicher? Wenn du fortfährst, werden alle automatischen rabatte für den aktuellen warenkorb aktiviert.'
      },
      MODAL_ACTIVATE_CUSTOMER_DISCOUNT: {
        TITLE: 'Kundenrabatt aktivieren',
        DESCRIPTION: 'Bist du sicher? Wenn du fortfährst, wird der kundenrabatt für den aktuellen warenkorb aktiviert.'
      },
      MODAL_SKIP_AUTOMATIC_DISCOUNT: {
        TITLE: 'Automatische rabatte ignorieren',
        DESCRIPTION: 'Bist du sicher? Wenn du fortfährst, werden alle automatischen rabatte für den aktuellen warenkorb ignoriert.'
      },
      MODAL_SKIP_CUSTOMER_DISCOUNT: {
        TITLE: 'Kundenrabatt ignorieren',
        DESCRIPTION: 'Bist du sicher? Wenn du fortfährst, wird der kundenrabatt für den aktuellen warenkorb ignoriert.'
      },
      MODAL_ACTIVATE_STORECHANNEL_DISCOUNT: {
        TITLE: 'Invincibile-rabatte aktivieren',
        DESCRIPTION: 'Bist du sicher? Wenn du fortfährst, werden alle invincibile (store-channel) rabatte für den aktuellen warenkorb aktiviert.'
      },
      MODAL_SKIP_STORECHANNEL_DISCOUNT: {
        TITLE: 'Invincibile-rabatte ignorieren',
        DESCRIPTION: 'Bist du sicher? Wenn du fortfährst, werden alle invincibile (store-channel) rabatte für den aktuellen warenkorb ignoriert.'
      },
      SHOW_ONLY_UNAVAILABLE: 'Zeige nur Artikel mit einer Verfügbarkeit, die geringer ist als die angeforderte Menge',
      ADD_MANUAL_DISCOUNT_MANUAL: 'Manuellen rabatt in % eingeben',
      ADD_MANUAL_DISCOUNT_CALCULATED: 'Berechne basierend auf dem gewünschten retail-rabatt in %',
      ADD_MANUAL_DISCOUNT_CALCULATED2: 'Berechne basierend auf dem gewünschten wholesale-einzelpreis',
      ADD_MANUAL_DISCOUNT_CALCULATED3: 'Berechne basierend auf dem gewünschten marge in %',
      INSERT_PERCENTAGE: 'Prozent eingeben',
      INSERT_DESIRED_WHOLESALE: 'Gewünschten wholesale-preis eingeben',
      HIDE_CANCELLED: 'Abgebrochene bestellpositionen ausblenden',
      COMMERCIAL_DISCOUNT_APPLIED: 'Kommerzieller rabatt auf {{orderItemsCount}} {{itemsTranslation}} angewendet',
      ITEM: 'Position',
      ITEMS: 'Positionen',
      SOME_ORDERITEMS_HAS_NO_COST: 'Einige artikel im warenkorb haben keinen angegebenen preis, daher ist diese funktion nicht verfügbar',
      PENDING_OPERATION: 'Du kannst keine aktionen im warenkorb durchführen, da derzeit bestellpositionen über eine excel-datei hochgeladen werden.',
      CHOOSE_EXCEL_PROPS_TITLE: 'Wähle die Eigenschaften',
      CHOOSE_EXCEL_PROPS: 'Wähle die Spalten, die im excel-arbeitsblatt für bestellpositionen angezeigt werden sollen',
      CUSTOM_DATE: 'Benutzerdefiniertes datum',
      EDIT_CUSTOM_DATE: 'Datum anpassen',
      NO_CUSTOM_DATE: 'Kein benutzerdefiniertes datum',
      SELECTED_ITEMS: 'Ausgewählte bestellpositionen',
      ALERT_CART_SHIPPING_COST: 'Zu diesem warenkorb wird eine versandgebühr von <strong>{{shippingCost}}</strong> (zzgl. mwst.) berechnet; um kostenlose lieferung zu erhalten, musst du noch <strong>{{threshold}}</strong> hinzufügen.',
      ALERT_CART_SHIPPING_COST_NO_COST: 'Zu diesem warenkorb wird eine versandgebühr berechnet; um kostenlose lieferung zu erhalten, musst du noch <strong>{{threshold}}</strong> hinzufügen.',
      ALERT_CART_SHIPPING_COST_WITH_VOUCHER: 'Wenn du einen gutschein verwendest, werden keine versandkosten berechnet.',
      COLUMNS: {
        IMAGE: 'Bild',
        NAME: 'Spalten',
        SKU: 'Sku',
        COLOR: 'Farbe',
        COLOR_CODE: 'Farbcode',
        COLOR_NAME: 'Farbname',
        SIZE: 'Größe',
        UNIT_WHOLESALE: 'Wholesale einheit',
        UNIT_RETAIL: 'Retail einheit',
        GENDER: 'Geschlecht',
        UNIT_NET: 'Nettobetrag pro einheit',
        UNIT_COST: 'Kosten pro einheit',
        UNIT_MARGIN: 'Marge pro einheit',
        TOTAL_RETAIL: 'Gesamt retail',
        TOTAL_WHOLESALE: 'Gesamt wholesale',
        TOTAL_NET: 'Gesamt netto',
        TOTAL_COST: 'Gesamt kosten',
        TOTAL_MARGIN: 'Gesamt marge',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Rabatt vom retail',
        TOTAL_DISCOUNT_PERCENTAGE: 'Rabatt vom wholesale',
        CUSTOMER_DISCOUNT: 'Kundenrabatt',
        AGREEMENT_DISCOUNT: 'Rabatt gemäß vereinbarung',
        FINANCIAL_DISCOUNT: 'Finanzieller rabatt',
        STORECHANNEL_DISCOUNT: 'Invincibile rabatt',
        DISCOUNT_BY_QTY: 'Rabatt nach menge',
        DISCOUNT_BY_VALUE: 'Rabatt nach wert',
        COMMERCIAL_DISCOUNT: 'Kommerzieller rabatt',
        MARGIN_PERCENTAGE: 'Marge',
        QTY: 'Menge',
        EAN: 'EAN',
        SIZE_GROUP: 'Größengruppe',
        PRODUCT_CODE: 'Produktcode',
        PRODUCT_TITLE: 'Produktname',
        DATE: 'Datum',
        ORDERED_QTY: 'Bestellte menge',
        CANCELED_QTY: 'Stornierte menge',
        NOT_FULFILLED_QTY: 'Nicht erfüllte menge',
        FULFILLED_QTY: 'Erfüllte menge',
        FULFILLMENT_STATUS: 'Erfüllungsstatus',
        GROUP_GENERAL: 'Allgemein',
        GROUP_UNITARY: 'Pro einheit (€)',
        GROUP_TOTALS: 'Gesamt (€)',
        GROUP_PERCENT: 'Prozentual (%)',
        GROUP_FULFILLMENT: 'Erfüllung',
        STYLE_GROUP: 'Stilgruppe',
        NOTE: 'Notizen',
        CUSTOMIZATION_REQUEST: 'Personalisierungsanfrage',
      },
    },
    REGISTRATION: {
      WELCOME: 'Willkommen bei',
      REGISTER_NEW: 'Registriere eine neue',
      BACK_TO_HOME: 'Zurück',
      LOGOUT: 'Abmelden',
      CUSTOMER: 'Kunde',
      CUSTOMER_INFO: 'Kundendaten',
      AGENCY: 'Agentur',
      AGENCY_INFO: 'Agenturinformationen',
      INFO_SETUP: 'Füge allgemeine informationen hinzu',
      STEPPER: {
        REQUIRED_INFOTO_CREATE: 'Um einen neuen Kunden zu erstellen, ohne ihn an das ERP zu senden, sind folgende Informationen erforderlich: ',
        REQUIRED_INFOTO_CREATE2: 'Kontonummer (Tab: Kundeninfo), Firmenname (Tab: Kundeninfo), Bekannt als (Tab: Kundeninfo), Rechnungsadresse (Tab: Kundeninfo), Verwaltungs-E-Mail (Tab: Kundeninfo), mindestens ein Verkaufsstandort (Tab: Lieferadressen).',
        REQUIRED_INFOTO_CREATE3: 'Denke daran! Den Verkaufsstandort kannst du direkt aus den Rechnungsdaten erstellen, und er wird nicht im ERP dupliziert. Im Schritt Lieferadressen kannst du die Daten dann speichern.',
        ADD_NEW: 'Neu hinzufügen',
        CONTACT_INFO: 'Kontaktinformationen',
        ADD_CONTACT_INFO: 'Kontaktinformationen hinzufügen',
        PAYMENT_INFO: 'Zahlungsinformationen',
        ADD_PAYMENT_INFO: 'Zahlungsinformationen hinzufügen',
        POINT_OF_SALE: 'Verkaufsstellen',
        NEW_POINT_OF_SALE: 'Neue verkaufsstelle',
        ADD_POINT_OF_SALE: 'Verkaufsstelle hinzufügen',
        ENABLED_ONLINE_STORE: 'Aktivierte online-shops',
        USE_BILLING: 'Verwende rechnungsadresse',
        FINANCIAL_STATUS: 'Finanzstatus',
        COMPANY_FINANCIAL_STATUS: 'Finanzstatus des unternehmens',
        FINISH_REGISTRATION: 'Registrierung abschließen',
        FINISH_REGISTRATION_TEXT: 'Nachdem die registrierungsanfrage gesendet wurde, wird diese bearbeitet.',
        SEND_REGISTRATION_REQUEST: 'Registrierungsanfrage senden',
        NEXT_STEP: 'Nächster schritt',
        PREV_STEP: 'Vorheriger schritt',
        SEND_REQUEST: 'Anfrage senden',
        OWNER: 'Inhaber',
        OWNER_SUB: 'Inhaber des unternehmens',
        SEND_USER_INVITATION: 'Einladung per e-mail an den inhaber senden',
        POS_WITHOUT_STORE: 'Sie müssen jede verkaufsstelle für mindestens einen online-shop und einen entsprechenden kanal aktivieren',
        FORWARDED_REQUEST: 'Ihre anfrage wurde an den kundenservice weitergeleitet',
        USER: {
          EXISTING: 'Wählen sie einen bestehenden benutzer',
          NEW: 'Erstellen sie einen neuen benutzer',
          SELECT_USER: 'Benutzer auswählen',
          EXISTING_EMAIL: 'E-mail bereits vorhanden'
        }
      }
    },
    PRODUCT_DETAIL: {
      IMAGES_VISIBILITY_ACTION: 'Bilder dieses Produkts ausblenden',
      IMAGES_VISIBILITY_INFO: 'Wenn du diese Option aktivierst, werden die Bilder der Produktvarianten dem Kunden in keinem Bereich der App angezeigt (z. B. Produktliste, Detailseite oder Bestätigungsbildschirm). Diese Einstellung hat Vorrang vor der Sichtbarkeit, die für einzelne Variantenbilder konfiguriert wurde, und kann im Detail jeder Variante verwaltet werden.',
      IMAGES_VISIBILITY: 'Sichtbarkeit von Bildern',
      BACK_TO_PRODUCTS_LIST: 'Zurück zur produktliste',
      STYLE_CARD: 'Produktkarte',
      NAME: 'Name',
      CODE: 'Code',
      GENDER: 'Geschlecht',
      DESCRIPTION: 'Beschreibung',
      PRODUCT_DESCRIPTION: 'Produktbeschreibung',
      OPEN_IN_BULK: 'Im variationen-editor öffnen',
      COLOR: 'Farbe',
      COLORS: 'Farben',
      PCS_ORDERED: 'Stücke bestellt',
      SELECT_COLORS_AND_DATES: 'Farben auswählen, um Termine und Mengen anzuzeigen',
      ADD_CUSTOM_DELIVERY: 'Benutzerdefinierte lieferung hinzufügen',
      ADD_QTY: 'Menge hinzuf.',
      CUSTOM_ADD: 'Benutzerdefiniertes hinzufügen',
      SETTINGS_PRODUCT: 'Kaufeinstellungen',
      SETTING_BASICKUSTOM: 'BasicKustom einstellungen',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE: 'Um dieses produkt anpassbar zu machen, wählen sie eine referenz-palette aus',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE_WITH_PLAYERS: 'Setzen sie dieses flag, wenn sie dem benutzer die Möglichkeit geben möchten, spielerinformationen zu diesem produkt hinzuzufügen.',
      BUY_MULTIPLIER: 'Kauf-multiplikator für kanäle: {{channels}}',
      BUY_MINIMUM_PER_ORDER: 'Mindestkaufmenge (für erkaufskanäle, die dies erfordern)',
      ON_DATE: 'In dieser daten',
      ADD_ORDER_ITEMS: 'Artikel zur Bestellung hinzufügen',
      ORDER_ITEM_WITHOUT_WHOLESALE_PRICE: 'Achtung! Einige ausgewählte Varianten haben keinen definierten Großhandelspreis und können nicht hinzugefügt werden.',
      VARIANTS: {
        NAME: 'Varianten',
        COLUMNS: {
          VARIANT: 'Variante',
          QTY: 'Menge',
          NEW_QTY: 'Neue menge',
          SKU: 'Sku',
          WHOLE_SALE: 'Großhandel',
          RE_ORDER: 'Wiederbestellung',
          PRE_ORDER: 'Vorbestellung',
        }
      },
      IMPORT_STATUS: {
        NAME: 'Importstatus',
        START: 'Start',
        END: 'Ende',
        ERROR: 'Es ist der folgende fehler aufgetreten: ',
        RESTART_IMPORT: 'Import neu starten',
        MODAL_TEXT: 'Achtung! alle Änderungen an diesem produkt und seinen varianten gehen verloren. Bist du sicher?',
        RETAIL_DISCOUNT_PERCENTAGE: '% Rabatt vom einzelhandelspreis',
        LAST_RETAIL_DISCOUNT_PERCENTAGE: 'Letzter verwendeter einzelhandelsrabatt'
      },
      MODAL_DELETE: {
        ARE_YOU_SURE: 'Bist du sicher?',
        ARE_YOU_SURE_TO_REMOVE_STOCK_LIMIT: 'Bist du sicher, dass du das lagerbestandslimit entfernen möchtest?',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_PRE_ORDER: 'Bist du sicher, dass du das mindest-vorbestelllimit entfernen möchtest?',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_RE_ORDER: 'Bist du sicher, dass du das mindest-wiederbestelllimit entfernen möchtest?',
        ARE_YOU_SURE_TO_REMOVE_ALL_LIMITS: 'Bist du sicher, dass du alle limits entfernen möchtest?',
        FOR: 'für',
        STYLE_COLOR: 'Farbe?',
        STYLE_COLORS: 'Farben?',
      },

      SETTINGS_LIMIT: 'Einstellungen der beschränkungen',
      SETTING_STOCK_LIMIT: 'Einstellungen des bestandslimits',
      SETTING_MINIMUM_PRE_ORDER: 'Einstellungen des mindestvorbestells',
      SETTING_MINIMUM_RE_ORDER: 'Einstellungen des mindestnachbestells',
      ADD_OR_EDIT_STOCK_LIMIT: 'Bestandslimit hinzufügen/bearbeiten',
      ADD_OR_EDIT_MINIMUM_PRE_ORDER: 'Mindestvorbestellmenge hinzufügen/bearbeiten',
      ADD_OR_EDIT_MINIMUM_RE_ORDER: 'Mindestnachbestellmenge hinzufügen/bearbeiten',
      REMOVE_STOCK_LIMIT: 'Bestandslimit entfernen',
      REMOVE_MINIMUM_PRE_ORDER: 'Mindestvorbestellmenge entfernen',
      REMOVE_MINIMUM_RE_ORDER: 'Mindestnachbestellmenge entfernen',
      REMOVE_ALL_LIMITS: 'Alle beschränkungen entfernen',
      MODAL_LIMIT: {
        STOCK_LIMIT: 'Bestandslimit',
        MINIMUM_QTY_PRE_ORDER: 'Mindestvorbestellmenge',
        MINIMUM_QTY_RE_ORDER: 'Mindestnachbestellmenge',
        SETTING_STOCK_LIMIT: 'Einstellungen des bestandslimits',
        SETTING_MINIMUM_PRE_ORDER: 'Einstellungen des mindestvorbestells',
        SETTING_MINIMUM_RE_ORDER: 'Einstellungen des mindestnachbestells',
        LIMIT_ENABLED_FOR_CHANNELS: 'Limit aktiviert für kanäle: {{channels}}',
        THE_QUANTITY_INSERTED_IS_NOT_VALID_MINIMUM_VALUE_IS_TWO: 'Die eingegebene menge ist ungültig, der mindestwert ist 2',
      },
    },
    PRODUCT_AND_VARIANT: {
      REORDER: 'Neu bestellen',
    },
    TAG_MANAGER: {
      NAME: 'Tag-Manager',
    },
    MEDIA_CONTAINER: {
      START_SYNC: 'Bilder-Sync starten',
      NAME: 'Medien',
      VISIBLE_IMAGE: 'Sichtbares bild',
      SET_AS_COVER: 'Als cover festlegen',
      NO_MEDIA_TO_VIEW: 'Keine medien zum anschauen',
      UPLOAD_MEDIA: 'Medien hochladen',
      SHOW_ALL_MEDIA: 'Alle medien anzeigen',
      HIDE_ALL_MEDIA: 'Alle medien ausblenden',
    },
    BULK_MEDIA_EDIT: {
      SHOW: 'Anzeigen',
      HIDE: 'Ausblenden',
      INFO: 'Alle medien anzeigen oder ausblenden (produkt und varianten)',
      NO_PRODUCT_SELECTED: 'Kein produkt ausgewählt',
      MESSAGE_SUCCESS_HIDE_1: 'Alle bilder der ausgewählten produkte wurden unsichtbar gemacht',
      MESSAGE_SUCCESS_VISIBILE_1: 'Alle bilder der ausgewählten produkte wurden sichtbar gemacht',
      MESSAGE_SUCCESS_VISIBILE_2: 'Alle bilder des produkte und seiner varianten wurden sichtbar gemacht',
      MESSAGE_SUCCESS_HIDE_2: 'Alle bilder des produkte und seiner varianten wurden unsichtbar gemacht',
    },
    VARIANT_DETAIL: {
      BACK_TO_PRODUCT_DETAIL: 'Zurück zur produktdetailseite',
      VARIANT: 'Variante',
      SELECT_VARIANT: 'Variante auswählen',
      COLOR: 'Farbe',
      SIZE: 'Größe',
      SKU_CODE: 'SKU-Code',
      EAN_CODE: 'EAN-Code',
      AVAILABLE_QTY: 'Verfügbare menge',
      COST: 'Kosten',
      BLANK_CELLS_SETTINGS: 'Einstellungen für leere zellen',
      BLANK_CELLS_END_DATE: 'Enddatum leere zellen',
      BLANK_CELLS_DELIVERY_DATE: 'Lieferdatum leere zellen',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Wähle die tiers aus, für die das produkt verfügbar ist:',
      EXTERNAL_COLLECTIONS_ID: 'Externe kollektionen-id',
      FROM: 'Von',
      TO: 'Bis',
      DETAIL: 'Detail',
      LABELS: 'Etiketten',
      PURPOSES: 'Zwecke',
      TEAMS: 'Teams',
      CATEGORIES: 'Kategorien',
      PRICING: 'Preise',
      RE_ORDER: 'Re-order',
      PRE_ORDER: 'Pre-order',
      WHOLE_SALE_PRICE_NO_VAT: 'Großhandelspreis (ohne MwSt.)',
      SUGGESTED_RETAIL_PRICE_VAT: 'Unverbindlicher verkaufspreis (inkl. MwSt.)',
      PERCENTAGE_DISCOUNT_OF_RETAIL: '% Rabatt auf UVP',
    },
    VISIBILITY: {
      NNAME: 'Sichtbarkeit',
      PUBLISH_ON_PRE_ORDER: 'Bei pre-order veröffentlichen',
      PUBLISH_ON_RE_ORDER: 'Bei re-order veröffentlichen',
      BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Automatische veröffentlichung bei re-order blockieren',
      AUTOMATIC_PUBLISH_DESCRIBE: 'Wenn deaktiviert, wird die variante automatisch veröffentlicht, sobald eine re-order-menge verfügbar ist'
    },
    ASSORTMENT_DETAIL: {
      NAME: 'Sortiment',
      BACK_TO_ASSORTMENTS: 'Zurück zu den sortimenten',
      ASSORTMENT_CARD: 'Sortimentskarte',
      ASSORTMENT_NAME: 'Name',
      ID: 'ID',
      EDIT_ORDER: 'Reihenfolge bearbeiten',
      DESCRIPTION: 'Beschreibung (optional)',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Wähle die tiers aus, für die das sortiment verfügbar ist:',
      CHANNEL: 'Kanal',
      SELECT_THE_CHANNEL_FIRST: 'Bitte zuerst einen kanal auswählen',
      CHANNEL_DESCRIPTION: 'Wähle die kanäle aus, für die das sortiment verfügbar ist:',
      INCLUDE_PRODUCTS: {
        NAME: 'Produkte einbeziehen',
        MANUAL: 'Manuell (statisch)',
        AUTOMATED: 'Automatisch (dynamisch)',
        PROPERTY: {
          CODE: 'Code',
          SIZE: 'Größe',
          COLOR: 'Farbe',
          TIER: 'Tier',
          PRICE: 'Preis',
          BRAND: 'Marke',
          GENDER: 'Geschlecht',
          SEASON: 'Saison',
          TAG: 'Tag',
          CATEGORY: 'Kategorie',
          LABEL: 'Label',
          EXTERNAL_COLLECTION_ID: 'Externe kollektion-id',
          PRODUCT_CODE: 'Produktcode',
        },
        OPERATOR: {
          EQUALS: 'Gleich',
          NOT_EQUALS: 'Ungleich',
          GREATER_THAN: 'Größer als',
          LESS_THAN: 'Kleiner als',
          GREATER_OR_EQUAL: 'Größer oder gleich',
          LESS_OR_EQUAL: 'Kleiner oder gleich',
          CONTAINS: 'Enthält',
          NOT_CONTAINS: 'Enthält nicht',
          STARTS_WITH: 'Beginnt mit',
          ENDS_WITH: 'Endet mit',
        },
        GENDER: {
          MAN: 'Mann',
          WOMAN: 'Frau',
          UNISEX: 'Unisex'
        }
      },
      ASSORTMENT_PRODUCTS: 'Sortimentsprodukte',
      ASSORTMENT_INFO_1: 'Die reihenfolge in dieser liste beeinflusst, wie die produkte in der 4Shop-produktliste angezeigt werden.',
      ASSORTMENT_INFO_2: 'Um die reihenfolge der produkte zu ändern, musst du zuerst die Änderungen an den sortimentsvarianten speichern, einschließlich der automatischen regeln.',
      UNDO_PRODUCTS_ORDER: 'Produkte-reihenfolge zurücksetzen',
      SAVE_PRODUCTS_ORDER: 'Produkte-reihenfolge speichern',
      FEATURED: 'Hervorgehoben',
    },
    AUTOMATED_INCLUDES: {
      ALL_CONDITION: 'Alle bedingungen',
      ANY_CONDITION: 'Beliebige bedingung',
      PROPERTY: 'Eigenschaft',
      OPERATOR: 'Operator',
      VALUE: 'Wert',
    },
    BULK_EDITOR_DETAIL: {
      CHOOSE_PROPS: 'Wähle die eigenschaften aus, die bearbeitet werden sollen',
      BACK_TO_SELECT_VARIANTS: 'Zurück zur variantenauswahl',
      EDIT_INFO: 'Du kannst mehrere varianten gleichzeitig bearbeiten, indem du sie auswählst. Halte die umschalttaste gedrückt, um gruppen von varianten schneller auszuwählen.',
      COLUMNS: {
        COLOR: 'Farbe',
        SIZE: 'Größe',
        SKU: 'SKU',
        RE_ORDER: 'Nachbestellung',
        PRE_ORDER: 'Vorbestellung',
        AUTO_RE_ORDER: 'Automatische nachbestellung sperren',
        BLANK_CELLS_END: 'Enddatum für leere Zellen',
        BLANK_CELLS_DELIVERY: 'Lieferdatum für leere zellen',
        TAGS: 'Tags',
        TIERS: 'Stufen',
        PRICES: 'Preise',
      },
    },
    SUPER_BULK_EDITOR_DETAIL: {
      CREATE_OPERATION: 'Operation erstellen',
      MANUAL_CODE: 'Manuell',
      AUTO_CODE_BY_ASSORTMENT: 'Nach sortiment',
      LIST_OPERATION: 'Operationenliste',
      SELECT_THE_TYPE_OF_CODE: 'Wählen sie den codetyp aus',
      SELECT_TYPE_OF_CODE_DESC: 'In diesem abschnitt wählen sie den typ der codes aus, die sie eingeben möchten, um die liste der varianten zu erhalten, auf die die operationen angewendet werden sollen',
      BEFORE_SELECT_THE_TYPE_OF_CODE: 'Wählen sie zuerst den codetyp aus',
      INSERT_CODES: 'Codes eingeben',
      INSERT_CODES_DESC: 'In diesem abschnitt geben sie eine liste von codes entsprechend dem zuvor ausgewählten typ ein, getrennt durch ";" oder jeweils einen code pro zeile',
      REPORT_VALIDATION: 'Validierungsbericht',
      BEFORE_INSERT_CODES_AND_VALIDATED: 'Geben sie zuerst die codes ein und validieren sie',
      TOTAL_VARIANTS_INVOLVED: 'Gesamtanzahl der betroffenen varianten',
      CREATE_OPERATION_DESC: 'In diesem abschnitt wählen sie die operation aus, die auf die liste der betroffenen varianten angewendet werden soll',
      SELECT_OPERATION: 'Operation auswählen',

      CODE_TYPE: {
        BASIC_COLLECTION: 'Kollektion',
        PRODUCT_CODE: 'Produktcode',
        PRODUCT_TEAM: 'Produktteam',
        PRODUCT_COLOR: 'Produktfarbe',
        SKU_CODE: 'SKU-Code',
      },

      CODE_TYPE_TOOLTIP: {
        BASIC_COLLECTION: 'Basis-Kollektion-ID, z. B. 12345',
        PRODUCT_CODE: 'Produktcode, die ersten 7 Zeichen des SKU-Codes, z. B. 35124DW',
        PRODUCT_TEAM: 'Produktteam-Code, die ersten 10 Zeichen des SKU-Codes, z. B. 35124DWACF oder 35124DW***',
        PRODUCT_COLOR: 'Produktfarbcode, die ersten 13 Zeichen des SKU-Codes, z. B. 35124DW***A00 oder 35124DW A00',
        SKU_CODE: 'SKU-Code, z. B. 35124DW***A00L***** oder 35124DW A00L',
      },

      REPORT_VALIDATION_MODAL: {
        TITLE: 'Validierungsbericht',
        VALIDATING: 'Validierung läuft...',
        ALERT_MESSAGE: 'Einige der eingegebenen codes sind ungültig ({{numberOfCodesInvalid}}). Um fortzufahren, entfernen oder korrigieren sie diese',
      },

      COLUMNS: {
        CODE: 'Code',
        VARIANTS_NUMBER: 'Anzahl varianten',
        STATUS: 'Status',
        INSERTED: 'Eingefügt',
        INTERPRETED: 'Interpretiert',
      },
      BUTTONS: {
        EDIT_CODES: 'Codes bearbeiten',
        UNDO_EDITS: 'Änderungen rückgängig machen',
        ADD_ROW: 'Zeile hinzufügen',
        VALIDATE: 'Validieren',
      },

      ALERT: {
        NO_VARIANTS_FOUND_PLEASE_CHECK_THE_CODES: 'Keine varianten gefunden, bitte überprüfen sie die eingegebenen codes',
        OPERATION_CREATED_SUCCESSFULLY: 'Vorgang #{{operationId}} erfolgreich erstellt',
      },

      OPERATION_LABELS: {
        VISIBLE_IN_RE_ORDER: 'Sichtbar in re-Order',
        VISIBLE_IN_PRE_ORDER: 'Sichtbar in pre-Order',
        BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Automatische veröffentlichung bei re-Order blockieren',
        BLANK_CELLS_END_DATE: 'Enddatum leere zellen',
        BLANK_CELLS_DELIVERY_DATE: 'Lieferdatum leere zellen',
        INCLUDE_IN_TIER: 'In tier einbeziehen',
        EXCLUDE_FROM_TIER: 'Aus tier ausschließen',
        INCLUDE_IN_ASSORTMENT: 'In Sortiment aufnehmen',
        EXCLUDE_FROM_ASSORTMENT: 'Aus Sortiment ausschließen',
        INCLUDE_IN_PROMOTION: 'Inaktion einbeziehen',
        EXCLUDE_FROM_PROMOTION: 'Ausaktion ausschließen',
        PALETTES_STOCK_LIMITS: 'Bestandslimit festgelegt: ',
      },

      DETAIL_OPERATION_MODAL: {
        TITLE: 'Vorgangsdetails #{{operationId}}',
        MESSAGE: 'Die <strong>Operation #{{operationId}}</strong>, erstellt von <strong>{{userName}}</strong> am <strong>{{date}}</strong>, befindet sich im status: <strong>{{status}}</strong>',
        OPERATION_REQUESTED: 'Angeforderte operation: ',
        ERROR_FOUND: 'Festgestellter fehler: ',
        ERRORS_FOUND: 'Festgestellte fehler: ',

        COLUMNS: {
          VARIANT_SKU: 'Variante SKU',
          ERRORS: 'Fehler',
        },
      },
    },
    SUPPORT_BUTTON: {
      LABEL: 'ASSISTENZA',
      TITLE: 'Füllen sie die felder aus, um eine supportanfrage zu senden',
      SUCCESS_MESSAGE: 'Anfrage erfolgreich gesendet!',
      OBJECT: 'Betreff',
      MESSAGE_BODY: 'Nachricht',
      BROWSE_FILE: 'Durchsuchen...',
      FEEDBACK_MESSAGE_0: 'Ticket erstellt mit der kennung #',
      FEEDBACK_MESSAGE: 'Wir werden auf die anfrage per e-mail an',
      SEND_REQUEST: 'Anfrage senden',
      CHOOSE_FILE: 'Datei auswählen',
    },
    PROMOTION_DETAIL: {
      NAME: 'Automatischer rabatt',
      EVALUATE_REQUIREMENTS_CONSIDERING_ENTIRE_ORDER: 'Bewerte anforderungen unter berücksichtigung der gesamten bestellung',
      NEW_PROMOTION: 'Neuer automatischer rabatt',
      BACK_TO_PROMOTIONS: 'Zurück zu den automatischen rabatten',
      PROMOTION_NAME: 'Name',
      CODE: 'Code',
      VALIDITY: 'Gültigkeit',
      VALID_FROM: 'Gültig von',
      VALID_UNTIL: 'Gültig bis',
      VALID_ON: 'Gültig auf',
      REQUIREMENTS_AND_DISCOUNT: 'Anforderungen und rabatt',
      MINIMUM_QUANTITY: 'Mindestmenge',
      MINIMUM_VALUE: 'Mindestwert',
      FROM: 'Von',
      TO: 'Bis',
      DISCOUNT: 'Rabatt',
      INCLUDE_VARIANTS: 'Varianten einbeziehen',
      INCLUDED_VARIANTS: 'Eingeschlossene varianten',
      MESSAGE: 'Einige varianten können nicht ausgewählt werden, da sie bereits in einer anderen promotion dieses typs enthalten sind',
      VARIANTS: 'Varianten',
      ERROR_APPLICATION_RANGE: {
        RANGE_IS_INCORRECT_FROM_MUST_BE_LESS_THAN_TO: 'Der bereich ist ungültig, "von" muss kleiner als "bis" sein',
        THE_INTERVAL_OVERLAPS_WITH_ANOTHER_INTERVAL: 'Der bereich überschneidet sich mit einem anderen bereich',
        THE_VALUE_FRO_THE_DISCOUNT_MUST_BE_BETWEEN_1_AND_100: 'Der rabattwert muss zwischen 1 und 100 liegen',
        THE_VALUE_FOR_TO_MUST_BE_GREATER_THAN_0_OR_EMPTY: 'Der wert für "bis" muss größer als 0 oder leer sein',
      },
      INFO_APPLICATION_RANGE: {
        THIS_INPUT_WHITEOUT_VALUE_WILL_BE_CONSIDERED_AS_INFINITY: 'Dieses feld ohne wert wird als unendlich betrachtet',
      },
    },
    VOUCHER_DETAIL: {
      NAME: 'Gutschein',
      NEW_VOUCHER: 'Neuer gutschein',
      NEW_VOUCHER_FOR: 'Neuer gutschein für',
      BACK_TO_VOUCHERS: 'Zurück zu den gutscheinen',
      VOUCHER_NAME: 'Name',
      VALIDITY: 'Gültigkeit',
      CUSTOMER_TO_APPLY: 'Kunden, denen der gutschein zugewiesen werden soll',
      CUSTOMER_APPLIED: 'Kunden, denen der gutschein zugewiesen wurde',
      ADD_CUSTOMER: 'Kunde hinzufügen',
      CUSTOMER: 'Kunde',
      SELECTED: 'Ausgewählt',
      DESELECT_ALL: 'Alle abwählen',
      NO_CUSTOMER_SELECTED: 'Kein kunde ausgewählt',
      EXPIRED_VOUCHER: 'Der ausgewählte gutschein ist abgelaufen!',
      EDIT_DESCRIPTION: 'Beschreibung bearbeiten',
      RESIDUAL_AMOUNT: 'Restbetrag',
      SELECT_AT_LEAST_ONE_CUSTOMER: 'Mindestens einen kunde auswählen',
      FILL_IN_ALL_REQUIRED_FIELDS: 'Alle pflichtfelder ausfüllen',
      CHANGE_VOUCHER: 'Gutschein ändern',
      APPLICABLE_AS_PARTIAL_PAYMENT: 'Als teilzahlung anwendbar',
      APPLICABLE_AS_PARTIAL_PAYMENT_MESSAGE: 'Wenn aktiviert, kann der gutschein auch dann auf eine bestellung angewendet werden, wenn der restbetrag nicht den gesamten rabattierten grosshandelswert der bestellung abdeckt.',
    },
    ASSIGN_VOUCHER: {
      SELECT_VOUCHER: 'Wählen sie den gutschein aus, den sie auf die bestellung anwenden möchten',
      SELECTION_MESSAGE: 'Durch anwendung dieses gutscheins beträgt der bestellwert ',
    },
    AGENCY_DETAIL: {
      TABS: {
        SUMMARY: 'Zusammenfassung',
        CHECK_IN: 'Check-in',
        CUSTOMERS: 'Kunden',
        ORDERS: 'Bestellungen',
        AGENTS: 'Vertreter',
      },
      PLEASE_INSERT_AGENCY_CODE_FOR_ALL_ACTIVE_STORES: 'Bitte geben sie den agenturcode für alle aktiven filialen ein',
      AGENCY_CODES: 'Agenturcodes',
      BACK_TO_AGENCIES: 'Zurück zu den agenturen',
      AGENCY_INFORMATION: 'Agenturinformationen',
      VAT: 'USt-IdNr.',
      FISCAL_CODE: 'Steuernummer',
      AGENCY_CODE: 'Agenturcode',
      AGENCY_NAME: 'Agenturname',
      AGENCY_FORM: 'Agenturform',
      CANT_EDIT: {
        MESSAGE: 'Sie können die agenturinformationen nicht bearbeiten, da sie auf genehmigung warten!',
      },
      SEND_TO_ERP: 'An ERP senden',
      CONTACT_INFO: 'Kontaktinformationen',
      MODAL_ERP: {
        ARE_YOU_SURE: 'Sind sie sicher?',
        ARE_YOU_SURE_YOU_WANT_TOSEND_TO_ERP: 'Sind sie sicher, dass sie an ERP senden möchten?',
        SEND: 'Senden',
      }
    },
    ADDRESS_INFO: {
      SEARCH: 'Suchen',
      ADDRESS: 'Adresse',
      ALTERNATIVE_ADDRESS: 'Alternative adresse',
      LABEL: 'Adresse suchen',
      BILLING_LABEL: 'Rechnungsadresse suchen',
      STREET: 'Straße',
      NUMBER: 'Hausnummer',
      COUNTRY: 'Land',
      PROVINCE: 'Provinz',
      CITY: 'Stadt',
      ZIP_CODE: 'PLZ',
    },
    CONTACT_INFO: {
      DELETE_MODAL: {
        ARE_YOU_SURE: 'Sind sie sicher?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Sind sie sicher, dass sie diesen Kontakt löschen möchten?',
        DELETE: 'Löschen',
      },

      ADD_MODAL: {
        TITLE: 'Kontakt hinzufügen',
        TYPE: 'Typ',
      },

      EDIT_MODAL: {
        TITLE: 'Kontakt bearbeiten',
      },

      CONTACT_TYPE: {
        ADMINISTRATIVE: 'Verwaltung',
        COMMERCIAL: 'Geschäftlich',
        EMAIL: 'E-mail',
        PEC: 'PEC',
        PHONE: 'Telefon',
        FAX: 'Fax',
        MOBILE: 'Handy',
        WEBSITE: 'Webseite',
        SOCIAL: 'Soziale medien',
        FACEBOOK: 'Facebook',
        TWITTER: 'Twitter',
        INSTAGRAM: 'Instagram',
        LINKEDIN: 'LinkedIn',
      }
    },
    CUSTOMER_DETAIL: {
      BACK_TO_CUSTOMERS: 'Zurück zu den kunden',
      TABS: {
        SUMMARY: 'Übersicht',
        CHECK_IN: 'Check-in',
        LOCATIONS: 'Adressen',
        ORDERS: 'Bestellungen',
        DISCOUNTS: 'Rabatte',
        USERS: 'Benutzer',
        VOUCHERS: 'Gutscheine',
        SETTINGS: 'Einstellungen',
      },

      ALLERT: {
        MESSAGE: 'Du kannst die kundeninformationen nicht bearbeiten, da sie auf genehmigung warten!',
      },

      SEND_TO_ERP: 'An ERP senden',

      CARDS: {
        COMPANY_INFO: 'Unternehmensinformationen',
        CONTACT_INFO: 'Kontaktinformationen',
        COMPANY_FINANCIAL_STATUS: 'Finanzstatus',
        PAYMENT_INFO: 'Zahlungsinformationen',
        COMMERCIAL_AGREEMENT: 'Handelsvereinbarung',
        CUSTOMER_DISCOUNT: 'Kundenrabatt',
        CUSTOMER_COMMERCIAL_BLOCK: 'Administrativer kundenblock',
        BASIC_KUSTOM_DISCOUNT: 'Grundlegender Kustom-Rabatt',
      },

      STATUS: {
        COMPLETED: 'Abgeschlossen',
        NOT_COMPLETED: 'Nicht abgeschlossen',
      },

      MODAL_ERP: {
        ARE_YOU_SURE_YOU_WANT_TO_SEND_TO_ERP: 'Sind sie sicher, dass sie an das ERP senden möchten?',
        MESSAGE: 'Durch die bestätigung des stammdatensatzes wird dieser gespeichert und an das ERP übermittelt',
        SEND: 'Senden',
      },

      MODAL_SAVE: {
        ARE_YOU_SURE: 'Sind sie sicher?',
        MESSAGE: 'Achtung! wenn sie die Änderung am kunden speichern, wird der status auf „Zur Freigabe“ gesetzt',
      },

      COMPANY_INFO: {
        PREFIX_VAT: 'USt. präfix',
        VAT_WHITHOUT_PREFIX: 'USt.-Nr. ohne präfix',
        FISCAL_CODE: 'Steuernummer',
        COMPANY_NAME: 'Firmenname',
        AUTOCOMPLETE: 'Autovervollständigung',
        COMPANY_FORM: 'Unternehmensform',
        COMPANY_CATEGORIES: 'Unternehmenskategorien',
        ITALIAN_DIGITAL_INVOICING_SYSTEM: 'Italienisches elektronisches rechnungssystem',
        SDI_CODE: 'SDI code',
        OFFICE_PA_CODE: 'PA code',
        PEC_EMAIL: 'PEC email',
        ERROR_YOU_CAN_NOT_ENTER_BOTH_PA_CODE_AND_SDI_CODE: 'Sie können nicht gleichzeitig den PA code und den SDI code eingeben',
        ERROR_CODE_MUST_BE_ALPHANUMERIC_CHARACTERS_WITHOUT_SPACES_AND_SPECIAL_CHARACTERS: 'Der Code {{codeName}} muss aus {{numCharacters}} alphanumerischen zeichen ohne leerzeichen und sonderzeichen bestehen',
      },

      FINANCIAL_STATUS: {
        ENTERPRISE_BOOL: 'Aktives unternehmen',
        MASTER_DATA_BOOL: 'Korrekte stammdaten',
        ACTIVITY_BOOL: 'Konforme tätigkeit',
        REQUEST_NEW_REPORT: 'Neuen bericht anfordern',
        NO_DATA_TO_SHOW: 'Kein vorhandener Bericht, fordere einen neuen Bericht an, indem du auf die Schaltfläche unten klickst',
        COLUMNS: {
          DATE: 'Datum',
          CLASS: 'Klasse',
          RISK_DESCRIPTION: 'Risikobeschreibung',
          CREDIT_LIMIT: 'Kreditlimit',
          SCORE: 'Punktzahl',
          REPORT: 'Bericht',
        },
        REFRESH_MODAL: {
          ARE_YOU_SURE: 'Sind sie sicher?',
          EACH_REFRESH_HAS_A_COST: 'Jede aktualisierung verursacht kosten',
          REFRESH: 'Aktualisieren',
        },
        PRINT: 'Drucken',
        SHARE: 'Teilen',
        VIEW_REPORT: 'Bericht anzeigen',
      },

      PAYMENT_INFO: {
        CHANNEL_PAYMENTS_TERM_INFO: 'Hier kannst du für jeden vertriebskanal eine spezifische zahlungsbedingung hinzufügen. Wenn keine zahlungsbedingung für einen kanal angegeben wird, wird die standard-zahlungsbedingung verwendet.',
        ADD_PAYMENT_TERM: 'Zahlungsbedingung hinzufügen',
        CHANNEL_PAYMENTS_TERM: 'Zahlungsbedingungen pro Kanal',
        PAYMENT_TERM: 'Zahlungsbedingungen',
        DEFAULT_PAYMENT_TERM: 'Standard zahlungsbedingung',
        CHANNEL: 'Kanal',
        BANCK_INFO: 'Bankinformationen',
        ABI: 'ABI',
        CAB: 'CAB',
        SWIFT: 'SWIFT',
      },

      COMMERCIAL_AGREEMENT: {
        COMMERCIAL_ALLOWANCE: 'Handelsausgabe',
      },

      COMMERCIAL_BLOCK: {
        COMMERCIAL_BLOCK: 'Verwaltungssperre',
        INFO: 'Wenn die verwaltungssperre für den kunden aktiviert ist, können nur benutzer mit der rolle storeOwner, storeUser und admin den warenkorb bestätigen.',
        BLOCKED_BY: 'Gesperrt von: {{name}}',
        ALERT_COMMERCIAL_BLOCK_FROM_ERP: 'Diese verwaltungssperre wurde vom ERP übernommen',
      },
    },
    STATUS_LABLE: {
      CREATED_ON: 'Erstellt am',
      BY: 'Von',
      LAST_UPDATE_ON: 'Letzte aktualisierung am',
      STATUS: 'Status',
      FOR_CURRENT_STORE: 'für den aktuellen store',
    },
    STATUS: {
      ALL: 'Alle',
      ENABLED: 'Aktiv',
      GOK: 'GOK',
      IS_DIRECT: 'Direktbestellung',
      NOT_GOK: 'Nicht GOK',
      VALID: 'Gültig',
      INVALID: 'Ungültig',
      TOAPPROVE: 'Zur genehmigung',
      APPROVED: 'Genehmigt',
      APPROVED_BY_REQUESTING_USER: 'Genehmigt vom anfordernden benutzer',
      APPROVED_GRAPHICALLY: 'Grafisch genehmigt',
      REJECTED: 'Abgelehnt',
      COMMERCIALBLOCKED: 'Gesperrt',
      BLOCKED: 'Gesperrt',
      PARTIALLY_FULFILLED: 'Teilweise erfüllt',
      ONHOLD: 'In warteschleife',
      BILLING: 'Abrechnung',
      SHIPPING: 'Versand',
      CUSTOMER: 'Kunde',
      AGENCY: 'Agentur',
      ADMIN: 'Verwaltung',
      UNASSIGNED: 'Nicht zugewiesen',
      ACTIVE: 'Aktiv',
      INVITED: 'Eingeladen',
      DISABLED: 'Deaktiviert',
      DRAFT: 'Entwurf',
      DRAFT_WITHOUT_NOTIFICATION: 'Entwurf ohne Benachrichtigung',
      DRAFT_WITH_NOTIFICATION: 'Entwurf mit Benachrichtigung',
      CREATED: 'Erstellt',
      CONFIRMED: 'Bereit zur erfüllung',
      FAILED: 'Fehlgeschlagen',
      RE_ORDER: 'Wiederbestellung',
      RESTOCK: 'Nachbestellung',
      ITEMEXCHANGE: 'Warenumtausch',
      PRE_ORDER: 'Vorbestellung',
      BY_VALUE: 'Nach wert',
      BY_QUANTITY: 'Nach menge',
      BOTH: 'Beides',
      EXTERNAL_ID: 'Externe ID',
      UNCONSTRAINED: 'Unbeschränkt',
      BY_ORDER_TOTAL_AMOUNT: 'Mindestbestellwert',
      BY_ORDER_TOTAL_QUANTITY: 'Mindestbestellmenge',
      DELIVERED: 'Geliefert',
      SHIPPED: 'Versendet',
      PENDING: 'Ausstehend',
      CANCELLED: 'Storniert',
      CONCLUDED: 'Abgeschlossen',
      PARTIAL: 'Teilweise',
      EXPIRED: 'Abgelaufen',
      INACTIVE: 'Inaktiv',
      AWAITING_PROCESSING: 'Wartet auf bearbeitung',
      PROCESSING: 'In bearbeitung',
      PROCESSED: 'Bearbeitet',
      PROCESSED_WITH_ERRORS: 'Bearbeitet mit fehlern',
      PROCESSED_WITH_ISSUES: 'Bearbeitet mit Problemen',
      PROCESSING_FAILURE: 'Verarbeitungsfehler',
      ARCHIVED: 'Archiviert',
      SYNCING: 'Synchronisierung',
      SINGLE_ORDER: 'Einzelbestellung',
      MULTIPLE_ORDERS: 'Mehrere Bestellungen'
    },
    CHANGES_HANDLER: {
      DATE_UNSAVE_CHANGES: 'Änderungen wurden nicht gespeichert',
      UNDO: 'Rückgängig',
      SAVE: 'Speichern',
      IF_YOU_HAVE_PENDING_CHANGES_YOU_WILL_LOSE_THEM: 'Wenn sie ausstehende Änderungen haben, gehen diese verloren',
    },
    CART: {
      ERROR_DIALOG: {
        TITLE: 'Artikel nicht verfügbar',
        UPDATE_DATES: 'Daten aktualisieren',
        UPDATE_DATES2: 'Daten aktualisieren und nicht verfügbare varianten entfernen',
        UPDATE_DATES3: 'Nur daten aktualisieren',
        UPDATE_DATES4: 'Daten aktualisieren und nicht verfügbare varianten entfernen',
        INVALID_DATES: 'Ungültige daten',
        VARIANT_UNAVAILABLE: 'Variante nicht verfügbar',
        DELETE_ITEMS: 'Nicht verfügbare entfernen',
        LIMIT: 'Limit',
        STOCK_QTY: 'Bestand menge',
        ORDERED_QTY: 'Bestellte menge',
        AVAILABLE_QTY: 'Verfügbare menge',
        CART_QTY: 'Menge im warenkorb',
        POS_LIMIT: 'POS-limit',
        SKU: 'SKU-code',
        COLOR: 'Farbe',
        PRODUCT: 'Produkt',
        SIZE: 'Größe',
        NEW_DATE: 'Neues datum',
        MESSAGE1: 'Die folgenden artikel sind für das angeforderte lieferdatum nicht mehr verfügbar, aber für ein neues datum verfügbar.',
        MESSAGE1_REORDER: 'Die folgenden artikel haben ein abgelaufenes lieferdatum.',
        MESSAGE1_REORDER2: 'Die folgenden artikel sind für das angeforderte lieferdatum nicht mehr verfügbar, aber für ein neues datum verfügbar.',
        MESSAGE2: 'Möchten sie die lieferdaten aktualisieren?',
        MESSAGE3: 'Einige artikel sind nicht mehr veröffentlicht oder verfügbar. Diese werden aus dem warenkorb entfernt!',
        MESSAGE4: 'Achtung! Sie haben das limit für die folgenden style-farbe-kombinationen überschritten. Überprüfen sie ihren warenkorb, um ihn bestätigen zu können.',
        MESSAGE5: 'Achtung! Sie haben das limit für den aktuellen verkaufsstandort überschritten! Überprüfen sie ihren warenkorb, um ihn bestätigen zu können.',
        MESSAGE6: 'Möchten sie das lieferdatum aktualisieren?',
        MESSAGE_MIN_QTY_PER_ORDER: 'Achtung! Einige artikel in der bestellung erreichen nicht die mindestmenge für die jeweilige style-farbe!',
        MINIMUM: 'Mindestmenge',
        ERROR_REASON: 'Fehlerursache',
        REASON: {
          REQUESTED_QTY_NOT_AVAILABLE: 'Angeforderte menge nicht verfügbar',
          VARIANT_NOT_AVAILABLE_IN_YOUR_TIER: 'Variante nicht verfügbar in ihrer stufe',
          VARIANT_NOT_AVAILABLE_IN_YOUR_CHANNEL: 'Variante nicht verfügbar in ihrem kanal',
          VARIANT_NO_LONGER_VISIBLE: 'Variante nicht mehr sichtbar',
          BLANK_CELL_DATE_NO_LONGER_ACTIVE: 'Leeres zellen-datum nicht mehr aktiv',
        }
      },
      ATTENTION: 'Achtung!',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'Du kannst diesen warenkorb nicht bestätigen, da der kunde nicht genehmigt ist',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'Du kannst diesen warenkorb nicht bestätigen, da der verkaufsort nicht genehmigt ist',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'Du kannst diesen warenkorb nicht bestätigen, da der gesamtwert unter dem in diesem geschäft zulässigen mindestbetrag liegt',
      THIS_CART_NOT_AVAILABLE: 'Dieser warenkorb ist nicht mehr verfügbar',
      NO_PRODUCTS_IN_CART: 'Keine Produkte im warenkorb',
      COMMERCIAL_BLOCK_INFO: 'Für den aktuellen kunden ist eine administrative sperre aktiv.',
      NO_CART_CONF: 'Dieser warenkorb kann nicht bestätigt werden.',
      DETAILS: {
        CUSTOMER: 'Kunde',
        GENERAL_INFO: 'Allgemeine informationen',
        DELIVERY_INFO: 'Lieferinformationen',
        POS: 'Verkaufsstelle',
        BILLING_ADDRESS: 'Rechnungsadresse',
        SEASON_REFERENCE: 'Saisonreferenz',
        GOK: 'GOK',
        SHIPPING: 'Liefern an',
        OVERVIEW: 'Übersicht',
        ALTERNATIVE: 'Alternative adresse auswählen',
        REMOVE_CUSTOM: 'Benutzerdefiniertes lieferdatum entfernen',
        SET_CUSTOM: 'Benutzerdefiniertes lieferdatum festlegen',
        INVALID_SELECTION_FOR_CUSTOM_DATES: 'Du kannst nicht dieselben benutzerdefinierten lieferdaten für dieselben sku codes mit unterschiedlichen vorgeschlagenen lieferdaten festlegen',
        CUSTOM_DATES: 'Benutzerdefinierte lieferdaten',
        SELECT_ALL: 'Alle auswählen',
        DESELECT_ALL: 'Alle abwählen',
        SHIPPING_UPDATED: 'Lieferadresse aktualisiert',
        NO_OTHER_SHIPPING_ADDRESS_AVAILABLE: 'Keine weitere lieferadresse verfügbar',
        VARIANTS_ALREADY_ORDERED_WITH_REORDER_DATE: ' Artikel wurden nicht hinzugefügt, da sie bereits mit abgelaufenem datum im warenkorb sind. Gehe zum warenkorb, um sie zu verwalten.',
        PLEASE_SAVE_OR_CANCEL_YOUR_ORDER_CHANGES: 'Bitte speichere oder storniere die Änderungen, bevor du die Bestellung bestätigst',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Ein oder mehrere Artikel erfüllen nicht die Mindestbestellmenge',
        TOTAL_COST: 'Gesamtkosten',
        TOTAL_MARGIN: 'Gesamtmarge',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Rabatt auf den einzelhandelspreis',
        NOTE: 'Notizen',
      },
      CONTROLLERS: {
        DELETE: 'Warenkorb löschen',
        DUPLICATE: 'Warenkorb duplizieren',
        NOTES: 'Notizen',
        PRINT: 'Drucken',
        ACTIONS: 'Aktionen',
        CONFIRM_ORDER: 'Bestellung bestätigen',
        OPEN_IN_BACKOFFICE: 'Im backoffice öffnen',
        CANCEL_CHANGES: 'Änderungen abbrechen',
        SAVE_CHANGES: 'Änderungen speichern',
        EDIT_QTY: 'Menge bearbeiten',
        COMMERCIAL_AGREEMENT: 'Handelsabkommen',
        VIEW_IN_BACK_OFFICE: 'Warenkorb im backoffice anzeigen'
      },
      SELECTORS: {
        SHIPPING: {
          TITLE: 'Versand',
          TEXT: 'Lieferadresse',
          INPUT: 'Adresse auswählen',
          DELIVERY_DATES: 'Liefertermine'
        },
        DELIVERY: 'Lieferdatum',
        PRICE: {
          TITLE: 'Gesamtsummen',
          TOT_WHOLESALE_GROSS: 'Großhandel brutto',
          TOT_DISCOUNT: 'Rabatt',
          TOT_DISCOUNT_PERC: 'Rabatt %',
          COMM_AGR_DISCOUNT_PERC: 'Rabatt Handelsabkommen %',
          TOT_WHOLESALE_NET: 'Großhandel netto',
          TOT_RETAIL_NET: 'Einzelhandel',
          TOTAL_CART: 'Warenkorb gesamt'
        },
        ADDING_INFO: 'Du fügst {{totalPcs}} stück hinzu, für einen gesamt-wholesale von €{{totalWholesale}}',
        ADDING_INFO_LOADING: 'Wird hinzugefügt...',
        QUANTITY: 'Menge',
        DISCOUNT: {
          TITLE: 'Dein rabatt',
          TEXT: 'Dein rabatt'
        },
        PAYMENT: {
          TITLE: 'Zahlung',
          SUB_TITLE: 'Zahlungsfrist'
        },
        BILLING: {
          TITLE: 'Rechnungsinformationen',
          SUB_TITLE_CUSTOMER: 'Kunde',
          SUB_TITLE_ADDRESS: 'Rechnungsadresse'
        }
      },
      PRODUCT: {
        TITLES: {
          NAME: 'Artikelname',
          WHOLESALE: 'Gesamt-wholesale',
          QUANTITY: 'Gesamtmenge'
        },
        DOT_MENU: {
          REMOVE: 'Entfernen',
          REMOVE_LINE: 'Setze die menge der zeile auf 0'
        },
        ERRORS: {
          UNAVAILABLE: 'Größe nicht verfügbar',
          UNAVAILABLES: 'Größen nicht verfügbar'
        }
      },
      CHECKOUT: {
        YOUR_ORDER: 'Ihre bestellung',
        HAS_BEEN_CONFIRMED: 'wurde bestätigt',
        POINT_OF_SALE: 'Verkaufsstelle',
      },
      PROMOTION: 'Verwendete werbeaktionen',
      ORDER_NOTES: 'Bestellnotizen',
    },
    ON_BACK: {
      MODAL: {
        TITLE: 'Änderungen wurden nicht gespeichert',
        MESSAGE: 'Wenn sie diese seite verlassen, gehen alle nicht gespeicherten Änderungen verloren.',
        LEAVE_PAGE: 'Verlassen',
        CONTINUE: 'Weiter',
      }
    },
    FINANTIAL_RISK: {
      FINANTIAL_RISK_CURRENT: 'Aktuelles finanzielles risiko',
      FINANTIAL_RISK_PREVIUS: 'Vorheriges finanzielles risiko',
      CLASS: 'Classe',
      SCORE: 'Punteggio',
      DESCRIPTION: 'Beschreibung',
      SUMMARY: 'Zusammenfassung',
      CREDIT_LIMIT: 'Kreditlimit',
      INSOLVENCY: 'Insolvenz',
      COMPANY_INSOLVENCY: 'Unternehmensinsolvenz',
      PROTESTI: 'Proteste',
      PREJUDICIALS: 'Vorbelastungen',
      NAME: 'Name',
      LEGAL_FORM: 'Rechtsform',
      TAX_CODE: 'Steuernummer',
      VAT_CODE: 'Umsatzsteuer-ID',
      COMPANY_NUMBER: 'Firmennummer',
      EMAIL: 'Email',
      COUNTRY: 'Land',
      COMPANY_REG_NUMBER: 'Handelsregisternummer',
      PUBLIC_REG_SECTION: 'Abschnitt des öffentlichen registers',
      INCORPORATION_DATE: 'Gründungsdatum',
      REA_REGISTRATION_DATE: 'REA-Registrierungsdatum',
      STATUS: 'Stato',
      STATUS_DESCRIPTION: 'Statusbeschreibung',
      EMPLOYESS: 'Mitarbeitende',
      TURNOVER: 'Umsatz',
      ACTIVITY_CODE: 'Tätigkeitscode',
      ACTIVITY_DESCRIPTION: 'Tätigkeitsbeschreibung',
      COMPANY_DETAILS: 'Unternehmensdetails',
      STATUS_AND_KEY_FIGURES: 'Status und kennzahlen',
      ACTIVITY_DETAILS: 'Tätigkeitsdetails',
      TELEPHONE: 'Telefon',
      ADDRESS: 'Adresse',
      LAST_RATING_CHANGE_AT: 'Letzte bewertungsänderung am',
      TYPE: 'Typ',
    },
    IMPORT_PRODUCT_MODAL: {
      RETAIL_DISCOUNT_PERCENTAGE: 'Einzelhandelsrabatt in prozent',
      DISCOUNT_REQUIRED: 'Rabatt erforderlich',
      MAX_DISCOUNT_ALLOWED: 'Maximal zulässiger rabatt {{value}}%',
    },
    LOCALIZED_TEXT_EDITOR: {
      ACTIONS: 'Aktionen',
      ACTION: {
        SET_DEFAULT: 'Als standard festlegen',
      },
      DEFAULT_LANGUAGE: 'Standardsprache',
    },
    OPERATION_LOG: {
      TITLE: 'ERP-vorgangsprotokoll für {{value}}',
      OPERATION_LOGS: 'Vorgangsprotokolle',
      ORDER: 'Bestellung #{{value}}',
      FULFILLMENT: 'Abwicklung #{{value}}',
      LOG_DESCRIPTION: 'Protokollbeschreibung',
      COLUMNS: {
        CREATION_DATE: 'Erstellungsdatum',
        OPERATION_TYPE: 'Vorgangsart',
        OUTCOME: 'Ergebnis',
      },
      OPERATION_TYPE_STATUS: {
        CONFRIMED_ORDER: 'Bestellung bestätigt',
        FULFILLMENT_CANCELED: 'Ausführung storniert',
        ORDER_ITEMS_INSERTED: 'Artikel hinzugefügt',
        ORDER_ITEMS_UPDATED: 'Artikel aktualisiert',
        ORDER_UPDATED: 'Bestellung aktualisiert',
        SERVICE_ITEM_INSERTED: 'Service hinzugefügt',
        SERVICE_ITEM_UPDATED: 'Service aktualisiert',
        SERVICE_ITEM_DELETED: 'Service gelöscht',
        FULFILLMENT_CREATED: 'Ausführung erstellt',
        FULFILLMENT_UPDATED: 'Ausführung aktualisiert',
        FULFILLMENT_PACKAGE_CREATED: 'Paket erstellt',
        FULFILLMENT_PACKAGE_ITEM_CREATED: 'Artikel zum paket hinzugefügt',
        ORDER_HEADER_UPDATED: 'Auftragskopf aktualisiert',
        BULK_ADD_ITEMS: 'Artikel hinzugefügt',
        BULK_CHANGE_QTY: 'Menge geändert',
        BULK_REPLACE_ITEMS: 'Artikel ersetzt',
        BULK_CHANGE_WHOLESALE: 'Preise geändert',
        BULK_CHANGE_DELIVERY_DATE: 'Lieferdatum geändert',
        WEBHOOK_NOTIFICATION: 'Webhook an das ERP weitergeleitet',
        ORDER_SYNC_STATUS: 'Bestellstatus aktualisiert',
        CHANGE_CUSTOMER_OR_POS: 'Kunde/Verkaufsstelle geändert',
        BULK_CANCEL_ORDER: 'Bestellungen storniert',
        BULK_OPERATION_ROLLBACK: 'Vorgang rückgängig',
        BULK_REMOVE_ITEMS: 'Artikel entfernt',
      },
      OUTCOME_STATUS: {
        SUCCESS: 'Erfolg',
        FAILED: 'Fehlgeschlagen',
      },
    },
    CUSTOMIZATION_REQUEST: {
      CREATE_NEW_CART: 'Neuen Warenkorb aus CR erstellen',
      PLAYERS: 'Spielerinformationen',
      NO_PLAYERS: 'Es wurden keine Spielerinformationen für diese Personalisierungsanfrage eingegeben',
      NO_PLAYERS_TO_EDIT: 'Es gibt keine Spieler zum Bearbeiten für dieses Produkt.',
      TITLE: 'Anpassungsanfrage: {{name}}',
      SUCCESSFULLY_SAVED: 'Konfiguration erfolgreich gespeichert',
      HEADER: {
        TITLE: 'TITEL',
        CUSTOMER: 'KUNDE',
        REQUESTER: 'ANFORDERER',
        CUSTOMER_REQUESTER: 'KUNDENANFORDERER',
        AGENCY_REQUESTER: 'AGENTURANFORDERER',
        DESIGNER: 'GRAFIKER',
        POINT_OF_SALE: 'VERKAUFSSTELLE',
        CUSTOMIZATION_REQUEST_CREATION: 'RP-Erstellung',
        PERSONALIZED_COST: 'Personalisierungskosten',
        SHIPPING_COST: 'Versandkosten',
        DISCOUNT: 'Prozentsatz des Rabatts, der auf den Warenkorb angewendet wird',
        ENDORSEMENT_REQUESTER: 'Genehmigung durch Anforderer',
        ENDORSEMENT_DESIGNER: 'Grafische genehmigung',
        ENDORSEMENT_COMMERCIAL: 'Kommerzielle genehmigung',
        REQUEST_REJECTED: 'Abgelehnt',
        APPROVED_BY_AT: 'Genehmigt von {{name}} am {{date}}',
        REJECTED_BY_AT: 'Abgelehnt von {{name}} am {{date}}',
        PENDING: 'Ausstehend',
        SUPPORT_PHONE: 'Support-Telefon',
        SUPPORT_EMAIL: 'Support-E-Mail',
        TOTAL_QUANTITY: 'Gesamtmenge',
        DELIVERY_DATE: 'Lieferdatum',
        LAST_DESIGNER_NOTIFICATION: 'Letzte Grafiker-Benachrichtigung',
        TITLE_UPDATED_SUCCESSFULLY: 'Titel erfolgreich aktualisiert',
        REQUESTER_UPDATED_SUCCESSFULLY: 'Anforderer erfolgreich aktualisiert',
        DESIGNER_UPDATED_SUCCESSFULLY: 'Grafiker erfolgreich aktualisiert',
        POINT_OF_SALE_UPDATED_SUCCESSFULLY: 'Verkaufsstelle erfolgreich aktualisiert',
        ARE_YOU_SURE_DUPLICATE: 'Sind sie sicher, dass sie die personalisierungsanfrage duplizieren moechten??',
      },
      REQUESTER_APPROVAL: {
        CHOOSE_TITLE: "Möchtest du die Informationen der spieler deiner mannschaft eingeben?",
        CHOOSE_DONT_CUSTOMIZE: "Nein, ich möchte keine anpassung vornehmen",
        CHOOSE_CUSTOMIZE: "Ja, ich möchte die Namen und nummern meiner spieler eingeben (optional)",
        HOW_MANY: "Wie viele spieler möchtest du eingeben?",
        SIZES_TITLE: "Gib die menge für jedes produkt ein. Denk daran, du musst mindestens {{min}} stück pro produkt bestellen",
        EXTRA_SIZES_TITLE: "Gib die zusätzlichen, nicht personalisierten Mengen ein",
        EXTRA_SIZES_TITLE2: " (optional)",
        EXTRA_SIZES_TITLE3: ". Es gibt {{n}} produkte, bei denen du die mindestbestellmenge von {{min}} stück nicht erreicht hast. Gib mengen ein, um die mindestbestellmenge für jedes produkt zu erreichen.",
        PLAYERS_TITLE: "Wähle eine schriftart und gib für jeden Spieler einen namen (optional) und eine nummer (verpflichtend) ein. wähle zudem die größe für jeden artikel, den du diesem spieler zuordnen möchtest.",
        NUMBER: "Nummer",
        JERSEY_TEXT: "Name",
        DUPLICATE_PRODUCT: "Produkt duplizieren",
        DUPLICATE_ARE_YOU_SURE: "Bist du sicher, dass du dieses produkt in deiner personalisierungsanfrage duplizieren möchtest? Wenn ja, gib den produktnamen in die anfrage ein und bestätige",
        SHOW_PLAYERS_INFO: "Spielerinfos anzeigen",
        FONTS: "Schriftarten",
      },

      NEW_REQUESTER_APPROVAL: {
        MODAL_TITLE: "Genehmigung der Personalisierungsanfrage",
        MODAL_SUBTITLE: "Definieren Sie Produktmengen und optionale zusätzliche Anpassungen.",
        ALERT_INFO: "Diese Anfrage umfasst mehrere Produkte. Um die Anfrage abzuschließen, müssen Sie für jedes Produkt Mengen eingeben. Anpassungen sind optional. Denken Sie daran, dass Sie mindestens {{min}} Stück pro Produkt benötigen.",
        PRODUCTS: "Produkte",
        INCOMPLETE: "Unvollständig",
        COMPLETE: "Vollständig",
        TOTAL_PIECES: "Gesamtstücke",
        TOTAL_PIECES_RECAP_TITLE: "Mengenzusammenfassung",
        TOTAL_PIECES_PER_PRODUCT_TITLE: "Mengenzusammenfassung pro Produkt",
        CUSTOMIZED: "Personalisiert",
        WITH_CUSTOMIZATION: "Mit Personalisierung",
        WITHOUT_CUSTOMIZATION: "Ohne Personalisierung",
        QUANTITY_WITHOUT_CUSTOMIZATION: "Produktmenge ohne Personalisierung",
        SIZE: "Größe",
        QUANTITY: "Menge",
        WS_UNIT: "WS Einheit",
        CUST_UNIT: "Pers. Einheit",
        WS_TOT: "WS Ges.",
        INSERT: "Einfügen",
        CUSTOMIZATION: "Produktmenge mit Personalisierung",
        FONTS: "Schriftarten",
        LOADING_FONTS: "Schriftarten werden geladen...",
        NUMBER: "Nummer",
        NAME: "Name",
        ADD_PLAYER: "Spieler hinzufügen",
        IMPORT_PLAYERS: "Spieler importieren",
        IMPORT_PLAYERS_HINT: "Nummer und Name der bereits konfigurierten Spieler importieren",
        IMPORT_LAST_CUSTOMIZATION: "Letzte Anpassung importieren",
        IMPORT_LAST_CUSTOMIZATION_TOOLTIP: "Falls vorhanden, können Sie Nummer und Name der zuletzt eingegebenen Spieler importieren",
        SAVE_APPROVAL: "Genehmigung speichern",
        CHECK_QUANTITIES_AND_PLAYERS: "Überprüfen Sie die eingegebenen Mengen und Spieler, bevor Sie mit der Bestätigung fortfahren",
        NO_SUMMARY_ROWS: "Keine Zusammenfassungszeilen.",
        BACK_TO_CUSTOMIZATION_REQUEST: "Zurück zur Anpassungsanforderung",
        SIZE_GROUP: {
          ADULT: "Erwachsene",
          YOUTH: "Jugend",
          KIDS: "Kinder",
        }
      },

      GRAPHICAL_APPROVAL: {
        COLOR_NAME: "Farbenname",
        COLOR_NAME_TOOLTIP: 'Beispiel: Clubname {{currentYear}} + Zweck (Spiel, Training...)',
        COLOR_NAME_ERROR: 'Dieser Farbenname wird bereits für ein anderes Produkt verwendet.',
      },

      ACTION: {
        APPROVE: 'Genehmigen',
        EDIT_CUSTOMIZATION_REQUEST_NAME: 'Name der Anpassungsanforderung bearbeiten',
        EDIT_CR_PRODUCT_NAME: 'Produktname in der CR bearbeiten',
        BACK: 'Zurück',
        NEXT: 'Weiter',
        APPROVE_GRAPHICALLY: 'Grafisch genehmigen',
        APPROVE_COMMERCIAL: 'Kaufmännisch genehmigen',
        LOCK_CONFIGURATOR: 'Konfigurator sperren',
        UNLOCK_CONFIGURATOR: 'Konfigurator entsperren',
        REJECT: 'Ablehnen',
        DELETE: 'Löschen',
        DOWNLOAD_REPORT: 'Bericht herunterladen',
        DOWNLOAD_COLOR_REPORT: 'Farbbericht herunterladen',
        DOWNLOAD_STORE_ORDERS_ITEMS_REPORT: 'Bestellpositionsbericht herunterladen',
        DOWNLOAD_STORE_ORDERS_REPORT: 'Bestellbericht herunterladen',
        DOWNLOAD_POINTS_OF_SALE_REPORT: 'Verkaufsstellenbericht herunterladen',

        DUPLICATE_CUSTOMIZATION_REQUEST: 'Personalisierungsanfrage duplizieren',
        CUSTOMIZATION_REQUEST_ENDORSEMENT: 'Genehmigung der anpassungsanfrage',
        DELETE_CUSTOMIZATION_REQUEST: 'Anpassungsanfrage löschen',
        REJECT_CUSTOMIZATION_REQUEST: 'Anpassungsanfrage ablehnen',
        INSERT_REJECTION_REASON: 'Ablehnungsgrund eingeben',
        ARE_YOU_SURE: 'Bist du sicher?',
        ARE_YOU_SURE_YOU_WANT_TO_LOCK_CONFIGURATOR: 'Bist du sicher, dass du den konfigurator sperren möchtest?',
        ARE_YOU_SURE_YOU_WANT_TO_UNLOCK_CONFIGURATOR: 'Bist du sicher, dass du den konfigurator entsperren möchtest?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Bist du sicher, dass du die anpassungsanfrage löschen möchtest?',

        DELIVERY_DATE: 'Lieferdatum',
        FINANCIAL_DISCOUNT: 'Finanzieller rabatt',
        ADDITIONAL_CUSTOMIZATION_COST: 'Anpassungskosten für diese anfrage (optional)',
        CUSTOMIZATION_REQUEST_APPROVED_SUCCESSFULLY: 'Anpassungsanfrage erfolgreich genehmigt',
        CONFIGURATOR_LOCKED_SUCCESSFULLY: 'Konfigurator erfolgreich gesperrt',
        CONFIGURATOR_UNLOCKED_SUCCESSFULLY: 'Konfigurator erfolgreich entsperrt',
        CUSTOMIZATION_REQUEST_REJECTED_SUCCESSFULLY: 'Anpassungsanfrage erfolgreich abgelehnt',
        CUSTOMIZATION_REQUEST_DELETED_SUCCESSFULLY: 'Anpassungsanfrage erfolgreich gelöscht',
        CUSTOMIZATION_REQUEST_DUPLICATED_SUCCESSFULLY: 'Anpassungsanfrage erfolgreich dupliziert',
        REVERT_TO_DRAFT: 'In Entwurf zurücksetzen',
        REVERT_TO_DRAFT_SUCCESSFULLY: 'Der Status der Anpassungsanfrage wurde erfolgreich geändert',
        NOTIFY_DESIGNER_READY: 'Designer benachrichtigen',
        DESIGNER_NOTIFIED_SUCCESSFULLY: 'Designer erfolgreich benachrichtigt',
      },
      DETAIL: {
        BACK_TO_CUSTOMIZATION_REQUESTS: 'Zurück zu den anpassungsanfragen',
        DETAIL: 'Detail',
        TIMELINE: 'Zeitachse',
        MEDIA: 'Medien',
        CHANNEL_NAME: 'Kanalname',
        STATUS: 'Status',
        CONFIGURATOR_LOCKED: 'Konfigurator gesperrt',
        CUSTOMIZED_PRODUCTS: 'Angepasste produkte',
        ADD_PRODUCT: 'Produkt hinzufügen',
        SELECT_PRODUCT: 'Produkt auswählen',
      },
      MEDIA: {
        FILE_NAME: 'Dateiname',
        USER_NAME: 'Benutzername',
        USER_ROLE: 'Benutzerrolle',
        DOCUMENT_GRAPHICAL_APPROVAL: 'Grafische genehmigungsdokumente',
        DOWNLOAD_DOCUMENT: 'Dokument herunterladen',
        ATTACHMENTS_OF_CUSTOMIZATION_REQUEST: 'Anhänge der anpassungsanfrage',
      },
      UPLOAD_FILE: {
        ERROR_FILE_MAX_SIZE: '<strong>Fehler! </strong> die datei überschreitet die maximal zulässige Größe von {{maxSize}}',
        ERROR_FILE_TYPE: '<strong>Fehler! </strong>die datei ist nicht vom zulässigen typ, zulässige typen sind: {{allowedTypes}}',
        ATTACH_DOCUMENT: 'Dokument anhängen',
        ATTACH_IMAGE: 'Bild anhängen',
        ATTACHMENT: 'Anhang',
        BROWSE: 'Durchsuchen',
        CHOSE_DOCUMENT: 'Dokument wählen',
        CHOSE_IMAGE: 'Bild wählen',
      },

      CUSTOMIZATION_PRODUCT: {
        PRODUCT_DELETED_SUCCESSFULLY: 'Produkt erfolgreich gelöscht',
        PERSONALIZE: 'Personalisieren',
        COLOR_NAME: 'Farbname',
        COLOR_CODE: 'Farbcode',
        START_3D_VIEWER: '3D-Viewer starten',

        SKU: 'Produktcode',
        PRODUCT_NAME: 'Produktname',
        TEMPLATE_ID: 'Template-ID',
        ID: 'ID',
        WHOLESALE_TOTAL_PRICE: 'Großhandel gesamt',

        TABLE: {
          SIZE: 'Größe',
          QUANTITY: 'Menge',
          WHOLESALE_UNIT_PRICE: 'Großhandel stückpreis',
          CUSTOMIZATION_UNIT_PRICE: 'Personalisierungsstückpreis',
          WHOLESALE_TOTAL_PRICE: 'Großhandel gesamt',
        }
      },

      TIMELINE: {
        CUSTOMIZATION_REQUEST_CREATED: 'Anpassungsanforderung erstellt',
        CUSTOMIZATION_REQUEST_REJECTED: 'Anpassungsanforderung abgelehnt',
        PRODUCT_ADDED: 'Produkt hinzugefügt',
        PRODUCT_DELETED: 'Produkt gelöscht',
        POINT_OF_SALE_UPDATED: 'Verkaufsstelle aktualisiert',
        CONFIGURATOR_LOCKED: 'Konfigurator gesperrt',
        CONFIGURATOR_UNLOCKED: 'Konfigurator entsperrt',
        STATUS_RESET_TO_DRAFT: 'Status auf entwurf zurückgesetzt',
        APPROVED_BY_REQUESTER: 'Vom anforderer genehmigt',
        APPROVED_GRAPHICALLY: 'Grafisch genehmigt',
        APPROVED_COMMERCIAL: 'Kommerziell genehmigt',
        DEFAULT_DESIGNER_ASSIGNED: 'Standarddesigner zugewiesen',
        DESIGNER_REASSIGNED: 'Designer neu zugewiesen',
        REQUESTER_REASSIGNED: 'Anforderer neu zugewiesen',
        CUSTOMER_REQUESTER_REASSIGNED: 'Kundenanforderer neu zugewiesen',
        AGENCY_REQUESTER_REASSIGNED: 'Agenturanforderer neu zugewiesen',
        MESSAGE_ADDED: 'Nachricht hinzugefügt',
        MEDIA_ADDED: 'Medien hinzugefügt',
        DESIGNER_NOTIFIED: 'Grafiker benachrichtigt',
        BY: 'von {{name}}',
        HIDE_MESSAGE_FROM_REQUESTER: 'Nachricht vom anforderer verbergen',
        READ_MORE: 'Mehr lesen',
        READ_LESS: 'Weniger lesen',
        FOR_CR_PRODUCT: 'für Produkt: #{{value}}',
        REQUESTING_NEW_DESIGN: 'mit Anfrage für neues Design',
        TRANSLATE_MESSAGE: 'Nachricht übersetzen',
        SHOW_ORIGINAL_MESSAGE: 'Originalnachricht anzeigen',
      },
      CONFIGURATOR: {
        BACK_TO_CUSTOMIZATION_REQUEST: 'Zurück zur anpassungsanforderung',
        PRODUCT_CONFIGURATOR: 'Produktkonfigurator #{{sku}} - {{title}}',
      },
      INHERIT_OR_RESET_SIZES_FROM_CR: 'Größen von CR wiederverwenden oder zurücksetzen',
      INHERIT_OR_RESET_SIZES_FROM_CR_DESCRIPTION: 'Möchten Sie die Größen aus der vorherigen Anpassungsanforderung wiederverwenden oder zurücksetzen?',
      RESET_SIZES: 'Größen zurücksetzen',
      INHERIT_SIZES: 'Größen wiederverwenden',
    },
    // TRADUZIONI CROSS FRONT / BACK OFFICE
    DUPLICATE_CART: {
      TITLE: 'Warenkorb duplizieren',
      CUSTOMER: 'Kunde',
      POINT_OF_SALES: 'Verkaufsstelle',
      CART_NAME: 'Warenkorbname',
      ALTERNATIVE_SHIPPING_ADDRESS: 'Alternative lieferadresse',
      SUCCESS_CART_DUPLICATED: 'Warenkorb erfolgreich dupliziert',
      ERROR_CART_DUPLICATED: 'Fehler beim duplizieren eines oder mehrerer produkte',
      DUPLICATE_CART: 'Warenkorb duplizieren',
      SET_REQUEST_DELIVERY_DATE: 'Lieferdatum der Anforderung setzen',
      AGENCY: 'Agentur',
      CART_DUPLICATED_PARTIALLY: 'Warenkorb teilweise dupliziert',
      CART_NOT_DUPLICATED: 'Warenkorb nicht dupliziert',
      VARIANTS_NOT_ADDED: 'Varianten nicht hinzugefügt',
      VARIANT: 'Variante',
      VARIANT_NOT_AVAILABLE: 'Variante nicht verfügbar',
      QUANTITY_INSUFFICIENT: 'Unzureichende menge',
      REQUESTED_QUANTITY: 'Angeforderte menge',
      AVAILABLE_QUANTITY: 'Verfügbare menge',
      MANUAL_DISCOUNT: 'Einschließlich angewendeter manueller rabatte',
      PENDING_FULFILLMENT: 'Nur nicht erfüllte bestellartikel duplizieren',
      OPTION_DUPLICATE_ORDER: 'Bestell-duplikationsoptionen',
      INCLUDE_CUSTOM_DELIVERIES: 'Benutzerdefinierte lieferdaten einbeziehen',
      SKIP_CHECKS: 'Sichtbarkeits- und mengenprüfungen überspringen',
    },
    CHANNEL: {
      BROWSE: 'Durchsuchen',
      TITLE: 'Kanal',
    },

    CONFIRM_CART_MODAL: {
      TITLE: 'Warenkorb bestätigen',
      SUB_TITLE: 'Sie bestätigen den Warenkorb',
      ATTENTION_THIS_CUSTOMER_HAVE_A_COMMERCIAL_BLOCK_ACTIVE: 'Dieser Kunde hat eine aktive kommerzielle sperre. Sind sie sicher, dass sie die bestellung trotzdem bestätigen möchten?',
      YOU_HAVE_VOUCHERS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Sie haben verfügbare gutscheine, die sie auf diesen warenkorb anwenden können',
      NO_ENTERED_ATTACHMENTS: 'Keine anhänge eingegeben',
      SELECT_VOUCHER: 'Gutschein auswählen',
      RESIDUAL_VOUCHER_VALUE: 'Verbleibender gutscheinwert: {{value}}',
      TOTAL_CART: 'Gesamtwarenkorb: {{value}}',
      TERMS_AND_CONDITIONS: 'Allgemeine Geschäftsbedingungen',
      ACCEPT_TERMS_AND_CONDITIONS: 'Ich akzeptiere die allgemeinen Geschäftsbedingungen',
      NO_VOUCHERS_AVAILABLE: 'Keine gutscheine verfügbar',
      VOUCHERS_UNAVAILABLE: 'Gutscheinfunktion momentan nicht verfügbar',
      CONFIRM: 'Bestätigen',
      COMMERCIAL_AGREEMENT: 'Kommerzielles abkommen',
      YOU_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Sie haben verfügbare kommerzielle abkommen, die sie auf diesen warenkorb anwenden können',
      SELECT_COMMERCIAL_AGREEMENT: 'Kommerzielles abkommen auswählen',
      DISCOUNT: 'Rabatt',
      COMMERCIAL_AGREEMENT_ID_IS_NOT_VALID: 'Das zuvor mit diesem warenkorb verknüpfte kommerzielle abkommen ist nicht mehr gültig. Wählen sie ein anderes oder entfernen sie das alte',
      REMOVE_COMMERCIAL_AGREEMENT: 'Kommerzielles abkommen entfernen',
      YOU_DONT_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Sie haben keine verfügbaren kommerziellen abkommen, die sie auf diesen warenkorb anwenden können',
      SAVE: 'Speichern',
      MANAGE_DELIVERY_DATES: 'Liefertermine verwalten',
      OPTION_TITLE: 'Bestätigungsoptionen',
      EXCLUDE_CONTROLS: 'Sichtbarkeits- und mengensteuerungen ausschließen',
      INFO_EXCLUDE_CONTROLS: 'Wenn sie sichtbarkeits- und mengensteuerungen ausschließen, können sie den warenkorb auch bestätigen, wenn artikel nicht sichtbar sind oder die angeforderte menge nicht verfügbar ist.',
      DONT_SENT_EMAIL: 'Keine bestätigungs-e-mail senden',
      POPULATE_DEFAULT_RECIPIENTS: 'Standardempfänger füllen',
    },

    PAGINATION: {
      ITEM_FOR_PAGE: 'Elemente pro Seite',
      PAGE: 'Seite',
      OF: 'von',
    },

    EVALUATE_CART_SALE_CAMPAIGN_CONSTRAINT: {
      COMMERCIAL_RULES: 'Regole commerciali',
      ALERT: {
        TITLE: 'Achtung!',
        MESSAGE: 'Für diesen warenkorb ist die kommerzielle regel "{{commercialRuleName}}" für die verkaufsaktion "{{saleCampaignName}}" aktiv.',
        MORE_INFO: 'Details anzeigen',
        CLICK_HERE_FOR_MORE_INFO: 'Klicken sie hier, um Details anzuzeigen',
        CART_NOT_CONFIRMABLE: 'Für diesen warenkorb ist eine kommerzielle regel aktiv, bei der ein oder mehrere einschränkungen nicht erfüllt sind',
        FOR_CONFIRM_CART: ', um ihn zu bestätigen, müssen alle einschränkungen erfüllt sein.',
        ROLE_BYPASS: 'Ihre rolle erlaubt es ihnen, den warenkorb auch dann zu bestätigen, wenn nicht alle einschränkungen erfüllt sind.',
        CONSTRAINTS_IS_SATISFIED: 'Für diesen warenkorb ist eine kommerzielle regel aktiv und ihre einschränkungen sind erfüllt',
      },

      MODAL: {
        DETAIL_COMMERCIAL_RULE: 'Details zur kommerziellen regel: {{commercialRuleName}}',
        MISSING_ITEMS_OF_PRODUCTS: 'Es fehlen {{missingNumberOfItems}} stücke bei den produkten: {{stylesCode}}',
        VALUE_CONSTRAINT_NOT_REACHED: 'Die artikel in diesem assortiment erreichen nicht den mindestprozentsatz des gesamten wholesale-betrags, auch unter berücksichtigung früherer bestellungen in der aktuellen verkaufsaktion (Gesamtwholesale {{computedTotalWholesaleForMatchedItems}}€, entsprechend {{computedPercentageOfTotalWholesaleForMatchedItems}}%, während die schwelle bei {{constrainedTotalWholesaleMinimumPercentage}}% liegt; es fehlen €{{missingWholasale}})',
        VALUE_CONSTRAINT_REACHED: 'Wertbeschränkung erfüllt',
        VALUE_CONSTRAINT: '({{computedTotalWholesaleForMatchedItems}}€, entspricht {{computedPercentageOfTotalWholesaleForMatchedItems}}%)',
        ALL_PACKAGE_CONSTRAINTS_ARE_SATISFIED: 'Alle paketbeschränkungen sind erfüllt',
        CONSTRAINTS_ON_ASSORTMENT: 'Einschränkungen auf assortiment: {{assortmentName}}',
      },
    },

    CUSTOM_SHIP_DATES: {
      ITEMS_WITH_NO_STOCK1: 'Einige Termine wurden nicht hinzugefügt: ',
      ITEMS_WITH_NO_STOCK2: ' artikel haben keine verfügbare Lagerbestandsmenge',
      TITLE: 'Benutzerdefinierte versanddaten',
      SELECT_ALL: 'Alles auswählen',
      UNSELECT_ALL: 'Alles abwählen',
      BULK_PERSONALIZED_DATE: 'Lieferdatum anpassen ({{numberOfItems}})',
      CUSTOM_DATE: 'Benutzerdefiniertes datum',
      DATE_NOT_SELECTABLE: 'Datum nicht wählbar',
      REMOVE_ALL_CUSTOM_DATES: 'Alle benutzerdefinierten daten entfernen',
      DATE_OVER_MAX_DATE: 'Einer oder mehrere artikel haben ein benutzerdefiniertes datum, das das festgelegte maximale anpassungsdatum in diesem shop überschreitet',
      REQUESTED_DATE_OVER_MAX_DATE: 'Einer oder mehrere ausgewählte artikel können nicht angepasst werden, da das ursprünglich angeforderte lieferdatum das festgelegte maximale anpassungsdatum in diesem shop überschreitet',
      ON: 'am',
      FROM: 'von',
      TO: 'bis',
      ADD_NEW_DATE: 'Neues datum hinzufügen',
      DATE: 'Datum',
      QTY: 'Bestellte menge',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_GREATER_THAN_THE_QUANTITY_ORDERED: 'Fehler! Die summe der mengen für benutzerdefinierte daten ist größer als die bestellte menge',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_LESS_THAN_THE_QUANTITY_ORDERED: 'Fehler! Die summe der mengen für benutzerdefinierte daten ist kleiner als die bestellte menge',
      ERROR_THERE_ARE_DUPLICATE_DATES: 'Fehler! Es gibt doppelte daten',
      ERROR_THE_CURRENT_DATE_IS_OVER_THE_MAX_DATE: 'Fehler! Das aktuelle datum überschreitet das maximale datum',
      INFO_MODAL_TITLE: 'Neuer modus zur anpassung der lieferdaten',
      INFO_MODAL_CONTENT: 'Die anpassung der lieferdaten von artikeln innerhalb eines warenkorbs ist jetzt über das bestellbestätigungsfenster verfügbar (siehe Screenshot unten). Diese funktion kann nicht mehr über die bisherigen Aktionen vorgenommen werden.',
      OK: 'Verstanden'
    },

    CUSTOMIZATION_REQUEST_CREATOR: {
      PERSONALIZE: 'Personalisieren',
      BACK: 'Zurück',
      CONFIRM: 'Bestätigen',
      REQUEST_CONFIGURATION: 'Konfiguration neuen design',
      DOWNLOAD_THUMBNAIL: 'Miniatur herunterladen',
      SAVE: 'Speichern',
      CHANGE_TEMPLATE: 'Vorlage ändern',
      CREATED_SUCCESSFULLY: 'Personalisierungsanforderung erfolgreich erstellt',
      PRODUCT_ADDED_SUCCESSFULLY: 'Produkt erfolgreich hinzugefügt',
      STEP_1: {
        TITLE: 'Neue personalisierung',
        MESSAGE: 'Möchten sie eine neue personalisierungsanforderung erstellen oder eine bereits bestehende verwenden?',
        NEW_CR: 'Neue anfrage',
        EXISTING_CR: 'Bestehende anfrage',
      },
      STEP_2: {
        TITLE: 'Neue personalisierungsanforderung',
        SELECT_REQUESTER: 'Wähle mindestens einen Anfragenden aus. Du kannst einen Kunden und/oder einen Agenten auswählen',
        SELECT_REQUESTER_2: 'Als Benutzer einer Agentur kannst du diese Personalisierungsanfrage auch mit einem Kunden verknüpfen',
        SELECT_REQUESTER_3: 'Als Benutzer eines Kunden kannst du diese Personalisierungsanfrage auch mit einem Agenten verknüpfen, wenn dein Verkaufsstandort von einer Agentur betreut wird',
        TITLE_REQUEST: 'Anforderungstitel',
        TITLE_REQUEST_TOOLTIP: 'Beispiel: Clubname {{currentYear}}.',
        COMMENTS: 'Produktname in der anfrage',
        COMMENTS_TOOLTIP: 'Beispiel: Clubname + Zweck (Spiel, Training...)',
      },
      STEP_3: {
        TITLE: 'Personalisierungsanforderung auswählen',
        SELECT_REQUEST: 'Anforderung auswählen',
      },
      STEP_4: {
        TITLE: 'Wählen sie eine basisvorlage aus',
        DESCRIPTION: 'Personalisierungsanforderung: {{name}}',
      },
      STEP_5: {
        TITLE: 'Konfiguration für die personalisierung anfordern: {{name}}',
        DESCRIPTION: 'Vorlage #{{expiviId}}',
      },
      STEP_6: {
        TITLE: 'Konfiguration für die anfrage: {{name}}',
        DESCRIPTION: 'Vorlage #{{expiviId}}',
      },

      CONFIGURATION_MESSAGE: {
        PLACEHOLDER: 'Beschreibe das produkt, das du anfordern möchtest',
        MESSAGE_OF_REQUEST: 'Anforderungsnachricht',
        ATTACHMENTS: {
          TITLE: 'Anhänge',
          ADD: 'Anhang hinzufügen',
        },
      },

      VALIDATION: {
        AT_LEAST_ONE_REQUESTER: 'Bitte wählen Sie mindestens einen Anforderer (Kunde oder Agentur)',
        REQUESTERS_MUST_BE_DIFFERENT: 'Kundenanforderer und Agenturanforderer müssen unterschiedliche Benutzer sein',
      },

    },
    BASIC_KUSTOM_REQUESTER: {
      CUSTOMER: 'Kunde',
      AGENT: 'Agent',
      CUSTOMER_REQUESTER: 'Kundenanforderer',
      SELECT_AGENCY: 'Agentur auswählen',
      SELECT_AGENT: 'Agent auswählen',
      THIS_POINT_OF_SALES_DOES_NOT_HAVE_ANY_AGENCY: 'Dieser verkaufsstandort hat keine agentur',
    },

    //shop

    POS_STOCK_INFO: {
      TITLE: 'Info über den lagerbestand des verkaufsstandorts',
      LOADING: 'Lade lagerbestandsinformationen..',
      ORDERABLE_QTY: 'Bestellbare menge für den aktuellen verkaufsstandort',
      ORDERABLE_QTY2: 'Im aktuellen warenkorb können noch hinzugefügt werden',
      CART_QTY: 'Menge im aktuellen warenkorb',
      TOTAL: 'Gesamt'
    },
    COMMON: {
      SET: 'Setzen',
      SAVE: 'Speichern',
      MIN: 'Min',
      MAX: 'Max',
      FROM: 'Von',
      TO: 'Bis',
      SHOW: 'Zeigen',
      ONLY: 'nur',
      IN: 'in',
      SHOW_ONLY: 'Nur zeigen',
      SHOW_MORE: 'Mehr anzeigen',
      SUGG_RETAIL: 'Vorgeschlagener einzelhandel',
      SEARCH: 'Suchen',
      DATES_CHECKBOX: 'Nur wochen mit verfügbarkeit anzeigen',
      DELIVERY_DATES: 'Lieferdaten',
      PCS: 'Stück',
      WHOLESALE: 'Großhandel',
      SUGGESTED: 'Vorgeschlagen',
      VALID: 'Gültig',
      TYPE: 'Typ',
      EXPAND_ALL: 'Alle erweitern',
      COLLAPSE_ALL: 'Alle minimieren',
      PRODUCTS: 'Produkte',
      COMMERCIAL_BLOCK_ACTIVE: 'Aktiver verwaltungsblock',
      MAN: 'Mann',
      WOMAN: 'Frau',
      UNISEX: 'Unisex',
    },
    HEADER: {
      PRE_ORDER: 'Vorbestellung',
      RE_ORDER: 'Erneute bestellung',
      MY_CARTS: 'Meine warenkörbe',
      CART: 'Warenkorb',
      CARTS: 'Warenkörbe',
      SELECT_CHANNEL: 'Wählen sie kanal'
    },
    ACCOUNT_POPUP: {
      MY_ACCOUNT: 'Konto',
      BACK_OFFICE: 'Backoffice',
      LOGOUT: 'Abmelden',
      SWITCH_TENANT: 'Land wechseln',
      CHANGE_LINGUAGE: 'Sprache ändern',
      SHOW_ONLY_RETAIL_PRICES: 'Nur einzelhandelspreise anzeigen',
    },
    DIALOGS: {
      USE_TIER_FILTER: 'Einen Filter basierend auf der Tier-Einstellung festlegen',
      NO_TIER: 'Informationen, die keinem Tier zugeordnet sind',
      SELECT_TIER: 'Informationen, die einem bestimmten Tier zugeordnet sind',
      ARE_YOU_SURE_YOU_WANT_TO_CONFIRM_THIS_CART_BLOCKED: 'Achtung! Dieser kunde hat eine administrative sperre aktiviert. Sind sie sicher, dass sie die bestellung trotzdem bestätigen möchten?',
      DO_YOU_WANT_TO_LOGOUT: 'Möchten sie sich abmelden?',
      DO_YOU_WANT_TO_DELETE_THIS_CART: 'Möchten sie diesen warenkorb löschen?',
      DO_YOU_WANT_TO_CONFIRM_THIS_ORDER: 'Möchten sie diese bestellung bestätigen?',
      DO_YOU_WANT_TO_DELETE: 'Möchten sie löschen',
      CREATE_NEW_CART: 'Neuen warenkorb erstellen',
      EDIT_CART: 'Warenkorb bearbeiten',
      CREATE_CART: 'Warenkorb erstellen',
      COPY_CART: 'Warenkorb kopieren',
      TYPE_A_NEW_CART_NAME: 'Schreiben...',
      AGENCY: 'Agentur',
      NEW_CART_NAME: 'Warenkorbname',
      CANT_CONFIRM_THIS_ORDER: 'Diese bestellung kann nicht bestätigt werden',
      CANCEL: 'Abbrechen',
      CONFIRM: 'Bestätigen',
      SAVE: 'Speichern',
      GOK_MODE: 'GOK',
      GOK_CART: 'GOK-Warenkorb',
      CREATE_PRICE_LIST: 'Preisliste erstellen',
      EDIT_PRICE_LIST: 'Preisliste bearbeiten',
      DELETE_PRICE_LIST: 'Preisliste löschen',
      DELETE_PRICE_LIST_CONFIRM: 'Sind Sie sicher, dass Sie diese Preisliste löschen möchten?',
      ASSOCIATE_CUSTOMERS: 'Kunden zuordnen',
    },
    FOOTER: {
      COPYRIGHT: 'Copyright basicGroup 2025',
      PRIVACY_POLICY: 'Datenschutzrichtlinie',
      TERMS: 'Allgemeine geschäftsbedingungen',
      TERMS_NOT_FOUND: 'Allgemeine geschäftsbedingungen nicht gefunden',
      FOR_CLUBS: 'Für clubs',
      NO_DATA: 'Es gibt keine daten anzuzeigen, bitte kontaktieren sie den administrator.',
      RESET: 'Passwort zurücksetzen',
      TEXT: 'BasicItalia S.r.l. - Strada della Cebrosa 106, 10100 Torino, Italien - USt-IdNr. und CF IT1234567890',
      BUTTON: 'Hilfe'
    },
    CART_POPUP: {
      CLOSE: 'Schließen',
      PIECES: 'Stücke',
      PRODUCTS: 'Produkte',
      RE_ORDER_CARTS: 'BESTELLEN',
      PRE_ORDER_CARTS: 'VORBESTELLEN',
      SELECTED_CURRENT: 'Der ausgewählte warenkorb ist der, zu dem sie die waren hinzufügen',
      SELECTED: 'Ausgewählt',
      NAVIGATE: 'Zum warenkorb gehen',
      WHOLESALE_PRICE: 'Großhandelspreis',
      CREATED: 'Erstellt',
      DELIVERY_DATES: 'Lieferung am',
      CONTROLLERS: {
        DELETE: 'Warenkorb löschen',
        CREATE: 'Neuen warenkorb erstellen',
        GO_TO_CHECKOUT: 'Zur kasse gehen',
        NO_CARTS: 'Kein warenkorb, erstellen sie einen.'
      }
    },
    FILTERS: {
      STRATEGIC: 'Strategic',
      PROMO: 'Im angebot',
      CUSTOMIZABLE: 'Anpassbar',
      AVAILABLE_NOW: 'Jetzt verfügbar',
      GENDER: 'Geschlecht',
      SIZE_GROUP: 'Größengruppe',
      STYLE_GROUP: 'Stilgruppe',
      Collections: 'Kollektionen',
      COLORS: 'Farbe',
      CATEGORY: 'Kategorie',
      PURPOSE: 'Zweck',
      ASSORTMENTS: 'Sortiment',
      TEAM: 'Team',
      SEASON: 'Saison',
      AVAILABILITY: 'Verfügbarkeit',
      WHOLESALE_PRICE: 'Großhandelspreis',
      SUGGESTED_RETAIL_PRICE: 'Vorgeschlagener verkaufspreis',
      NO_DATA: 'Keine daten',
      TAGS: 'Tags',
      APPLAY_FILTERS: 'Filter anwenden',
      CLEAR_ALL: 'Alle löschen',
    },
    SIZE_GROUPS: {
      ADULT: 'Erwachsener',
      YOUTH: 'Jugendlicher',
      KID: 'Kind',
      INFANT: 'Säugling'
    },
    SIZES_TABS: {
      LIMIT: 'Grenze',
      COLOR: 'Farbe',
      PRICE: 'Preis',
      DOT_MENU: {
        COPY: 'Kopieren',
        PASTE: 'Einfügen',
        CLEAR_ALL: 'Alle löschen',
        REMOVE_ALL: 'Alle entfernen'
      },
      ADD: 'Hinzufügen',
      TOT_PCS: 'Gesamt stücke',
      MAX_QTY_REACHED: 'Maximale menge erreicht',
      QTY_NOT_AVAILABLE: 'Menge nicht verfügbar'
    },
    BREADCRUMBS: {
      HOME: 'Startseite',
      RE_ORDER: 'Wiederbestellen',
      PRE_ORDER: 'Vorbestellen',
      CATALOG: 'Katalog',
    },
    HOME: {
      SHOP: {
        CATALOG: 'Katalog',
        BROWSE: 'Durchstöbern nach',
      },
      CATEGORIES: {
        TITLE: 'Kategorien',
        TEXT: 'Entdecke die produkte jeder kategorie\n und bestelle in wenigen klicks',
        BUTTON: 'Alle produkte entdecken'
      },
      VIDEO: {
        TITLE: 'Was gibt es Neues?',
        TEXT: 'Entdecke, was diese saison neu ist. Stoffe, modelle, farben und vieles mehr.'
      },
      COLLECTIONS: {
        TITLE: 'Kollektionen',
        TEXT: 'Entdecke die produkte in unseren assortimenten, die wir für dich zusammengestellt haben.'
      },
      PRODUCTS: {
        TITLE: 'Die schlüsselprodukte',
        TEXT: 'Entdecke die must-haves der nächsten saison',
        BUTTON: 'Jetzt entdecken',
        ADD_TO_CART: 'In den warenkorb legen'
      },
      PROMOTIONS: {
        TITLE: 'Aktionen',
        EXPLORE: 'Entdecke alle aktionen',
      },
      SHOWCASE: {
        ALL: 'Alle',
        EXPLORE: 'Durchstöbere den {{name}}-katalog',
        SHOP_NOW: 'Jetzt einkaufen',
        DISCOVER_MORE: 'Entdecke alle produkte für {{name}}',
      }
    },
    PRODUCTS: {
      LIST: {
        FILTERS: 'Filter',
        ACTIVE_FILTERS: 'Aktive filter',
        BROWSE_BY: 'Durchsuchen nach',
        ITEMS: 'Artikel',
        ORDER_BY: 'Sortieren nach',
        NO_PRODUCTS: 'Keine artikel',
        NO_ASSORTMENTS: 'Kein sortiment',
        VIEW: 'Ansicht',
        GRID: 'Gitter',
        LIST: 'Liste'
      },
      DETAIL: {
        ERROR_VARIANTS_ALREADY_PRESENT: 'Die folgenden varianten sind bereits im warenkorb mit einem anderen lieferdatum als dem ausgewählten ({{date}}):',
        STYLE_COLOR_QUANTITY_LIMIT_EXCEEDED: 'Du überschreitest das mengenlimit für style-farbe',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Du versuchst, einen oder mehrere artikel hinzuzufügen, die das mindestbestelllimit nicht erfüllen',
        PROMO: {
          ORDER: 'Bestellen',
          MORE_OF: 'Weitere artikel, um den',
          MORE_MORE_OF: 'Weitere artikel, um den',
          MORE_OF_VALUE: '€ Mehr an artikel, um den',
          DISCOUNT: 'Rabatt',
          QUANTITY: 'Menge',
          PRICE: 'Preis',
          VIEW_PROMO: 'Promo entdecken',
          TITLE: 'Promotionen',
          PROMOTION_NAME: 'Name',
          RANGE: 'Gültigkeitsbereich',
          TYPE: 'Promo-Typ',
          VALIDITY_PERIOD: 'Gültigkeitszeitraum',
          ITEM_IN_YOUR_CART: 'Produkte in deinem warenkorb',
          VALUE_IN_YOUR_CART: 'Wert in deinem warenkorb',
          INFO_ALLERT: 'Achtung! Promotionen werden nicht auf varianten angewendet, die einen kanalrabatt haben',
        },
        INFO: {
          SHOP_SELLING_PERIOD: 'Im geschäft von/bis',
          PRICE_LIST: 'Preisliste'
        },
        ADDITIONAL: {
          PRODUCT_DESCRIPTION: 'Beschreibung',
          PRODUCT_INFO: 'Produktinfo',
          PURPOSE: 'Purpose',
          DESCRIPTION: 'Modell-ID',
          SEASON: 'Saison',
          GENDER: 'Geschlecht',
        },
        CS: {
          TITLE: 'Größen und farben',
          DELIVERY_DATE: 'Lieferdatum',
          PLACEHOLDER: 'Farbe suchen'
        },
        CONTROLLERS: {
          CLEAR_ALL: 'Mengen löschen',
          ADD_ALL: 'Alles hinzufügen',
          COMPRESS: 'Komprimieren',
          EXPAND: 'Erweitern',
        },
        NO_AVAILABLE: {
          TEXT: 'Dieses produkt ist nicht mehr im vorbestellungszeitraum verfügbar. Verwenden sie den nachbestellkatalog.',
          BUTTON: {
            PRE_ORDER: 'Vorbestellung kaufen',
            RE_ORDER: 'Nachbestellung kaufen'
          }
        },
        SAME: 'Artikel im gleichen sortiment',
        SIMILAR: 'Ähnliche artikel',
        NO_VARIANTS_PUBLISHED: 'KEINE VARIANTE FÜR DIE AKTUELLE GRÖSSENKATEGORIE FÜR DAS AUSGEWÄHLTE DATUM VERÖFFENTLICHT',
        ERROR_QUANTITY: 'Achtung! Angeforderte menge nicht verfügbar. Maximale verfügbare menge eingestellt',
      },
      CARD: {
        WHOLESALE: 'Großhandel',
        RETAIL: 'Einzelhandel',
        AVAILABILITY: 'Stück auf Lager'
      }
    },
    ERRORS: {
      TITLE: 'Fehlermeldung',
      PRODUCT_LOADING: 'Ein fehler ist beim laden des produkts aufgetreten',
      INVALID_ORDER: 'Die bestellung ist ungültig',
      DEFAULT_MESSAGE: 'Etwas ist schief gelaufen. Bitte kontaktieren sie den support, indem sie die schaltfläche "Hilfe" unten rechts verwenden.'
    },
    COLLECTION_CARD: {
      SHOP_ASSORTMENT: 'Entdecken sie das sortiment'
    },
    PROMOTION_CARD: {
      SHOP_PROMO: 'Entdecken sie aktionen'
    },

    VARIANT_GRID: {
      CUSTOMER_DISCOUNT: "Der Kunde, für den du einkaufst, hat einen Rabatt von",
      USE_ACTION: "Aktion verwenden",
      USING_PERC: "direkt mit dem Rabatt von",
      CLEAR_QUANTITY: 'Menge löschen',
      ADD_ALL: 'Alles hinzufügen',
      ADD: 'Hinzufügen',
      PRE_COMPILE_WITH_AVAILABLE_QTY: 'Vorab mit verfügbaren mengen ausfüllen',
      COPY: 'Werte der eingabefelder kopieren',
      PASTE: 'Kopierte werte einfügen',
      COPIED: 'Werte kopiert!',
      PASTED: 'Werte eingefügt!',
      ADD_AVAILABLE_QUANTITY: 'Verfügbare menge hinzufügen',
      QTY_AVAILABLE: 'Verfügbare menge',
      QTY_IN_CART: 'Menge im warenkorb',
      THERE_ARE_NO_AVAILABLE_QUANTITIES_TO_ADD: 'Es gibt keine verfügbaren mengen zum hinzufügen',
      MAX_QTY_REACHED: 'Maximale menge erreicht',
      QTY_NOT_AVAILABLE: 'Menge nicht verfügbar',
      QTY_NOT_AVAILABLE_BY_CLICKING_SAVE_THE_VARIANT_WILL_BE_REMOVED: 'Menge nicht verfügbar. Wenn sie auf "Speichern" klicken, wird die variante entfernt',
      LIMIT_EXCEEDED_FOR_PALETTE: 'Limit überschritten für die Farbe: {{paletteCode}}',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART: 'Die mengen der farbe <b>{{colorCode}}</b> wurden vorab ausgefüllt. Klicken sie auf "Hinzufügen", um sie Ihrem warenkorb hinzuzufügen',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART_ALL: 'Die verfügbaren Mengen wurden vorab ausgefüllt. Klicken sie auf "Alles hinzufügen", um sie Ihrem warenkorb hinzuzufügen',
      INPUTS_RESET_TO_ZERO: 'Eingabefelder auf 0 zurückgesetzt.',
      ITEMS_ADDED_TO_CART: '<b>{{sumQtyAdded}}</b> Artikel wurden dem warenkorb hinzugefügt.',
      NO_QUANTITIES_TO_ADD: 'Es gibt keine mengen hinzuzufügen.',
      RESET_QUANTITIES_INPUTS: 'Mengeingabefelder zurücksetzen',
      NO_COLORS_FOUND: 'Keine farben gefunden',
      NO_AVAILABLE_DATES: 'Keine verfügbaren lieferdaten',
      CHOOSE_DELIVERY_DATE: 'Lieferdatum',
      DATES: '({{numberDate}} verfügbar)',
      SUGG_RETAIL: 'Vorgeschlagener einzelhandelspreis',
      MAX: 'Max',
      SUGG: 'Vorgeschlagen',
      PROMOTION_TABLE: 'Aktionen anzeigen',
      PRICE_TABLE: 'Preise anzeigen',
      PRICE_TABLE_TITLE: 'Preistabelle',
      PROMOTION_TABLE_TITLE: 'Aktionstabelle',
      BY_VALUE: 'Nach gekauftem Wert',
      BY_QUANTITY: 'Nach gekaufter Menge',
      ADD_ITEMS_WITH_CUSTOM_OPTIONS: 'Artikel mit benutzerdefinierten optionen hinzufügen',
      BY_COLORS: 'Nach farben',
      BY_VARIANTS: 'Nach varianten',
      QUANTITY: 'Menge',
    },

    MODAL_ATTENTION_CHANGE_ORDER_QTY: {
      LOSE_CUSTOM_DELIVERY_DATES: 'Wenn du die mengen änderst, verlierst du die festgelegten benutzerdefinierten liefertermine! Denk daran, sie beim bestellabschluss neu festzulegen!',
      ARE_YOU_SURE: 'Bist du sicher?',
      CONFIRM: 'Bestätigen',
    },


    PROMOTION_STEPS: {
      ITEMS_IN_THE_CART: 'Artikel im warenkorb {{products}}',
      PROMOTION_DISCOUNT: 'Rabatt promotion {{discount}}%',
      ADD_PCS_FOR_REACH_PROMO_DISCOUNT: 'Füge {{pcs}} Stück hinzu, um den promotion-rabatt zu erreichen',
      CART_VALUE: 'Warenkorbwert {{value}}',
      ADD_VALUE_FOR_REACH_PROMO_DISCOUNT: 'Füge {{value}} hinzu, um den promotion-rabatt zu erreichen',
      PROMOTION: 'Promotion',
    },
    BULK_OPERATIONS: {
      STATUS: {
        AWAITINGPROCESSING: 'Wartet auf bearbeitung',
        PROCESSING: 'In bearbeitung',
        PROCESSEDWITHOUTISSUES: 'Bearbeitet',
        PROCESSEDWITHISSUES: 'Bearbeitet mit Problemen',
        PROCESSINGFAILURE: 'Verarbeitungsfehler',
      },
      TYPES: {
        ADDNEWITEMS: 'Neue Artikel hinzufügen',
        REMOVEITEMS: 'Artikel entfernen',
        REPLACEITEMS: 'Artikel ersetzen',
        EDITQUANTITY: 'Menge ändern',
        CHANGEITEMSDELIVERYDATE: 'Lieferdatum ändern',
        EDITWHOLESALEPRICE: 'Nettopreis ändern',
        CHANGERETAILPRICE: 'Einzelhandelspreis ändern',
        UPDATEERPSERVICEITEMS: 'Zusatzkosten aktualisiert',
        CHANGECUSTOMERANDSHIPPINGADDRESS: 'Kunde und Verkaufsstelle ändern',
        CANCELORDER: 'Bestellungen stornieren',
        UPDATEFROMTEMPLATE: 'Aus Vorlage aktualisieren',
        UPDATEORDERHEADER: 'Bestellungshheader aktualisieren',
      },
      SCOPES: {
        SINGLEORDER: 'Einzelbestellung',
        MULTIPLEORDERS: 'Mehrere Bestellungen',
      },
      MODAL: {
        TITLE: 'Details zur Operation',
        TAB1_TITLE: 'ERP-Log',
        TAB2_TITLE: 'Issues',
      },
      BACK_TO_BULK_OPERATIONS: 'Vorgänge',
      PROCESSED_ORDER_ITEMS_COUNT: 'Verarbeitete Artikel',
      PROCESSED_WITH_ISSUES_COUNT: 'Probleme',
      PENDING_OPERATIONS: 'Vorgänge in Warteschlange',
      LOADING_OPERATIONS: 'Vorgänge werden geladen...',
      NO_PENDING_OPERATIONS: 'Keine Vorgänge in Warteschlange',
      NO_PENDING_OPERATIONS_DESC: 'Alle Vorgänge für diese Bestellung wurden verarbeitet.',
      TOTAL_OPERATIONS: 'Total {{count}} Vorgänge in Warteschlange',
      VIEW_DETAILS: 'Details anzeigen',
      VIEW_PENDING_OPERATIONS: 'Vorgänge in Warteschlange anzeigen',
      CREATED_BY: 'Erstellt von',
      AFFECTED_ITEMS: 'Betroffene Artikel',
      ADD_NEW_ITEMS: 'Neue Artikel hinzufügen',
      REMOVE_ITEMS: 'Artikel entfernen',
      REPLACE_ITEMS: 'Artikel ersetzen',
      CHANGE_QUANTITY: 'Menge ändern',
      CHANGE_DELIVERY_DATE: 'Lieferdatum ändern',
      CHANGE_WHOLESALE_PRICE: 'Nettopreis ändern',
      CHANGE_RETAIL_PRICE: 'Einzelhandelspreis ändern',
      UPDATE_SERVICE_ITEMS: 'Zusatzkosten aktualisiert',
      CHANGE_CUSTOMER_AND_POS: 'Kunde und Verkaufsstelle ändern',
      CANCEL_ORDERS: 'Bestellungen stornieren',
      UPDATEFROMTEMPLATE: 'Bestellung aus Excel aktualisieren',
      UPDATE_ORDER_HEADER: 'Bestellkopf aktualisieren',
      SINGLE_ORDER: 'Einzelbestellung',
      MULTIPLE_ORDERS: 'Mehrere Bestellungen',
      PRODUCT: 'SKU Code-EAN',
      DELIVERY_DATE: 'Lieferdatum',
      UNKNOWN: 'Unbekannt',
      UPDATE_FROM_TEMPLATE: 'Aus Vorlage aktualisieren',
      UNKNOWN_SCOPE: 'Unbekanntes Scope',
      ITEMS_TO_ADD: 'Artikel hinzufügen',
      ITEMS_TO_REMOVE: 'Artikel entfernen',
      ITEMS_TO_REPLACE: 'Artikel ersetzen',
      QUANTITY_CHANGES: 'Mengenänderungen',
      DELIVERY_DATE_CHANGES: 'Lieferdatumänderungen',
      PRICE_CHANGES: 'Preisänderungen',
      CUSTOMER_AND_POS_CHANGES: 'Kunden- und Verkaufsstellenänderungen',
      CUSTOMER: 'Kunde',
      POINT_OF_SALE: 'Verkaufsstelle',
      ORDER_CANCELLATION: 'Bestellung stornieren',
      OLD_PRODUCT: 'Alter SKU Code-EAN',
      NEW_PRODUCT: 'Neuer SKU Code-EAN',
      NEW_PRICE: 'Neuer Preis',
      OLD_QUANTITY: 'Alter Menge',
      NEW_QUANTITY: 'Neue Menge',
      OLD_DATE: 'Alter Lieferdatum',
      NEW_DATE: 'Neues Lieferdatum',
      OLD_PRICE: 'Alter Preis',
      FROM: 'Von',
      TO: 'Bis',
      CANCELLATION_REASON_ID: 'Stornierungsgrund-ID',
      QUANTITY: 'Menge',
      DELIVERY: 'Lieferung',
      REASON: 'Grund',
      PRICE: 'Preis',
      TYPE: 'Vorgangstyp',
    },
    REPORTS: {
      STORE_VARIANTS: 'Produktvarianten',
      STORE_ORDERS: 'Produktbestellungen',
      STORE_ORDERS_ITEMS: 'Produktbestellungspositionen',
    },
  },
};
